import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useStore, useSelector, batch } from "react-redux";

import {
  Tabs,
  InputNumber,
  Modal,
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  message,
  Form,
  Select,
  Tooltip,
  Checkbox,
  Spin,
  Alert,
  AutoComplete,
  Switch,
  Upload,
  Radio,
  Avatar,
  DatePicker,
} from "antd";
import CKEditor from "react-ckeditor-component";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import {
  ArrowLeftOutlined,
  FireFilled,
  InboxOutlined,
  PlusOutlined,
  PlusCircleFilled,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Placeholder from "../../../assets/images/placeholder.svg";
import { InputGroup } from "reactstrap";
import ProductImg from "../../../assets/images/product-details.png";
import { Typography } from "antd";
import { FormattedRelativeTime } from "react-intl";
import { setCommonConfigs } from "../../../appRedux/actions/CommonData";
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  StringIsNullOrEmpty,
  removeSpacewithLowerCaseString,
} from "../../../appRedux/actions/GlobalMethods";
import { PRODUCT_SCREEN } from "../../../constants/Pages";
import { userLogOut } from "../../../appRedux/actions/Auth";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { loadIsTaxExclusive } from "../../../appRedux/actions/MainSale";
import { forEach, remove } from "lodash";
import { parse } from "path";
import moment from "moment";
// import { REACT_APP_BUS_FIRST_NAME } from "../../../constants/StoreSetting";
import { saveProductsToIndexedDB } from "../../../appRedux/actions";
import ProductSearch from "../../../components/ProductSearch";
import { TableName } from "../../../constants/TableName";
import { env } from '../../../env'
import NotAllowedComponent from "../../../components/NotAllowedComponent";

const { REACT_APP_BUS_FIRST_NAME } = env
const { Title } = Typography;
const Panel = Collapse.Panel;
const { Footer } = Layout;
const Dragger = Upload.Dragger;
const RadioGroup = Radio.Group;
const TabPane = Tabs.TabPane;
const confirm = Modal.confirm;

const options = [
  { label: "Automatically Generate a SKU", value: "Apple" },
  { label: "Enter a custom SKU", value: "Pear" },
];
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      //offset: 0,
    },
    sm: {
      span: 16,
      //offset: 0,
    },
    md: {
      span: 24,
      //  offset: 0,
    },
  },
};
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};
const dateFormat = "YYYY-MM-DD";
let variantIndex = 0;
const Products = ({ match }) => {
  let index = 0;

  const store = useStore();
  const dispatch = useDispatch();
  const history = useHistory();
  const isDuplicate = window.location.href.indexOf("/duplicate/") > -1 ? true : false;
  const urlProductID = match.params.id;
  const isAddMode = !urlProductID;
  let productID = isAddMode
    ? "0&&_bd98-6131-47dd-8ac8-4bd1856d2a60"
    : urlProductID;
  const methodType = isAddMode || isDuplicate ? BEHAVIOUR_TYPE.POST : BEHAVIOUR_TYPE.UPDATE;
  const productNameRef = useRef("");

  //States Start
  const [productInventoryType, setProductInventoryType] = useState("0");
  const [AttributeItems, setAttributeItems] = useState([]);
  const [NewAttributeItem, setNewAttributeItem] = useState({});
  const [InvSKURadioButton, setInvSKURadioButton] = useState(1);
  const [PLoyaltyRadioButton, setPLoyaltyRadioButton] = useState(1);
  const [isLoading, SetisLoading] = React.useState({ isLoading: true });
  const [isRegistering, SetisRegistering] = React.useState({
    isRegistering: false,
  });
  const [countriesObject, setcountriesObject] = React.useState([
    { id: 1, label: "" },
  ]);
  const [storeOutletsOptions, setStoreOutletsOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [brandOptions, setBrandOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [productTagOptions, setProductTagOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [productTypeOptions, setProductTypeOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [supplierOptions, setSupplierOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [saleTaxOptions, setSaleTaxOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [variantAttributeOptions, setVariantAttributeOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [tableDataStoreOutlets, setTableDataStoreOutlets] = useState();
  //const [tableDataOutletTax, setTableDataOutletTax] = useState();
  const [storeOutletCount, setStoreOutletCount] = useState(4);
  const [descriptionContent, setDescriptionContent] = useState("");
  const [isSellOnPOS, setIsSellOnPOS] = useState(true);
  const [options, setOptions] = useState([]);
  const [getSearchProd, setSearchProd] = useState([]);
  const [getTableCompositeProductData, setTableCompositeProductData] =
    React.useState([]);
  const [getCPTotal, setCPTotal] = React.useState([
    { CPTotalQuantity: 0, CPTotalSupplyPrice: 0 },
  ]);
  const [getCPTotalQuantity, setCPTotalQuantity] = useState(0);
  const [getCPTotalSupplyPrice, setCPTotalSupplyPrice] = useState(0);
  const [attributeOptionCount, setAttributeOptionCount] = useState(1);
  const [attributeOptionsRows, setAttributeOptionsRows] = useState([
    { Key: 0, value: 0 },
  ]);

  const [TableProductVariantdata, setTableProductVariantdata] = useState([]); //Main table
  const [tableDataVariantStoreOutlets, setTableDataVariantStoreOutlets] =
    useState(); //Sub Table
  //const [TableProductVariantdataSecondary, setTableProductVariantdataSecondary] = useState([]);
  const [getRemovableVariantCombinations, setRemovableVariantCombinations] =
    useState([]);
  const [productInventoryTypeInEdit, setProductInventoryTypeInEdit] =
    useState();
  const [fileList, setfileList] = useState([]);

  const [getVariantImages, setVariantImages] = useState([]);

  const [PreviewVisible, setPreviewVisible] = useState(false);
  const [PreviewImage, setPreviewImage] = useState("");
  const [PreviewTitle, setPreviewTitle] = useState("");
  const attributeOptions = [];
  const [getCurrData, setCurrData] = useState({
    currencyCode: "",
    currencyName: "",
    currencySymbol: "",
  });
  const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2); //api me isko db sy update rakhna hy
  const [getIsMountedOne, setIsMountedOne] = React.useState(true);
  const [getDeletedImages, setDeletedImages] = React.useState([]);
  const [getSKUCodeTypeOptions, setSKUCodeTypeOptions] = React.useState([]);
  const [getSKUTypeOptionsRows, setSKUTypeOptionsRows] = React.useState([
    {
      Key: 0,
      SKUID: 0,
      SKUTypeID: 1,
      SKUValue: "",
      IsUnique: true,
      RecordID: "0",
      IsRemove: false,
    },
  ]);
  const [getProductBatchesOptionsRows, setProductBatchesOptionsRows] =
    React.useState([
      // {
      //   Key: 0,
      //   BatchID: 0,
      //   BatchCode: "",
      //   BatchQuantity: 0,
      //   BatchExpiryDate: moment(),
      //   RecordID: "0",
      //   OutletID: "",
      //   BatchManufacturingDate: moment(),
      //   IsRemove: false,
      //   IsUnique: true,
      // },
    ]);
  const [getAutoGenerateSKUs, setAutoGenerateSKUs] = React.useState([]);
  const [getIsAutoSKUCodeLoader, setIsAutoSKUCodeLoader] =
    React.useState(false);
  const [getVariantSKURows, setVariantSKURows] = React.useState([]);
  const [getVariantBatchesRows, setVariantBatchesRows] = React.useState([]);
  const [getIsDisableCreate, setIsDisableCreate] = useState(true);
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true);
  const [getIsDisableDelete, setIsDisableDelete] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);
  const [getDefaultOutletTaxes, setDefaultOutletTaxes] = useState([]);
  const [getDisplayPriceWithName, setDisplayPriceWithName] = useState({
    taxID: "",
    taxName: "",
    taxPrice: 0,
  });
  // const [getIsTaxExclusive, setIsTaxExclusive] = React.useState(false);
  const [getTaxID, setTaxID] = React.useState("");
  const [getIsProductInventory, setIsProductInventory] = React.useState(true);
  const [getDefaultTaxObj, setDefaultTaxObj] = React.useState({});
  const [getRetailPricePreviousValue, setRetailPricePreviousValue] =
    React.useState("");
  const [RemoveVariantCombinations, setRemoveVariantCombinations] =
    React.useState([]);
  const [getLoyaltyPoints, setLoyaltyPoints] = React.useState(0);
  const [getDefaultLoyaltyData, setDefaulLoyaltyData] = React.useState({});
  const [getLoyaltyAmountValue, setLoyaltyAmountValue] = React.useState("0");
  const [getSalesGroupTaxes, setSalesGroupTaxes] = useState([]);
  const [getProductName, setProductName] = useState("");
  const [errorMessages, setErrorMessages] = useState([]);

  //States End

  //#region  for use Selector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  );
  const defaultSalesTaxID = useSelector(
    ({ MainSale }) => MainSale.defaultSalesTaxID
  );
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  );

  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  );
  const getReduxDefaultSKUGeneration = useSelector(
    ({ Setup }) => Setup.defaultSKUGeneration
  );
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  );

  // const getLoyaltyAmountValue = useSelector(
  //   ({ MainSale }) => MainSale.getLoyaltyAmountValue
  // );
  //#endregion use Selector Region

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const commonData = getReduxCommonSetting;
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData);
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData);
          setAccessLoading(false);
        } else {
          toInitialState();
          setAccessLoading(false);
        }
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);

  React.useEffect(() => {
    setVariantAttributeOptions(["A", "B", "C"]);
    setNewAttributeItem("");
    getProductsData();
  }, [defaultSalesTaxID]);

  React.useEffect(() => {
    let mounted = true;

    if (mounted) {
      dispatch(setCommonConfigs(PRODUCT_SCREEN));
    }
    return () => {
      mounted = false;
      setIsMountedOne(false);
    };
  }, []);

  React.useEffect(() => {
    if (isAddMode) {
      let bodySKu = {
        ProductName: [""],
      };
      getAutoGeneratedSKU(bodySKu);
    }
  }, []);
  React.useEffect(() => {
    let skuData = getAutoGenerateSKUs;
    if (skuData) {
      if (productInventoryType == "0") {
        // form.setFieldsValue({
        //   SKUCodeTypeValue0:
        //     getAutoGenerateSKUs[0] != undefined ? getAutoGenerateSKUs[0] : "",
        // });
        let SKUTypeOptionRows = getSKUTypeOptionsRows;
        let tempObj = SKUTypeOptionRows.filter((e) => e.Key === 0)[0];
        tempObj.SKUID = skuData[0] != undefined ? skuData[0].skuid : "";
        tempObj.SKUValue = skuData[0] != undefined ? skuData[0].skuValue : "";
        setSKUTypeOptionsRows(SKUTypeOptionRows);
      }
    }
  }, [getAutoGenerateSKUs]);
  React.useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct);
      }
    }

    return () => (mounted = false);
  }, [getSearchSelectedProduct]);

  // React.useEffect(() => form.resetFields(), [getProductBatchesOptionsRows]);
  // React.useEffect(() => {

  //   if (getLoyaltyAmountValue) {
  //     const loyaltyPoints = form.getFieldValue("RetailPrice")  ?
  //       parseFloat(form.getFieldValue("RetailPrice")) /
  //       parseFloat(getLoyaltyAmountValue) : 0;
  //     setLoyaltyPoints(loyaltyPoints);
  //   }
  // }, [getLoyaltyAmountValue]);

  //Funtions Start

  function setupRightsPermissions(rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights);
    } else {
      setRights([]);
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions);
    } else {
      setPermissions([]);
    }
    if (rpData.read) {
      setIsAllowRead(true);
    } else {
      setIsAllowRead(false);
    }
    if (rpData.create) {
      setIsDisableCreate(false);
    } else {
      setIsDisableCreate(true);
    }
    if (rpData.update) {
      setIsDisableUpdate(false);
    } else {
      setIsDisableUpdate(true);
    }
    if (rpData.delete) {
      setIsDisableDelete(false);
    } else {
      setIsDisableDelete(true);
    }
  }

  function toInitialState() {
    setRights([]);
    setPermissions([]);
    setIsAllowRead(false);
    setIsDisableCreate(true);
    setIsDisableUpdate(true);
    setIsDisableDelete(true);
    setAccessLoading(true);
  }

  function getRandomInt(max, min = 0) {
    return Math.floor(Math.random() * (max - min + 1)) + min; // eslint-disable-line no-mixed-operators
  }
  function getDecryptID(id) {
    return id ? id.substring(0, id.indexOf("&")) : "";
  }
  async function getProductsData() {
    let productDataresponse = [];
    let loyaltyAmountValue = "0";
    const getProductData = ds.getProductsData("", BEHAVIOUR_TYPE.GET);
    await getProductData
      .then((response) => {
        setStoreOutletsOptions(response.data.data.storeOutletsOptions);
        if (response.data.data.storeOutletsOptions != null) {
          let mapped = response.data.data.storeOutletsOptions.map(
            (storeOutlet) => {
              return {
                key: getRandomInt(100000000),
                OutletID: storeOutlet.id,
                OutletName: storeOutlet.label,
                CurrentInventory: "0",
                ReOrderPoint: "0",
                ReOrderQuantity: "0",
                Tax: "0",
              };
            }
          );

          mapped.sort((a, b) => (a.name > b.name ? 1 : -1));
          setTableDataStoreOutlets(mapped);
          //////;
          let variantOuteltsArray = [];
          variantOuteltsArray.push(mapped);
          setTableDataVariantStoreOutlets(variantOuteltsArray);
          setStoreOutletCount(mapped != null ? mapped.length : 1);
        }
        setBrandOptions(response.data.data.brandsOptions);
        setProductTagOptions(response.data.data.productTagsOptions);
        setProductTypeOptions(response.data.data.productTypesOptions);
        setSupplierOptions(response.data.data.suppliersOptions);
        setSaleTaxOptions(response.data.data.salesTaxesOptions);
        setVariantAttributeOptions(response.data.data.variantAttributesOptions);
        setSKUCodeTypeOptions(response.data.data.skuCodeTypesOptions);
        setDefaultOutletTaxes(response.data.data.defaultOutletTaxes);
        setDefaulLoyaltyData(response.data.data.defaultLoyalty);
        setSalesGroupTaxes(response.data.data.salesGroupTaxes);
        if (response.data.data.defaultLoyalty) {
          loyaltyAmountValue = response.data.data.defaultLoyalty
            .loyaltyAmountValue
            ? response.data.data.defaultLoyalty.loyaltyAmountValue.toString()
            : "0";
          setLoyaltyAmountValue(loyaltyAmountValue);
        }
        productDataresponse = response.data.data;
        if (isAddMode) {
          // let bodySKu = {
          //   ProductName: [""],
          // };
          // getAutoGeneratedSKU(bodySKu);
          setTaxID("0");
          form.setFieldsValue({ TaxID: "0" });
          if (!getIsTaxExclusive) {
            let salesTaxObj =
              defaultSalesTaxID != ""
                ? response.data.data.salesTaxesOptions.filter(
                    (x) => x.id == defaultSalesTaxID
                  )[0]
                : salesTaxObj[0];

            setDefaultTaxObj(salesTaxObj);

            let displayPriceObj = {
              taxID: salesTaxObj.id,
              taxName: salesTaxObj.label,
              taxPrice: parseFloat("0").toFixed(getDefaultDecimalPlaces),
            };
            setDisplayPriceWithName(displayPriceObj);
          }
        }

        // let taxDefaultObj = response.data.data.defaultOutletTaxes[0];
      })
      .then(() => {
        if (!isAddMode) {
          ds.getProductCommonDetailByProductID(
            { productID: productID },
            BEHAVIOUR_TYPE.GET
          ).then((res) => {
            if (res.data.msgCode == "GENERAL_SUCCESS") {
              if (res.data.data.productDetails != null) {
                let productCommonData = res.data.data.productDetails;
                form.setFieldsValue({ Name: productCommonData.productName });
                //productNameRef.current = productCommonData.productName;
                setProductName(productCommonData.productName);
                form.setFieldsValue({
                  BrandID:
                    productCommonData.brandID != 0
                      ? productCommonData.brandID
                      : "",
                });
                setDescriptionContent(productCommonData.description);
                //EditSalis
                let productTagObj =
                  productCommonData.productTags &&
                  productCommonData.productTags.length &&
                  productCommonData.productTags.map((e) => {
                    return e.key;
                  });
                // ;
                if (productTagObj != 0) {
                  form.setFieldsValue({ ProductTags: productTagObj });
                }
                if (productCommonData.productType != 0) {
                  form.setFieldsValue({
                    ProductType: productCommonData.productType,
                  });
                }

                setIsSellOnPOS(productCommonData.isActiveProduct);
                //;

                let productSKUObj =
                  productCommonData.productSKUs &&
                  productCommonData.productSKUs.length &&
                  productCommonData.productSKUs.map((e, index) => {
                    return {
                      Key: index,
                      SKUID: e.skuid,
                      SKUTypeID: parseInt(getDecryptID(e.skuTypeID)),
                      SKUValue: e.skuValue,
                      IsUnique: true,
                      RecordID: e.recordID,
                      IsRemove: false,
                    };
                  });

                setSKUTypeOptionsRows(productSKUObj);

                let productBatchesObj =
                  productCommonData.productBatchesDetails &&
                  productCommonData.productBatchesDetails.length &&
                  productCommonData.productBatchesDetails.map((e, index) => {
                    form.setFieldsValue({
                      [`BatchID${index}`]: parseInt(getDecryptID(e.batchID)),
                      [`BatchCode${index}`]: e.batchCode,
                      [`BatchQuantity${index}`]: e.batchQuantity,
                      [`BatchExpiryDate${index}`]: e.batchExpiryDate,
                      [`OutletID${index}`]: e.outletID,
                      [`BatchManufacturingDate${index}`]:
                        e.batchManufacturingDate,
                    });

                    return {
                      Key: index,
                      BatchID: parseInt(getDecryptID(e.batchID)),
                      BatchCode: e.batchCode,
                      BatchQuantity: e.batchQuantity,
                      BatchExpiryDate: e.batchExpiryDate,
                      RecordID: e.recordid,
                      IsRemove: false,
                      IsUnique: true,
                      OutletID: e.outletID,
                      BatchManufacturingDate: e.batchManufacturingDate,
                    };
                  });

                setProductBatchesOptionsRows(
                  productBatchesObj ? productBatchesObj : []
                );

                if (productCommonData.productImages[0].id != 0) {
                  let fileList = productCommonData.productImages.map((obj) => {
                    return {
                      uid: obj.id,
                      // url: obj.imageURL.replace(
                      //   "https://data.dakarpos.com/",
                      //   "http://localhost:13000/"
                      // ),
                      url: obj.imageURL,
                      status: "done",
                    };
                  });
                  setfileList(fileList);
                } else {
                  setfileList([]);
                }

                if (productCommonData.isCustomSKU) {
                  setInvSKURadioButton(2);
                  form.setFieldsValue({
                    CustomSKU: productCommonData.customSKUCode,
                  });
                } else {
                  setInvSKURadioButton(1);
                }
                if (productCommonData.supplierID != 0) {
                  form.setFieldsValue({
                    SupplierID: productCommonData.supplierID,
                  });
                }

                form.setFieldsValue({
                  SupplierCode: productCommonData.supplierCode,
                });
                form.setFieldsValue({
                  SupplyPrice: productCommonData.supplyPrice,
                });

                // form.setFieldsValue({
                //   ExpireDate: moment(productCommonData.expiryDate),
                // });
                let supplyPricetemp = productCommonData.supplyPrice
                  ? parseFloat(productCommonData.supplyPrice).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : "0.00";
                setCPTotalSupplyPrice(supplyPricetemp);
                form.setFieldsValue({
                  ["SupplyPriceTotal"]: supplyPricetemp,
                });
                // form.setFieldsValue({
                //   IsProductInventory: productCommonData.isProductInventory,
                // });
                const isTrackInventory = productCommonData.isProductInventory;
                setIsProductInventory(isTrackInventory);
                const retailP = productCommonData.retailPrice;
                form.setFieldsValue({
                  RetailPrice: retailP,
                });

                const loyaltyPoints =
                  getIsLoyaltyEnabled &&
                  loyaltyAmountValue &&
                  loyaltyAmountValue != "0"
                    ? parseFloat(retailP) / parseFloat(loyaltyAmountValue)
                    : 0;
                setLoyaltyPoints(loyaltyPoints);

                if (productCommonData.isCustomLoyalty) {
                  setPLoyaltyRadioButton(2);
                  form.setFieldsValue({
                    CustomLoyalty: productCommonData.loyaltyPrice,
                  });
                } else {
                  //setPLoyaltyRadioButton (2);
                  setPLoyaltyRadioButton(1);
                }
                form.setFieldsValue({
                  Markup: productCommonData.markupInPercentage,
                });

                let mapped = productCommonData.outletInventoriesandTax.map(
                  (storeOutlet) => {
                    // let currentInventory =  isTrackInventory ? storeOutlet.currentInventory : "0";
                    return {
                      key: getRandomInt(100000000),
                      OutletID: storeOutlet.outletID,
                      OutletName: storeOutlet.outletName,
                      CurrentInventory: storeOutlet.currentInventory,
                      ReOrderPoint: storeOutlet.reOrderPoint,
                      ReOrderQuantity: storeOutlet.reOrderQuantity,
                      Tax: storeOutlet.taxID,
                    };
                  }
                );
                setTaxID(mapped[0].Tax);
                form.setFieldsValue({ TaxID: mapped[0].Tax });
                mapped.sort((a, b) => (a.name > b.name ? 1 : -1));

                setTableDataStoreOutlets(mapped);
                setProductInventoryTypeInEdit(
                  productCommonData.productInventoryType
                );
                let salesTaxObj =
                  defaultSalesTaxID !== ""
                    ? productDataresponse.salesTaxesOptions.filter(
                        (x) => x.id == defaultSalesTaxID
                      )[0]
                    : productDataresponse.salesTaxesOptions[0];

                setDefaultTaxObj(salesTaxObj);
                if (!getIsTaxExclusive) {
                  DisplayPriceCalculator(
                    productDataresponse.salesTaxesOptions,
                    salesTaxObj,
                    productCommonData.retailPrice,
                    mapped[0].Tax,
                    productDataresponse.salesGroupTaxes
                  );
                }

                // ;
                if (
                  productCommonData.productInventoryType == "Standard Product"
                ) {
                  setProductInventoryType("0");
                }
                if (
                  productCommonData.productInventoryType ==
                  "Product with Variants"
                ) {
                  setProductInventoryType("1");
                }
                if (
                  productCommonData.productInventoryType == "Composite Product"
                ) {
                  setProductInventoryType("2");
                }

                if (res.data.msgCode == "GENERAL_SUCCESS") {
                  if (!isAddMode) {
                    if (
                      res.data.data.productDetails.productInventoryType !=
                      "Standard Product"
                    ) {
                      ds.getProductOtherDetailByProductID(
                        {
                          productID: productID,
                          isThumbnailImage: false,
                        },
                        BEHAVIOUR_TYPE.GET
                      ).then((res1) => {
                        SetisLoading(false);
                        if (res1.data.msgCode == "GENERAL_SUCCESS") {
                          if (res1.data.data.productDetails != null) {
                            let productOtherData =
                              res1.data.data.productDetails;

                            if (
                              productOtherData.productInventoryType ==
                              "Composite Product"
                            ) {
                              if (
                                productOtherData.compositeProductsData !=
                                  null &&
                                productOtherData.compositeProductsData.length >
                                  0
                              ) {
                                let compositeData =
                                  productOtherData.compositeProductsData;
                                let newCompositeData = compositeData.map(
                                  (obj) => {
                                    return {
                                      key: getRandomInt(1000000000000000),
                                      ProductID: obj.productID,
                                      Name: obj.productName,
                                      CompositeProductQuantity: obj.quantity,
                                      SupplyPrice: obj.supplyPrice,
                                      IsVariant: obj.isVariant,
                                      VariantName: obj.variantName,
                                    };
                                  }
                                );

                                setTableCompositeProductData(newCompositeData);
                                CalculateCompositeProductTotal(
                                  newCompositeData
                                );
                              }
                            }
                            if (
                              productOtherData.productInventoryType ==
                              "Product with Variants"
                            ) {
                              if (
                                productOtherData.productVariants != null &&
                                productOtherData.productVariants.length > 0 &&
                                productOtherData.variantAttributes != null &&
                                productOtherData.variantAttributes.length > 0
                              ) {
                                // ;
                                let attributeOptionRows =
                                  productOtherData.variantAttributes.map(
                                    (data, index) => {
                                      return {
                                        Key: index,
                                        value: index,
                                      };
                                    }
                                  );
                                // ;
                                setAttributeOptionsRows(attributeOptionRows);

                                // setAttributeOptionsRows(
                                //   attributeOptionRows.filter(function (item) {
                                //     return item.Key != 0;
                                //   })
                                // );
                                let editAttributeValues = [];
                                productOtherData.variantAttributes.map(
                                  (data, index) => {
                                    let attributeOption = `Attributes${index}`;
                                    let attributeOptionValue = `AttributeValues${index}`;
                                    let attributeValueArray =
                                      data &&
                                      data.variantAttributeValues.length &&
                                      data.variantAttributeValues
                                        .split(",")
                                        .map((e) => {
                                          return e;
                                        });
                                    editAttributeValues.push(
                                      attributeValueArray
                                    );
                                    form.setFieldsValue({
                                      [attributeOption]:
                                        data.variantAttributeID,
                                    });
                                    if (attributeValueArray.length != 0) {
                                      form.setFieldsValue({
                                        [attributeOptionValue]:
                                          attributeValueArray,
                                      });
                                    }
                                  }
                                );

                                let variantInventoryTaxData = [];

                                productOtherData.productVariants.forEach(
                                  myFunction
                                );
                                function myFunction(item, index) {
                                  let tempObj = {};
                                  tempObj = item.outletInventoriesandTax.map(
                                    (storeOutlet) => {
                                      // let currentInventory =  isTrackInventory ? storeOutlet.currentInventory : "0";
                                      return {
                                        key: getRandomInt(100000000),
                                        OutletID: storeOutlet.outletID,
                                        OutletName: storeOutlet.outletName,
                                        CurrentInventory:
                                          storeOutlet.currentInventory,
                                        ReOrderPoint: storeOutlet.reOrderPoint,
                                        ReOrderQuantity:
                                          storeOutlet.reOrderQuantity,
                                        Tax: storeOutlet.taxID,
                                      };
                                    }
                                  );
                                  variantInventoryTaxData.push(tempObj);
                                }

                                // mapped.sort((a, b) => (a.name > b.name ? 1 : -1));
                                setTableDataVariantStoreOutlets(
                                  variantInventoryTaxData
                                );

                                //In future we can also hanlde multiple variant images by using this logic, Bs hamen flat(1) remove krk hr index pr set krna hoga
                                //
                                let variantImages = [];
                                productOtherData.productVariants.forEach(
                                  getVariantImages
                                );
                                function getVariantImages(item, index) {
                                  let imageObj = {};
                                  imageObj = item.productImages
                                    .filter((x) =>
                                      x.imageURL.includes("products")
                                    )
                                    .map((obj) => {
                                      return {
                                        uid: obj.id,
                                        variantProductID: obj.productID,
                                        // url: obj.imageURL.replace(
                                        //   "http://data.dakartest.com/",
                                        //   "http://localhost:13000/"
                                        // ),
                                        url: obj.imageURL,
                                        status: "done",
                                      };
                                    });

                                  variantImages.push(imageObj);
                                }
                                console.log(variantImages);
                                variantImages = variantImages.flat(1);
                                setVariantImages(variantImages);

                                let variantSKUs = [];
                                productOtherData.productVariants.forEach(
                                  getVariantSKUs
                                );
                                function getVariantSKUs(item, index) {
                                  let skuObj = {};
                                  skuObj = item.productSKUs.map((obj) => {
                                    return {
                                      Key: index,
                                      SKUID: obj.skuid,
                                      SKUTypeID: parseInt(
                                        getDecryptID(obj.skuTypeID)
                                      ),
                                      SKUValue: obj.skuValue,
                                      IsUnique: true,
                                      RecordID: obj.recordID,
                                      IsRemove: false,
                                    };
                                  });
                                  variantSKUs.push(skuObj);
                                }

                                setVariantSKURows(variantSKUs);

                                let variantProductBatches = [];
                                productOtherData.productVariants.forEach(
                                  getVariantProductBatches
                                );
                                function getVariantProductBatches(item, index) {
                                  let batchesObj = {};
                                  batchesObj = item.productBatchesDetails.map(
                                    (e, batchIndex) => {
                                      // form.setFieldsValue({
                                      //   [`BatchIDVariant${batchIndex}`]: parseInt(getDecryptID(e.batchID)),
                                      //   [`BatchCodeVariant${batchIndex}`]: e.batchCode,
                                      //   [`BatchQuantityVariant${batchIndex}`] : e.batchQuantity,
                                      //   [`BatchExpiryDateVariant${batchIndex}`]: e.batchExpiryDate,
                                      //   [`OutletIDVariant${batchIndex}`]: e.outletID,
                                      //   [`BatchManufacturingDateVariant${batchIndex}`]: e.batchManufacturingDate,
                                      // });

                                      return {
                                        Key: batchIndex,
                                        BatchID: parseInt(
                                          getDecryptID(e.batchID)
                                        ),
                                        BatchCode: e.batchCode,
                                        BatchQuantity: e.batchQuantity,
                                        BatchExpiryDate: e.batchExpiryDate,
                                        RecordID: e.recordID,
                                        IsRemove: false,
                                        IsUnique: true,
                                        OutletID: e.outletID,
                                        BatchManufacturingDate:
                                          e.batchManufacturingDate,
                                      };
                                    }
                                  );
                                  variantProductBatches.push(batchesObj);
                                }

                                setVariantBatchesRows(variantProductBatches);

                                // if (productOtherData.productVariants !=undefined &&  productOtherData.productVariants!=null && productOtherData.productVariants.length>0) {
                                //   let fileList = productOtherData.productVariants.productImages.map(
                                //     (obj) => {
                                //       return {
                                //         uid: obj.id,
                                //         url: obj.imageURL.replace(
                                //           "http://data.dakartest.com/",
                                //           "http://localhost:13000/"
                                //         ),
                                //         status: "done",
                                //       };
                                //     }
                                //   );
                                //   setVariantImages(fileList);
                                // } else {
                                //   setVariantImages([]);
                                // }
                                let existingCombinationsVariantName = [];
                                let variantColumnData =
                                  productOtherData.productVariants.map(
                                    (obj, index) => {
                                      let taxPrice = "";
                                      let taxName = "";
                                      const loyaltyPoints =
                                        getIsLoyaltyEnabled &&
                                        loyaltyAmountValue &&
                                        loyaltyAmountValue != "0"
                                          ? parseFloat(obj.retailPrice) /
                                            parseFloat(loyaltyAmountValue)
                                          : 0;
                                      if (!getIsTaxExclusive) {
                                        let variantSelectedTaxID =
                                          variantInventoryTaxData[index][0].Tax;
                                        // if (taxID == 0) {
                                        //   let salesTaxObj =
                                        //     defaultSalesTaxID !== ""
                                        //       ? productDataresponse.salesTaxesOptions.filter(
                                        //           (x) =>
                                        //             x.id == defaultSalesTaxID
                                        //         )[0]
                                        //       : productDataresponse
                                        //           .salesTaxesOptions[0];
                                        //   taxName = salesTaxObj.label;
                                        // } else {
                                        //   let salesTaxObj =
                                        //     taxID !== ""
                                        //       ? productDataresponse.salesTaxesOptions.filter(
                                        //           (x) => x.id == taxID
                                        //         )[0]
                                        //       : productDataresponse
                                        //           .salesTaxesOptions[0];
                                        //   taxName = salesTaxObj.label;
                                        // }
                                        // DisplayPriceCalculator(
                                        //   productDataresponse.salesTaxesOptions,
                                        //   salesTaxObj,
                                        //   productCommonData.retailPrice,
                                        //   mapped[0].Tax
                                        // );
                                        if (defaultSalesTaxID !== "") {
                                          let taxObj =
                                            VariantProductOnlyTaxCalculator(
                                              variantSelectedTaxID,
                                              obj.retailPrice,
                                              obj.supplyPrice,
                                              productDataresponse.salesTaxesOptions,
                                              defaultSalesTaxID,
                                              productDataresponse.salesGroupTaxes
                                            );
                                          taxPrice = taxObj.taxPrice;
                                          taxName = taxObj.taxName;
                                          // markUp = taxObj.finalMarkup;
                                        }
                                      }
                                      existingCombinationsVariantName.push(
                                        obj.variantName
                                      );
                                      //
                                      let filteredImageObj =
                                        variantImages.filter(
                                          (x) =>
                                            getDecryptID(x.variantProductID) ==
                                            getDecryptID(obj.productID)
                                        );
                                      let variantImageURL =
                                        filteredImageObj &&
                                        filteredImageObj.length > 0
                                          ? filteredImageObj[0].url
                                          : "";

                                      return {
                                        key: index,
                                        VariantProductID: obj.productID,
                                        // VariantName:
                                        //   productCommonData.productName +
                                        //   obj.variantName,
                                        VariantName: obj.variantName,
                                        // VariantImageURL:
                                        //   variantImages[index] != undefined
                                        //     ? variantImages[index].url
                                        //     : "",
                                        VariantImageURL: variantImageURL,
                                        VariantSKU: obj.customSKUCode,
                                        VariantSupplierCode: obj.supplierCode,
                                        VariantSupplyPrice: obj.supplyPrice,
                                        VariantRetailPrice: getIsTaxExclusive
                                          ? obj.retailPrice
                                          : parseFloat(obj.retailPrice) +
                                            parseFloat(taxPrice),
                                        VariantEnabled: obj.isActiveProduct,
                                        VariantMarkup: obj.markupInPercentage,
                                        VariantIsCustomLoyalty:
                                          obj.isCustomLoyalty,
                                        VariantCustomLoyaltyPrice:
                                          obj.loyaltyPrice,
                                        IsSupplyPriceChange: true,
                                        IsRetailPriceChange: true,
                                        VariantTaxName: taxName,
                                        VariantTaxPrice: taxPrice,
                                        VariantLoyaltyPoints: loyaltyPoints,
                                      };
                                    }
                                  );

                                setTableProductVariantdata(variantColumnData);
                                let removeCombinations =
                                  getRemoveVariantCombinationsName(
                                    existingCombinationsVariantName,
                                    editAttributeValues
                                  );
                                setRemoveVariantCombinations(
                                  removeCombinations
                                );
                              }
                            }
                          }
                        }
                      });
                    } else {
                      SetisLoading(false);
                    }
                  } else {
                    SetisLoading(false);
                  }
                }
              }
            }
          });
        } else {
          SetisLoading(false);
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        SetisLoading(false);
      });
  }

  async function getAutoGeneratedSKU(body) {
    setIsAutoSKUCodeLoader(true);
    const generatedSKUs = ds.getAutoGeneratedSKUs(body, BEHAVIOUR_TYPE.GET);
    await generatedSKUs
      .then((response) => {
        if (response) {
          setAutoGenerateSKUs(response);
          setIsAutoSKUCodeLoader(false);
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
      });
  }
  async function getReturnAutoGeneratedSKU(body) {
    let generatedSKU = [];
    const generatedSKUs = ds.getAutoGeneratedSKUs(body, BEHAVIOUR_TYPE.GET);
    await generatedSKUs
      .then((response) => {
        if (response) {
          generatedSKU = response;
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
      });
    return generatedSKU;
  }
  async function getCheckSKUAvailibility(body) {
    const isSKUAvailable = ds.getCheckSKUAvailability(body, BEHAVIOUR_TYPE.GET);

    let skuAvailibilityObj = {
      skuID: "",
      skuValue: "",
      isAvailable: false,
    };
    await isSKUAvailable
      .then((response) => {
        if (response) {
          skuAvailibilityObj = response;
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
      });
    return skuAvailibilityObj;
  }
  async function postDeleteProductBatch(body) {
    //setLoader(true);
    await ds
      .postDeleteProductBatchByID(body, BEHAVIOUR_TYPE.POST)
      .then((res) => {
        if (res.data.data.isDeleted) {
          //setLoader(false);
          message.success(res.data.data.message);

          // getProductListing(pagination);
        } else {
          message.error(res.data.data.message);
        }
      })
      .catch((error) => {
        notAllowMsgCheck(error);
        message.error("Something went wrong...");
      });
  }
  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    //////;

    setPreviewVisible(true);
    setPreviewImage(
      file.uid.toString().includes("rc-upload") ? file.thumbUrl : file.url
    );
    setPreviewTitle(file.name);
  };

  const handleSearch = async (value) => {
    if (value.length > 1) {
      let nameArray = [];
      let searchProducts = {
        data: {
          msgCode: "",
          msgDescription: "",
        },
      };
      await ds
        .getBookSearchProd(
          `?keys=${value}&outletid=${""}&isstock=${true}&isInventory=${false}&isActiveProduct=${true}&isPB=${false}&isVariantProduct=${true}`
        )
        .then((response) => (searchProducts.data = response.data))
        .catch((e) => {
          // console.log("Product Search Issue", e)
        });

      if (searchProducts.data.msgCode == "GENERAL_SUCCESS") {
        if (searchProducts.data.data.length > 0) {
          setSearchProd(getSearchProd.concat(searchProducts.data.data));
          nameArray = searchProducts.data.data.map((names) => {
            const category = names.productName;
            return {
              value: category,
              label: (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "lightcyan",
                      fontStyle: "oblique",
                      fontWeight: "bolder",
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id="products.addeditpriceprod.searchresult" />
                  </span>
                </div>
              ),
            };
          });
        }
        setOptions(nameArray);
      }

      if (searchProducts.data.msgCode == "GENERAL_ERROR") {
        message.error(searchProducts.data.msgDescription);
      }
    } else {
      setOptions([]);
      setSearchProd([]);
    }
  };
  const onSelect = async (selectedObj) => {
    let newProd = [];
    let productID = "";

    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID;
      }
    } else {
      productID = "";
    }
    if (!StringIsNullOrEmpty(productID)) {
      // Here we call Details API
      await ds
        .getBookSearchProd(
          `?keys=""&outletid=${""}&isstock=${true}&isInventory=${false}&isActiveProduct=${true}&isPB=${false}&isVariantProduct=${true}&productID=${productID}`
        )
        .then((response) => {
          const productData = response.data;
          if (productData.msgCode == "GENERAL_SUCCESS") {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map((obj) => {
                return {
                  key: getRandomInt(1000000000000000),
                  ProductID: obj.productID,
                  Name: obj.productName,
                  CompositeProductQuantity: 1,
                  SupplyPrice: obj.supplyPrice,
                };
              });
            }
          }
          if (productData.msgCode == "GENERAL_ERROR") {
            message.error(productData.msgDescription);
          }
        })
        .catch((e) => {
          // console.log("Product Search Issue", e)
        });

      if (newProd.length > 0) {
        let isExist = getTableCompositeProductData.filter(
          (x) =>
            getDecryptID(x.ProductID) === getDecryptID(newProd[0].ProductID)
        );
        if (isExist.length === 0) {
          let supposed = [];
          supposed.push(newProd[0]);
          setTableCompositeProductData(
            supposed.concat(getTableCompositeProductData)
          );

          CalculateCompositeProductTotal(
            supposed.concat(getTableCompositeProductData)
          );
        } else {
          message.error(
            "Product is already in list, increase quantity if you want to add more than 1 product"
          );
        }
      }
    }
  };
  const onChangeProductInventor = (e) => {
    setIsProductInventory(e.target.checked);
  };
  function CalculateCompositeProductTotal(compositeProduct) {
    // ;
    ////;
    let CPQuantity = 0;
    let CPSupplyPrice = 0;
    if (compositeProduct.length > 0) {
      for (var i = 0; i <= compositeProduct.length; i++) {
        if (compositeProduct[i] != undefined) {
          CPQuantity += parseInt(compositeProduct[i].CompositeProductQuantity);
          CPSupplyPrice +=
            parseInt(compositeProduct[i].CompositeProductQuantity) *
            parseFloat(compositeProduct[i].SupplyPrice);
        }
      }
    } else {
      CPQuantity = 0;
      CPSupplyPrice = 0;
    }
    let cpPriceDecimal = CPSupplyPrice
      ? parseFloat(CPSupplyPrice.toString())
          .toFixed(getDefaultDecimalPlaces)
          .toString()
      : "0.00";
    form.setFieldsValue({ SupplyPrice: cpPriceDecimal });

    setCPTotalQuantity(CPQuantity);
    setCPTotalSupplyPrice(cpPriceDecimal);
    form.setFieldsValue({ SupplyPriceTotal: cpPriceDecimal });
    // handlePricesCalculator("", "SupplyPrice");
  }
  const props = {
    name: "file",
    multiple: true,
    fileList: fileList.length != 0 ? fileList : [],
    listType: "picture-card",
    onPreview: handlePreview,
    onChange(info) {
      if (
        info.file.status == "removed" &&
        !info.file.uid.toString().includes("rc-upload")
      ) {
        let getImages = getDeletedImages;
        getImages.push(info.file);
        setDeletedImages(getImages);
        handleUpload(info);
      } else {
        handleUpload(info);
      }
    },
  };

  const handleUpload = ({ fileList }) => {
    ////;
    setfileList(fileList);
    console.log("fileList", fileList);
  };
  const handleFocus = (event) => event.target.select();

  const onClickBatchDelete = (batchID) => {
    let body = {
      BatchID: `${batchID}&&_da1a-77cb-4563-bc20-d1b957c65b25`,
      BehaviorName: 2,
    };
    postDeleteProductBatch(body);
  };

  const columnsInventory = [
    {
      title: "Outlet",
      dataIndex: "OutletName",
      key: "OutletName",
    },
    {
      title: "Current Inventory",
      dataIndex: "CurrentInventory",
      key: "CurrentInventory",
      render: (text, record) => {
        function putCurrentInventory() {
          let CurrentInventory = `CurrentInventory${record.key}`;
          if (record.CurrentInventory != undefined)
            form.setFieldsValue({
              [CurrentInventory]: record.CurrentInventory,
            });
        }
        function onChangeCurrentInventory(value) {
          let rowKey = record.key;
          let supposedArr = tableDataStoreOutlets;
          supposedArr.filter((a) => a.key === rowKey)[0].CurrentInventory =
            value.target.value;
          setTableDataStoreOutlets(supposedArr);
        }

        putCurrentInventory();

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`CurrentInventory${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
            >
              <Input
                onChange={onChangeCurrentInventory}
                onFocus={handleFocus}
                type="number"
              />
            </Form.Item>
          </Form>
        );
      },
    },
    {
      title: "Re-order Point",
      dataIndex: "ReOrderPoint",
      key: "ReOrderPoint",
      render: (text, record) => {
        function putReorderPoint() {
          let ReorderPoint = `ReOrderPoint${record.key}`;
          form.setFieldsValue({ [ReorderPoint]: record.ReOrderPoint });
        }
        function onChangeReOrderPoint(value) {
          let rowKey = record.key;
          let supposedArr = tableDataStoreOutlets;
          supposedArr.filter((a) => a.key === rowKey)[0].ReOrderPoint =
            value.target.value;
          setTableDataStoreOutlets(supposedArr);
        }
        putReorderPoint();

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`ReOrderPoint${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
            >
              <Input onChange={onChangeReOrderPoint} type="number" />
            </Form.Item>
          </Form>
        );
      },
    },
    {
      title: "Re-order Quantity",
      dataIndex: "ReOrderQuantity",
      key: "ReOrderQuantity",
      render: (text, record) => {
        function putReorderQuantity() {
          let ReorderQuantity = `ReOrderQuantity${record.key}`;
          form.setFieldsValue({ [ReorderQuantity]: record.ReOrderQuantity });
        }
        function onChangeReOrderQuantity(value) {
          let rowKey = record.key;
          let supposedArr = tableDataStoreOutlets;
          supposedArr.filter((a) => a.key === rowKey)[0].ReOrderQuantity =
            value.target.value;
          setTableDataStoreOutlets(supposedArr);
        }
        putReorderQuantity();

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`ReOrderQuantity${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
            >
              <Input type="number" onChange={onChangeReOrderQuantity} />
            </Form.Item>
          </Form>
        );
      },
    },
  ];
  const columnsTax = [
    {
      title: "Outlet",
      dataIndex: "OutletName",
      key: "OutletName",
    },
    {
      title: "Tax",
      dataIndex: "Tax",
      key: "Tax",
      render: (text, record) => {
        function putTax() {
          let Tax = `Tax${record.key}`;
          form.setFieldsValue({ [Tax]: record.Tax });
        }
        function onChangeTax(value) {
          let rowKey = record.key;
          let supposedArr = tableDataStoreOutlets;
          supposedArr.filter((a) => a.key === rowKey)[0].Tax =
            value.target.value;
          setTableDataStoreOutlets(supposedArr);
        }
        putTax();

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
              name={`Tax${record.key}`}
              onChange={onChangeTax}
            >
              <Select>
                {saleTaxOptions &&
                  saleTaxOptions.map((e, key) => {
                    return <option value={e.id}>{e.label}</option>;
                  })}
              </Select>
            </Form.Item>
          </Form>
        );
      },
    },
  ];

  const columnsProductVariant = [
    {
      title: "",
      dataIndex: "VariantImageURL",
      key: "VariantImageURL",
      render: (text, record) => (
        <>
          <div className="gx-module-list-icon">
            <div className="gx-d-none gx-d-sm-flex">
              {record.VariantImageURL != undefined &&
              record.VariantImageURL != "" ? (
                <Avatar
                  shape="square"
                  size={64}
                  className="dk-avatar-retrive-sale"
                  src={record.VariantImageURL}
                />
              ) : (
                <Avatar
                  shape="square"
                  size={64}
                  className="dk-avatar-retrive-sale"
                  src={Placeholder}
                />
              )}
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Variant Name",
      dataIndex: "VariantName",
      key: "VariantName",
    },
    // {
    //   title: "SKU",
    //   dataIndex: "VariantSKU",
    //   key: "VariantSKU",
    //   render: (text, record) => {
    //     function putVariantSKU() {
    //       let VariantSKU = `VariantSKU${record.key}`;
    //       form.setFieldsValue({ [VariantSKU]: record.VariantSKU });
    //     }
    //     putVariantSKU();

    //     function onChangeVariantSKU(value) {
    //       let rowKey = record.key;
    //       let supposedArr = TableProductVariantdata;
    //       supposedArr.filter((a) => a.key === rowKey)[0].VariantSKU =
    //         value.target.value;
    //       setTableProductVariantdata(supposedArr);
    //     }
    //     return (
    //       <Form
    //         form={form}
    //         name="ProductForm"
    //         onFinish={onFinish}
    //         onFinishFailed={onFinishFailed}
    //         scrollToFirstError
    //       >
    //         <Form.Item
    //           name={`VariantSKU${record.key}`}
    //           className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto custom-div-hide "
    //         >
    //           <Input onChange={onChangeVariantSKU} />
    //         </Form.Item>
    //       </Form>
    //     );
    //   },
    // },
    {
      title: "Supplier Code",
      dataIndex: "VariantSupplierCode",
      key: "VariantSupplierCode",
      render: (text, record) => {
        function putVariantSupplierCode() {
          let VariantSupplierCode = `VariantSupplierCode${record.key}`;
          form.setFieldsValue({
            [VariantSupplierCode]: record.VariantSupplierCode,
          });
        }
        putVariantSupplierCode();

        function onChangeVariantSupplierCode(value) {
          let rowKey = record.key;
          let supposedArr = TableProductVariantdata;
          supposedArr.filter((a) => a.key === rowKey)[0].VariantSupplierCode =
            value.target.value;
          setTableProductVariantdata(supposedArr);
        }
        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`VariantSupplierCode${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
            >
              <Input onChange={onChangeVariantSupplierCode} />
            </Form.Item>
          </Form>
        );
      },
    },
    {
      title: "Supply Price",
      dataIndex: "VariantSupplyPrice",
      key: "VariantSupplyPrice",
      render: (text, record) => {
        function putVariantSupplyPrice() {
          let VariantSupplyPrice = `VariantSupplyPrice${record.key}`;
          let VariantSupplyPriceTab = `VariantSupplyPrice${record.VariantName}`;
          form.setFieldsValue({
            [VariantSupplyPrice]: record.VariantSupplyPrice,
          });
          form.setFieldsValue({
            [VariantSupplyPriceTab]: record.VariantSupplyPrice,
          });
        }
        putVariantSupplyPrice();

        function onChangeVariantSupplyPrice(event) {
          let rowKey = record.key;
          let priceValue = event.target.value;
          let supposedArr = TableProductVariantdata;
          let filteredArray = supposedArr.filter((a) => a.key === rowKey)[0];
          filteredArray.VariantSupplyPrice = priceValue;
          filteredArray.IsSupplyPriceChange = true;

          let VariantSupplyPriceTab = `VariantSupplyPrice${record.VariantName}`;
          form.setFieldsValue({ [VariantSupplyPriceTab]: priceValue });
          setTableProductVariantdata(supposedArr);
          VariantProductPricesCalculator(
            supposedArr,
            record.key,
            "SupplyPrice"
          );
        }

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`VariantSupplyPrice${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
            >
              <InputNumber
              type="number"
                precision={2}
                style={{
                  width: "100%",
                }}
                min={0}
                onFocus={handleFocus}
                onBlur={(event) => onChangeVariantSupplyPrice(event)}
              />
              {/* <Input onChange={onChangeVariantSupplyPrice} /> */}
            </Form.Item>
          </Form>
        );
      },
    },
    {
      title: "Retail Price",
      dataIndex: "VariantRetailPrice",
      key: "VariantRetailPrice",
      render: (text, record) => {
        function putVariantRetailPrice() {
          let VariantRetailPrice = `VariantRetailPrice${record.key}`;
          let VariantRetailPriceTab = `VariantRetailPrice${record.VariantName}`;
          form.setFieldsValue({
            [VariantRetailPrice]: record.VariantRetailPrice,
          });
          form.setFieldsValue({
            [VariantRetailPriceTab]: record.VariantRetailPrice,
          });
        }
        putVariantRetailPrice();

        function onChangeVariantRetailPrice(event) {
          let rowKey = record.key;
          let priceValue = event.target.value;
          let supposedArr = TableProductVariantdata;
          let filteredArray = supposedArr.filter((a) => a.key === rowKey)[0];
          filteredArray.VariantRetailPrice = priceValue;
          filteredArray.IsRetailPriceChange = true;

          let VariantRetailPriceTab = `VariantRetailPrice${record.VariantName}`;
          form.setFieldsValue({ [VariantRetailPriceTab]: priceValue });
          setTableProductVariantdata(supposedArr);
          VariantProductPricesCalculator(
            supposedArr,
            record.key,
            "RetailPrice"
          );
        }

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`VariantRetailPrice${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
            >
              <InputNumber
              type="number"
                precision={2}
                onBlur={(event) => onChangeVariantRetailPrice(event)}
                onFocus={handleFocus}
                min={0}
              />
              {/* <Input onChange={onChangeVariantRetailPrice} /> */}
            </Form.Item>
          </Form>
        );
      },
    },
    {
      title: "Markup",
      dataIndex: "VariantMarkup",
      key: "VariantMarkup",
      render: (text, record) => {
        function putVariantMarkup() {
          let VariantMarkup = `VariantMarkup${record.key}`;
          let VariantMarkupTab = `VariantMarkup${record.VariantName}`;

          form.setFieldsValue({
            [VariantMarkup]: record.VariantMarkup,
          });
          form.setFieldsValue({
            [VariantMarkupTab]: record.VariantMarkup,
          });
        }
        putVariantMarkup();

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`VariantMarkup${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
            >
              <InputNumber
              type="number"
                precision={2}
                disabled={true}
                min={0}
              />
            </Form.Item>
          </Form>
        );
      },
    },

    {
      title: "Enabled",
      dataIndex: "VariantEnabled",
      key: "VariantEnabled",
      render: (text, record) => {
        function putVariantEnabled() {
          let VariantEnabled = `VariantEnabled${record.key}`;
          form.setFieldsValue({ [VariantEnabled]: record.VariantEnabled });
        }
        putVariantEnabled();

        function onChangeVariantEnabled(value) {
          let rowKey = record.key;
          let supposedArr = TableProductVariantdata;
          supposedArr.filter((a) => a.key === rowKey)[0].VariantEnabled = value;
          setTableProductVariantdata(supposedArr);
        }
        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`VariantEnabled${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
            >
              <span>
                <Switch
                  onChange={onChangeVariantEnabled}
                  defaultChecked
                  style={{ marginBottom: "20px" }}
                />
              </span>
            </Form.Item>
          </Form>
        );
      },
    },
    // {
    //   title: "Expiry Date",
    //   dataIndex: "VariantExpiryDate",
    //   key: "VariantExpiryDate",
    //   render: (text, record) => {
    //     function putExpiryDate() {
    //       let VariantExpiryDate = `VariantExpiryDate${record.key}`;
    //       form.setFieldsValue({
    //         [VariantExpiryDate]: moment(record.VariantExpiryDate),
    //       });
    //     }
    //     putExpiryDate();

    //     function onChangeVariantExpiryDate(date) {
    //       let rowKey = record.key;
    //       let supposedArr = TableProductVariantdata;
    //       supposedArr.filter((a) => a.key === rowKey)[0].VariantExpiryDate =
    //         moment(date).format(dateFormat);
    //       setTableProductVariantdata(supposedArr);
    //     }
    //     // const onExpiryDateChange = (date, dateString) => {
    //     //   console.log(date, dateString);
    //     // };
    //     return (
    //       <div className="" style={{ marginTop: "20px" }}>
    //         <div
    //           style={{
    //             marginLeft: "15px",
    //             marginRight: "18px",
    //           }}
    //         >
    //           <p>
    //             <strong>
    //               <IntlMessages id="products.main.add.expirydate" />
    //             </strong>{" "}
    //             {/* <IntlMessages id="products.main.add.producttypedescription" /> */}
    //           </p>
    //         </div>
    //         <Form
    //           form={form}
    //           name="ProductForm"
    //           onFinish={onFinish}
    //           onFinishFailed={onFinishFailed}
    //           scrollToFirstError
    //         >
    //           <Form.Item
    //             className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
    //             name={`VariantExpiryDate${record.key}`}
    //             label=""
    //             style={{ width: "100%" }}
    //           >
    //             <DatePicker
    //               format={dateFormat}
    //               onChange={onChangeVariantExpiryDate}
    //             />
    //           </Form.Item>
    //         </Form>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "",
      dataIndex: "Delete",
      key: "Delete",
      render: (text, record) => {
        function handleDelete() {
          let temp = RemoveVariantCombinations;
          temp.push(record.VariantName);
          setRemoveVariantCombinations(temp);
          let tableColumnData = TableProductVariantdata;
          let newData = tableColumnData.filter((x) => x.key != record.key);
          setTableProductVariantdata(newData);
          AddDeleteProductVariant();
        }
        //putCurrentInventory();

        return (
          <span>
            <a
              onClick={handleDelete}
              className="trash-icon-btn"
            >
              {" "}
              <i className="icon icon-trash" />
            </a>
          </span>
        );
      },
    },
  ];

  const columnsCompositeProduct = [
    {
      title: <IntlMessages id="products.main.add.product" />,
      dataIndex: "Name",
      key: "Name",
      render: (text, record) => {
        return (
          <span>
            {" "}
              {record.IsVariant ? `${text} ${record.VariantName}` : text}
          </span>
        );
      },
    },
    {
      title: <IntlMessages id="products.main.add.quantity" />,
      dataIndex: "CompositeProductQuantity",
      key: "CompositeProductQuantity",
      render: (text, record) => {
        function putQuantity() {
          let CompositeProductQuantity = `CompositeProductQuantity${record.key}`;
          form.setFieldsValue({
            [CompositeProductQuantity]: record.CompositeProductQuantity,
          });
        }
        function onChangeQuantity(value) {
          let rowKey = record.key;
          let supposedArr = getTableCompositeProductData;
          supposedArr.filter(
            (a) => a.key === rowKey
          )[0].CompositeProductQuantity = value;
          setTableCompositeProductData(supposedArr);
          CalculateCompositeProductTotal(supposedArr);
        }
        putQuantity();

        return (
          <Form
            form={form}
            name="ProductForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`CompositeProductQuantity${record.key}`}
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
            >
              <InputNumber type="number" onChange={onChangeQuantity} />
            </Form.Item>
          </Form>
        );
      },
    },
    {
      title: <IntlMessages id="products.main.add.supplyprice" />,
      dataIndex: "SupplyPrice",
      key: "SupplyPrice",
    },
    {
      title: <IntlMessages id="products.brands.delete" />,
      key: "delete",
      render: (text, record) => {
        const deleteProds = (proid) => {
          let obj = {};
          obj.proid = proid;
          setTableCompositeProductData(
            getTableCompositeProductData.filter((a) => a.ProductID !== proid)
          );
          CalculateCompositeProductTotal(
            getTableCompositeProductData.filter((a) => a.ProductID !== proid)
          );
        };
        function showDeleteConfirmPro(proid, name) {
          //
          confirm({
            title: "Are you sure remove this Product?",
            content: `"${name}"`,
            okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
            onOk() {
              deleteProds(proid);
            },
            onCancel() {
              //console.log('Cancel');
            },
          });
        }

        return (
          <span>
            <a
              onClick={() =>
                showDeleteConfirmPro(record.ProductID, record.Name)
              }
              className="trash-icon-btn"
            >
              <i className="icon icon-trash" />
            </a>
          </span>
        );
      },
    },
  ];

  const getTableProductVariantdata = [
    {
      key: 1,
      VariantName: "Green",
      VariantSKU: "",
      VariantSupplierCode: "",
      VariantSupplyPrice: "",
      VariantRetailPrice: "",
      VariantEnabled: "",
    },
    {
      key: 2,
      VariantName: "Blue",
      VariantSKU: "",
      VariantSupplierCode: "",
      VariantSupplyPrice: "",
      VariantRetailPrice: "",
      VariantEnabled: "",
    },
  ];
  const getTabledataOutlet = [
    {
      OutletName: "Main outlet",
      CurrentInventory: 4,
      ReorderPoint: 5,
      ReorderQuantity: 6,
    },
  ];
  const getTableCompositeProductDataTax = [
    {
      OutletName: "Main outlet",
      Tax: 4,
    },
    {
      OutletName: "Friend outlet",
      Tax: 4,
    },
    {
      OutletName: "Khan g outlet",
      Tax: 4,
    },
  ];
  const ProductInventoryTypeSelection = (value) => {
    if (value == 0) {
      let bodySKu = {
        ProductName: [""],
      };
      getAutoGeneratedSKU(bodySKu);

      setProductInventoryType(0);
    } else if (value == 1) {
      setProductInventoryType(1);
      setProductInventoryTypeInEdit("Product with Variants");
    } else if (value == 2) {
      let defaultSKUJson = [
        {
          Key: 0,
          SKUID: "",
          SKUTypeID: 1,
          SKUValue: "",
          IsUnique: true,
          RecordID: "0",
          IsRemove: false,
        },
      ];
      setSKUTypeOptionsRows(defaultSKUJson);
      setProductInventoryType(2);
    }
  };
  const onAttributeNameChange = (event) => {
    //setNewAttributeItem(event.target.value);
  };
  const addAttributeItem = (event) => {
    ////;

    var newValue = form.getFieldValue("NewAttributeName");
    if (newValue != null && newValue != "") {
      let newVariantAttribute = {
        id: "New&&" + newValue,
        label: newValue,
        IsNew: true,
      };

      let temp = variantAttributeOptions;
      setVariantAttributeOptions(temp.concat(newVariantAttribute));
    } else {
      message.error("Please Select attribute");
    }
    form.setFieldsValue({ NewAttributeName: "" });
  };

  const OnChangeSKURadioButton = (e) => {
    //1. For Auto Generated
    //2. For Custom
    let SKUTypeID = e.target.value;
    let defaultSKUJson = [
      {
        Key: 0,
        SKUID: 0,
        SKUTypeID: SKUTypeID,
        SKUValue: "",
        IsUnique: true,
        RecordID: "0",
        IsRemove: false,
      },
    ];
    setSKUTypeOptionsRows(defaultSKUJson);
    setInvSKURadioButton(SKUTypeID);
  };
  const OnChangeLoyaltyRadioButton = (e) => {
    setPLoyaltyRadioButton(e.target.value);
  };

  const redirectToadd = () => {
    history.push("/Dashboard/products/main/add");
  };
  const redirectToListing = () => {
    history.push("/Dashboard/products/main");
  };
  const [form] = Form.useForm();

  const OnChangeDescription = (evt) => {
    setDescriptionContent(evt.editor.getData());
  };

  //getvariantCombinatiosn([['red','green'],['small','large']]);

  function getvariantCombinatiosn(arr) {
    if (arr.length > 0) {
      if (arr.length == 1) {
        return arr[0];
      } else {
        var ans = [];

        // recur with the rest of the array.
        var otherCases = getvariantCombinatiosn(arr.slice(1));
        for (var i = 0; i < otherCases.length; i++) {
          for (var j = 0; j < arr[0].length; j++) {
            ans.push(arr[0][j] + "/" + otherCases[i]);
          }
        }
        // console.log("Combination", ans);

        return ans;
      }
    } else {
      return [];
    }
  }
  const handleAttributeValueChange = (e, id) => {
    AddDeleteProductVariant();
  };

  const handlePricesCalculator = (event, inputType) => {
    // let value = event.target.value;
    ////;

    let whichInputTypeChange = inputType;
    let SupplyPrice = parseFloat(
      form.getFieldValue("SupplyPrice")
        ? form.getFieldValue("SupplyPrice")
        : "0.00"
    ).toFixed(getDefaultDecimalPlaces);
    let MarkUp = parseFloat(
      form.getFieldValue("Markup") ? form.getFieldValue("Markup") : "0.00"
    ).toFixed(getDefaultDecimalPlaces);
    let RetailPrice = parseFloat(
      form.getFieldValue("RetailPrice") ? form.getFieldValue("RetailPrice") : 0
    );

    let CalculatedSP = parseFloat("0").toFixed(getDefaultDecimalPlaces);
    let CalculatedRP = parseFloat("0");
    let CalculatedMarkUp = parseFloat("0").toFixed(getDefaultDecimalPlaces);

    if (whichInputTypeChange == "SupplyPrice") {
      if (SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
        if (RetailPrice != 0) {
          if (getIsTaxExclusive) {
            CalculatedMarkUp =
              ((RetailPrice - SupplyPrice) / SupplyPrice) * 100;
            CalculatedRP = RetailPrice;
          } else {
            CalculatedMarkUp =
              ((RetailPrice - getDisplayPriceWithName.taxPrice - SupplyPrice) /
                SupplyPrice) *
              100;
            CalculatedRP = RetailPrice - getDisplayPriceWithName.taxPrice;
          }
          CalculatedSP = SupplyPrice;
        } else if (MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
          //Ye case kbhe nhi chalega
        } else {
          CalculatedSP = SupplyPrice;
          //When Retail Price and Markup Empty , First Time add Supply Price
          //No Change
        }
      } else {
        // CalculatedRP = RetailPrice;
        onChangeMainTax(getTaxID);
      }
    } else if (whichInputTypeChange == "MarkUp") {
      if (MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
        if (SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
          // CalculatedRP = SupplyPrice / (1 - MarkUp / 100); // here we use math,round
          // let markupValue = (MarkUp/100);
          let retailPrice =
            SupplyPrice * (MarkUp / 100) + parseFloat(SupplyPrice);
          CalculatedRP = parseFloat(retailPrice);
          CalculatedSP = SupplyPrice;
          CalculatedMarkUp = MarkUp;
        } else if (RetailPrice != 0) {
          CalculatedSP = SupplyPrice;
          CalculatedRP = 0; //Remove
          CalculatedMarkUp = MarkUp;

          form.setFieldsValue({ ["RetailPrice"]: CalculatedRP });
          let temp = getDisplayPriceWithName;
          temp.taxPrice = parseFloat("0").toFixed(getDefaultDecimalPlaces);
          setDisplayPriceWithName(temp);
        } else {
          CalculatedMarkUp = MarkUp;
          CalculatedRP = 0; //Remove
          //When Retail Price and Supply Price Empty , First Time add Markup
          //No Change
        }
      } else {
        CalculatedSP = SupplyPrice;
      }
    } else if (whichInputTypeChange == "RetailPrice") {
      if (MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
        if (SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
          CalculatedSP = SupplyPrice;
          if (getIsTaxExclusive) {
            CalculatedRP = RetailPrice;
            CalculatedMarkUp =
              ((RetailPrice - SupplyPrice) / SupplyPrice) * 100;
          } else {
            if (
              parseFloat(getRetailPricePreviousValue) !==
              parseFloat(form.getFieldValue("RetailPrice"))
            ) {
              onChangeMainTax(getTaxID);
            }
            //  let pricesObj =  DisplayPriceCalculator( saleTaxOptions,getDefaultOutletTaxes,RetailPrice,getTaxID);
            //   CalculatedRP = pricesObj.retailPrice ;
            //   CalculatedMarkUp =
            //     ((pricesObj.retailPrice - SupplyPrice) /
            //       SupplyPrice) *
            //     100;
          }
        } else {
          CalculatedRP = RetailPrice;
        }
      } else if (
        SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)
      ) {
        CalculatedSP = SupplyPrice;
        // MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces) &&
        if (RetailPrice != 0) {
          if (getIsTaxExclusive) {
            CalculatedMarkUp =
              ((RetailPrice - SupplyPrice) / SupplyPrice) * 100;
            CalculatedRP = RetailPrice;
          } else {
            // CalculatedMarkUp =
            //   ((RetailPrice - SupplyPrice - getDisplayPriceWithName.taxPrice) /
            //     SupplyPrice) *
            //   100;
            onChangeMainTax(getTaxID);
          }
        } else {
          CalculatedSP = SupplyPrice;
          // CalculatedRP = RetailPrice;
        }
      } else {
        CalculatedRP = RetailPrice;
        // DisplayPriceCalculator(
        //   saleTaxOptions,
        //   getDefaultOutletTaxes,
        //   CalculatedRP,
        //   getTaxID
        // );
        // DisplayPriceCalculator(
        //   saleTaxOptions,
        //   getDefaultTaxObj,
        //   CalculatedRP,
        //   getTaxID,
        //   getSalesGroupTaxes
        // );

        onChangeMainTax(getTaxID);
        //When MarkUp and Supply Price Empty , First Time add Markup
        //No Change
      }
    }

    form.setFieldsValue({ ["SupplyPrice"]: CalculatedSP });
    form.setFieldsValue({ ["SupplyPriceTotal"]: CalculatedSP });

    if (
      (whichInputTypeChange != "RetailPrice" &&
        CalculatedSP != parseFloat("0").toFixed(getDefaultDecimalPlaces)) ||
      getIsTaxExclusive
    ) {
      form.setFieldsValue({ ["RetailPrice"]: CalculatedRP });
      form.setFieldsValue({ ["Markup"]: CalculatedMarkUp });
    }

    // DisplayPriceCalculator(CalculatedRP);
    if (
      !getIsTaxExclusive &&
      whichInputTypeChange != "RetailPrice" &&
      CalculatedSP != parseFloat("0").toFixed(getDefaultDecimalPlaces)
    ) {
      // DisplayPriceCalculator(
      //   saleTaxOptions,
      //   getDefaultOutletTaxes,
      //   CalculatedRP,
      //   getTaxID
      // );
      DisplayPriceCalculator(
        saleTaxOptions,
        getDefaultTaxObj,
        CalculatedRP,
        getTaxID,
        getSalesGroupTaxes
      );
    }
    if (getIsTaxExclusive) {
      const loyaltyPoints =
        parseFloat(CalculatedRP) / parseFloat(getLoyaltyAmountValue);
      setLoyaltyPoints(loyaltyPoints);
    }
    if (productInventoryType == 1 && TableProductVariantdata.length > 0) {
      AddDeleteProductVariant();
    }
  };

  function DisplayPriceCalculator(
    salesTaxes,
    defaultTaxObj,
    retailPrice,
    selectedTaxID,
    salesGroupTaxes
  ) {
    ////;

    let returnPriceObj = {
      taxID: "",
      taxName: "",
      taxPrice: "",
      retailPrice: "",
    };

    let inclRetailPrice = parseFloat("0").toFixed(getDefaultDecimalPlaces);
    let displayPriceObj = {
      taxName: "",
      taxName: "",
      taxPrice: "",
    };
    let taxObj = {};
    let preTaxPrice = parseFloat(retailPrice);

    //Salis important change verify to notepad++ if issue occurred
    if (selectedTaxID == "0") {
      taxObj = defaultTaxObj;
    } else {
      taxObj = salesTaxes.filter((x) => x.id == selectedTaxID)[0];
    }

    if (taxObj == undefined) {
      displayPriceObj = {
        taxID: "0",
        taxName: "No Tax",
        taxPrice: "0",
      };
    } else {
      const getTotalTaxDataPrice = GetCummulativeTaxDatabyTaxID(
        taxObj.id,
        salesTaxes,
        salesGroupTaxes
      );

      retailPrice = parseFloat(retailPrice);
      // retailPrice += getTotalTaxDataPrice.totalFixedTax;
      let taxPrice =
        retailPrice *
        (parseFloat(getTotalTaxDataPrice.totalTaxPercentage).toFixed(
          getDefaultDecimalPlaces
        ) /
          100);
      taxPrice += getTotalTaxDataPrice.totalFixedTax;
      inclRetailPrice = parseFloat(preTaxPrice) + taxPrice;
      displayPriceObj = {
        taxID: taxObj.id,
        taxName: taxObj.label,
        taxPrice:
          selectedTaxID == "0"
            ? taxPrice
            : parseFloat(taxPrice).toFixed(getDefaultDecimalPlaces),
      };
    }

    setDisplayPriceWithName(displayPriceObj);
    form.setFieldsValue({
      ["RetailPrice"]: parseFloat(inclRetailPrice).toFixed(
        getDefaultDecimalPlaces
      ),
    });
    returnPriceObj = {
      taxID: displayPriceObj.taxID,
      taxName: displayPriceObj.taxName,
      taxPrice: displayPriceObj.taxPrice,
      inclRetailPrice: inclRetailPrice,
      retailPrice: preTaxPrice,
    };
    setRetailPricePreviousValue(inclRetailPrice);

    return returnPriceObj;
  }
  const GetCummulativeTaxDatabyTaxID = (
    paramTaxID,
    paramSalesTaxes,
    paramSalesGroupTaxes
  ) => {
    let taxID = paramTaxID.includes("&")
      ? getDecryptID(paramTaxID).toString()
      : paramTaxID.toString();
    if (taxID == "0") {
      taxID = defaultSalesTaxID;
    }

    let totalTaxPercentage = 0;
    let totalFixedTax = 0;
    const currentTax =
      paramSalesTaxes && paramSalesTaxes.filter((x) => x.id == taxID)[0];
    if (currentTax) {
      if (currentTax.isGroup) {
        const currentGroupTax =
          paramSalesGroupTaxes &&
          paramSalesGroupTaxes.filter(
            (x) => getDecryptID(x.groupID) == taxID
          )[0];
        if (currentGroupTax) {
          currentGroupTax.taxes &&
            currentGroupTax.taxes.map((x) => {
              if (x.isFix) {
                totalFixedTax += x.salesTaxValue;
              } else {
                totalTaxPercentage += x.salesTaxValue;
              }
            });
        }
      } else {
        if (currentTax.isFix) {
          totalFixedTax = currentTax.taxPercentage;
        } else {
          totalTaxPercentage = currentTax.taxPercentage;
        }
      }
    }
    const totalTaxValue = {
      totalTaxPercentage: parseFloat(totalTaxPercentage),
      totalFixedTax: parseFloat(totalFixedTax),
    };
    return totalTaxValue;
  };
  const onChangeMainTax = (value) => {
    ////;
    let selectedTaxID = value;
    setTaxID(selectedTaxID);
    let SupplyPrice = parseFloat(
      form.getFieldValue("SupplyPrice")
        ? form.getFieldValue("SupplyPrice")
        : "0.00"
    );
    let RetailPrice = parseFloat(
      form.getFieldValue("RetailPrice")
        ? form.getFieldValue("RetailPrice")
        : "0.00"
    );
    let taxObj = {};
    if (selectedTaxID == "0") {
      //Default Tax Selected
      // let obj = getDefaultOutletTaxes[0];
      let obj = getDefaultTaxObj;
      taxObj = {
        id: obj.id,
        label: obj.label,
        taxPercentage: obj.taxPercentage,
      };
    } else {
      taxObj = saleTaxOptions.filter((x) => x.id == selectedTaxID)[0];
    }

    const getTotalTaxData = GetCummulativeTaxDatabyTaxID(
      taxObj.id,
      saleTaxOptions,
      getSalesGroupTaxes
    );

    RetailPrice -= getTotalTaxData.totalFixedTax;
    let taxPercentageValue = getTotalTaxData.totalTaxPercentage / 100;
    let finalRetailPrice =
      RetailPrice -
      (RetailPrice / (1 + taxPercentageValue)) * taxPercentageValue;
    // finalRetailPrice -= getTotalTaxData.totalFixedTax;

    let finalTax =
      RetailPrice - finalRetailPrice + getTotalTaxData.totalFixedTax;

    let finalMarkup = ((finalRetailPrice - SupplyPrice) / SupplyPrice) * 100;

    RetailPrice = finalRetailPrice + finalTax;

    let displayPriceObj = {
      taxID: taxObj.id,
      taxName: taxObj.label,
      taxPrice: parseFloat(finalTax),
    };

    setDisplayPriceWithName(displayPriceObj);
    //
    const loyaltyPoints =
      parseFloat(finalRetailPrice) / parseFloat(getLoyaltyAmountValue);
    setLoyaltyPoints(loyaltyPoints);
    form.setFieldsValue({
      ["RetailPrice"]: parseFloat(RetailPrice),
    });
    let tempMarkup =
      SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)
        ? parseFloat(finalMarkup).toFixed(getDefaultDecimalPlaces)
        : parseFloat("0").toFixed(getDefaultDecimalPlaces);
    form.setFieldsValue({
      ["Markup"]: tempMarkup,
    });
  };

  const handleVariantPricesCalculator = (event, variantKey, inputType) => {
    let rowName = variantKey;
    let items = [...TableProductVariantdata];
    let value = event.target.value;
    let whichInputTypeChange = inputType;
    let isUpdate = true;

    let item = { ...items.filter((a) => a.key === rowName)[0] };
    if (inputType == "SupplyPrice") {
      item.VariantSupplyPrice = value;
      item.IsSupplyPriceChange = true;
    } else if (inputType == "MarkUp") {
      if (
        parseFloat(item.VariantMarkup).toFixed(getDefaultDecimalPlaces) !==
        parseFloat(value).toFixed(getDefaultDecimalPlaces)
      ) {
        item.VariantMarkup = value;
      } else {
        isUpdate = false;
      }
    } else if (inputType == "RetailPrice") {
      if (
        parseFloat(item.VariantRetailPrice).toFixed(getDefaultDecimalPlaces) !==
        parseFloat(value).toFixed(getDefaultDecimalPlaces)
      ) {
        item.VariantRetailPrice = value;
        item.IsRetailPriceChange = true;
      } else {
        isUpdate = false;
      }
    } else if (inputType == "CustomLoyalty") {
      if (event.target.value != "") {
        item.VariantCustomLoyaltyPrice = value;
        item.VariantIsCustomLoyalty = true;
      }
    }
    if (isUpdate) {
      items[item.key] = item;
      setTableProductVariantdata(items);
      if (inputType != "CustomLoyalty") {
        VariantProductPricesCalculator(items, item.key, whichInputTypeChange);
      }
    }
  };
  function VariantProductPricesCalculator(
    variantData,
    key,
    whichInputTypeChange
  ) {
    ////;
    let rowName = key;
    let items = [...variantData];
    let item = { ...items.filter((a) => a.key === rowName)[0] };

    let SupplyPrice = parseFloat(item.VariantSupplyPrice).toFixed(
      getDefaultDecimalPlaces
    );
    let MarkUp = parseFloat(item.VariantMarkup).toFixed(
      getDefaultDecimalPlaces
    );
    let RetailPrice = parseFloat(item.VariantRetailPrice);
    let TaxPrice = parseFloat(item.VariantTaxPrice);

    // let TaxID = parseFloat(item.VariantTaxName).toFixed(getDefaultDecimalPlaces);

    let CalculatedSP = parseFloat("0").toFixed(getDefaultDecimalPlaces);
    let CalculatedRP = 0;
    let CalculatedMarkUp = parseFloat("0").toFixed(getDefaultDecimalPlaces);
    let selectedTaxID = tableDataVariantStoreOutlets[rowName][0].Tax;
    // ;
    if (whichInputTypeChange == "SupplyPrice") {
      if (SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
        if (RetailPrice != 0) {
          if (getIsTaxExclusive) {
            CalculatedMarkUp =
              ((RetailPrice - SupplyPrice) / SupplyPrice) * 100;
            CalculatedRP = RetailPrice;
          } else {
            CalculatedMarkUp =
              ((RetailPrice - TaxPrice - SupplyPrice) / SupplyPrice) * 100;
            CalculatedRP = RetailPrice - TaxPrice;
          }
          CalculatedSP = SupplyPrice;
        } else if (MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
          //Ye case kbhe nhi chalega
        } else {
          CalculatedSP = SupplyPrice;
          //When Retail Price and Markup Empty , First Time add Supply Price
          //No Change
        }
      } else {
        VariantProductTaxCalculator(selectedTaxID, rowName, "");
      }
    } else if (whichInputTypeChange == "MarkUp") {
      if (MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
        if (SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
          // CalculatedRP = SupplyPrice / (1 - MarkUp / 100); // here we use math,round
          // let markupValue = (MarkUp/100);
          let retailPrice =
            SupplyPrice * (MarkUp / 100) + parseFloat(SupplyPrice);
          CalculatedRP = parseFloat(retailPrice);
          CalculatedSP = SupplyPrice;
          CalculatedMarkUp = MarkUp;
        } else if (RetailPrice != 0) {
          CalculatedSP = SupplyPrice;
          CalculatedRP = 0; //Remove
          CalculatedMarkUp = MarkUp;

          let VariantRetailPriceTab = `VariantRetailPrice${item.VariantName}`;
          form.setFieldsValue({ [VariantRetailPriceTab]: CalculatedRP });
        } else {
          CalculatedMarkUp = MarkUp;
          CalculatedRP = 0; //Remove
          //When Retail Price and Supply Price Empty , First Time add Markup
          //No Change
        }
      } else {
        CalculatedSP = SupplyPrice;
      }
    } else if (whichInputTypeChange == "RetailPrice") {
      if (MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
        if (SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)) {
          CalculatedSP = SupplyPrice;
          if (getIsTaxExclusive) {
            CalculatedRP = RetailPrice;
            CalculatedMarkUp =
              ((RetailPrice - SupplyPrice) / SupplyPrice) * 100;
          } else {
            VariantProductTaxCalculator(selectedTaxID, rowName, RetailPrice);
          }
        } else {
          CalculatedRP = RetailPrice;
        }
      } else if (
        SupplyPrice != parseFloat("0").toFixed(getDefaultDecimalPlaces)
      ) {
        CalculatedSP = SupplyPrice;
        // MarkUp != parseFloat("0").toFixed(getDefaultDecimalPlaces) &&
        if (RetailPrice != 0) {
          if (getIsTaxExclusive) {
            CalculatedMarkUp =
              ((RetailPrice - SupplyPrice) / SupplyPrice) * 100;
          } else {
            // CalculatedMarkUp =
            //   ((RetailPrice - SupplyPrice - getDisplayPriceWithName.taxPrice) /
            //     SupplyPrice) *
            //   100;
            VariantProductTaxCalculator(selectedTaxID, rowName, RetailPrice);
          }
        } else {
          CalculatedSP = SupplyPrice;
          // CalculatedRP = RetailPrice;
        }
      } else {
        CalculatedRP = RetailPrice;
        VariantProductTaxCalculator(selectedTaxID, rowName, RetailPrice);
        //When MarkUp and Supply Price Empty , First Time add Markup
        //No Change
      }
    }

    item.VariantSupplyPrice = CalculatedSP;
    let variantSupplyPriceTab = `VariantSupplyPrice${item.VariantName}`;
    form.setFieldsValue({ [variantSupplyPriceTab]: CalculatedSP });

    if (
      whichInputTypeChange != "RetailPrice" &&
      CalculatedSP != parseFloat("0").toFixed(getDefaultDecimalPlaces)
    ) {
      let VariantRetailPriceTab = `VariantRetailPrice${item.VariantName}`;
      form.setFieldsValue({ [VariantRetailPriceTab]: CalculatedRP });
      item.VariantRetailPrice = CalculatedRP;

      let VariantMarkupTab = `VariantMarkup${item.VariantName}`;
      form.setFieldsValue({ [VariantMarkupTab]: CalculatedMarkUp });
      item.VariantMarkup = CalculatedMarkUp;
    }

    if (
      !getIsTaxExclusive &&
      whichInputTypeChange != "RetailPrice" &&
      CalculatedSP != parseFloat("0").toFixed(getDefaultDecimalPlaces)
    ) {
      //DisplayPriceCalculatorFunction Start
      if (CalculatedRP != 0) {
        let inclRetailPrice = 0;
        let displayPriceObj = {
          taxName: "",
          taxName: "",
          taxPrice: "",
        };
        //Salis important change verify to notepad++ new 8 if issue occurred
        let taxObj = {};
        let preTaxPrice = CalculatedRP;
        if (selectedTaxID == "0") {
          taxObj = getDefaultTaxObj;
        } else {
          taxObj = saleTaxOptions.filter((x) => x.id == selectedTaxID)[0];
        }
        if (taxObj == undefined) {
          displayPriceObj = {
            taxID: "0",
            taxName: "No Tax",
            taxPrice: "0",
          };
        } else {
          const getTotalTaxDataPrice = GetCummulativeTaxDatabyTaxID(
            taxObj.id,
            saleTaxOptions,
            getSalesGroupTaxes
          );
          CalculatedRP = parseFloat(CalculatedRP);
          // CalculatedRP += getTotalTaxDataPrice.totalFixedTax;
          let taxPrice =
            CalculatedRP *
            (parseFloat(getTotalTaxDataPrice.totalTaxPercentage) / 100);
          taxPrice += getTotalTaxDataPrice.totalFixedTax;
          inclRetailPrice = parseFloat(preTaxPrice) + taxPrice;
          displayPriceObj = {
            taxID: taxObj.id,
            taxName: taxObj.label,
            taxPrice: taxPrice,
          };
        }
        item.VariantTaxPrice = displayPriceObj.taxPrice;
        item.VariantTaxName = displayPriceObj.taxName;
        // setDisplayPriceWithName(displayPriceObj);

        item.VariantRetailPrice = parseFloat(inclRetailPrice);
      }
      //DisplayPriceCalculatorFunction End
    }
    if (getIsTaxExclusive) {
      item.VariantLoyaltyPoints =
        parseFloat(CalculatedRP) / parseFloat(getLoyaltyAmountValue);
    }

    items[item.key] = item;
    if (whichInputTypeChange != "RetailPrice" || getIsTaxExclusive) {
      setTableProductVariantdata(items);
    }
  }
  function VariantProductTaxCalculator(variantSelectedTaxID, key, paramRP) {
    ////;
    let rowName = key;
    let items = [...TableProductVariantdata];
    let item = { ...items.filter((a) => a.key === rowName)[0] };

    let SupplyPrice = parseFloat(item.VariantSupplyPrice).toFixed(
      getDefaultDecimalPlaces
    );

    let RetailPrice = !StringIsNullOrEmpty(paramRP)
      ? parseFloat(paramRP)
      : parseFloat(item.VariantRetailPrice);

    let taxObj = {};
    if (variantSelectedTaxID == "0") {
      //Default Tax Selected
      // let obj = getDefaultOutletTaxes[0];
      let obj = getDefaultTaxObj;

      taxObj = {
        id: obj.id,
        label: obj.label,
        taxPercentage: obj.taxPercentage,
      };
    } else {
      taxObj = saleTaxOptions.filter((x) => x.id == variantSelectedTaxID)[0];
    }
    const getTotalTaxData = GetCummulativeTaxDatabyTaxID(
      taxObj.id,
      saleTaxOptions,
      getSalesGroupTaxes
    );

    let taxPercentageValue = getTotalTaxData.totalTaxPercentage / 100;
    RetailPrice -= getTotalTaxData.totalFixedTax;

    let finalRetailPrice =
      RetailPrice -
      (RetailPrice / (1 + taxPercentageValue)) * taxPercentageValue;
    // finalRetailPrice -= getTotalTaxData.totalFixedTax;

    let finalTax =
      RetailPrice - finalRetailPrice + getTotalTaxData.totalFixedTax;
    let finalMarkup = ((finalRetailPrice - SupplyPrice) / SupplyPrice) * 100;
    RetailPrice = finalRetailPrice + finalTax;

    let displayPriceObj = {
      taxID: taxObj.id,
      taxName: taxObj.label,
      taxPrice: finalTax,
    };
    // setDisplayPriceWithName(displayPriceObj);
    item.VariantTaxPrice = parseFloat(finalTax);
    item.VariantTaxName = taxObj.label;
    // item.VariantRetailPrice = finalRetailPrice + parseFloat(finalTax);
    item.VariantRetailPrice = RetailPrice;
    // item.VariantMarkup = finalMarkup;
    item.VariantMarkup = finalMarkup == "Infinity" ? 0 : finalMarkup;
    item.VariantLoyaltyPoints =
      parseFloat(finalRetailPrice) / parseFloat(getLoyaltyAmountValue);
    let VariantRetailPriceTab = `VariantRetailPrice${item.VariantName}`;
    let VariantMarkupTab = `VariantMarkup${item.VariantName}`;

    // form.setFieldsValue({
    //   [VariantRetailPriceTab]: finalRetailPrice + parseFloat(finalTax),
    // });
    form.setFieldsValue({
      [VariantRetailPriceTab]: parseFloat(RetailPrice),
    });
    form.setFieldsValue({ [VariantMarkupTab]: finalMarkup });
    items[item.key] = item;
    setTableProductVariantdata(items);
  }
  function GetAttributeArrayLength(attrArray) {
    let allAttributData = attrArray ? attrArray : [];
    let attributeActualLength = 0;
    for (let i = 0; i < allAttributData.length; i++) {
      attributeActualLength += allAttributData[i]
        ? allAttributData[i].length > 0
          ? 1
          : 0
        : 0;
    }
    return attributeActualLength;
  }
  function VariantProductOnlyTaxCalculator(
    variantSelectedTaxID,
    paramRP,
    paramSP,
    salesTaxes,
    defaultSaleTax,
    salesGroupTaxes
  ) {
    let SupplyPrice = parseFloat(paramSP).toFixed(getDefaultDecimalPlaces);
    let RetailPrice = parseFloat(paramRP).toFixed(getDefaultDecimalPlaces);
    let taxObj = {};
    let preTaxPrice = RetailPrice;
    if (variantSelectedTaxID == "0") {
      //Default Tax Selected
      let obj =
        defaultSalesTaxID !== ""
          ? salesTaxes.filter((x) => x.id == defaultSalesTaxID)[0]
          : salesTaxes[0];

      taxObj = {
        id: obj.id,
        label: obj.label,
        taxPercentage: obj.taxPercentage,
      };
    } else {
      taxObj = salesTaxes.filter((x) => x.id == variantSelectedTaxID)[0];
    }
    const getTotalTaxDataPrice = GetCummulativeTaxDatabyTaxID(
      variantSelectedTaxID,
      salesTaxes,
      salesGroupTaxes
    );
    RetailPrice = parseFloat(RetailPrice);
    // RetailPrice += getTotalTaxDataPrice.totalFixedTax;

    let taxPercentageValue =
      parseFloat(getTotalTaxDataPrice.totalTaxPercentage) / 100;
    let finalTax = parseFloat(RetailPrice * taxPercentageValue);
    finalTax += getTotalTaxDataPrice.totalFixedTax;

    let finalMarkup = ((preTaxPrice - SupplyPrice) / SupplyPrice) * 100;
    let displayPriceObj = {
      taxID: taxObj.id,
      taxName: taxObj.label,
      taxPrice: parseFloat(finalTax),
      markUp: finalMarkup,
    };
    return displayPriceObj;
  }
  async function AddDeleteProductVariant() {
    let allAttributeValue = [];
    // var option1 = form.getFieldValue("AttributeValues0");
    // allAttributeValue.push(option1);
    attributeOptionsRows.map((obj) => {
      if (form.getFieldValue("AttributeValues" + obj.Key) != undefined) {
        allAttributeValue.push(form.getFieldValue("AttributeValues" + obj.Key));
      }
    });
    //console.log("All attribute Values", allAttributeValue);
    let variantCombinations = getvariantCombinatiosn(
      allAttributeValue.filter((e) => e.length)
    );
    //console.log("variantCombinations", variantCombinations);
    let variantCombinationsArray = getvariantCombinatiosn(
      allAttributeValue.filter((e) => e.length)
    );
    //console.log("variantCombinationsArray", variantCombinationsArray);
    let supplyPrice = form.getFieldValue("SupplyPrice")
      ? form.getFieldValue("SupplyPrice")
      : "0";
    let retailPrice = form.getFieldValue("RetailPrice");

    let markUp = form.getFieldValue("Markup")
      ? form.getFieldValue("Markup")
      : "0";
    let taxName = getDisplayPriceWithName.taxName; //getDefaultOutletTaxes[0].saleTaxName;
    let taxPrice = getIsTaxExclusive
      ? parseFloat("0").toFixed(getDefaultDecimalPlaces)
      : getDisplayPriceWithName.taxPrice;
    let loyaltyPoints = getLoyaltyPoints ? getLoyaltyPoints : "0";
    let removeVariantCombinations = RemoveVariantCombinations;
    let allAttributeActualLength = GetAttributeArrayLength(allAttributeValue);
    let secondaryData = TableProductVariantdata.filter(
      (obj) => !removeVariantCombinations.includes(obj.VariantName)
    );

    removeVariantCombinations = removeVariantCombinations.filter((x) =>
      variantCombinations.includes(x)
    );

    if (removeVariantCombinations.length > 0 && allAttributeActualLength > 0) {
      if (allAttributeActualLength == 1) {
        removeVariantCombinations =
          removeVariantCombinations &&
          removeVariantCombinations.map((x) => {
            let xSplitVariantName =
              x != undefined ? x.toString().split("/") : [];
            let newRemoveVariantName = xSplitVariantName[0];
            return newRemoveVariantName;
          });
      }
      if (allAttributeActualLength == 2) {
        removeVariantCombinations =
          removeVariantCombinations &&
          removeVariantCombinations.map((x) => {
            let xSplitVariantName =
              x != undefined ? x.toString().split("/") : [];
            let newRemoveVariantName = "";
            if (xSplitVariantName.length == 1) {
              newRemoveVariantName = x + "/" + allAttributeValue[1][0];
            }
            if (xSplitVariantName.length == 2) {
              newRemoveVariantName = x;
            }
            if (xSplitVariantName.length == 3) {
              newRemoveVariantName =
                xSplitVariantName[0] + "/" + xSplitVariantName[2];
            }
            return newRemoveVariantName;
          });
      }
      if (allAttributeActualLength == 3) {
        removeVariantCombinations =
          removeVariantCombinations &&
          removeVariantCombinations.map((x) => {
            let xSplitVariantName =
              x != undefined ? x.toString().split("/") : [];
            let newRemoveVariantName = "";
            if (xSplitVariantName.length == 2) {
              newRemoveVariantName = x + "/" + allAttributeValue[2][0];
            }
            if (xSplitVariantName.length == 3) {
              newRemoveVariantName = x;
            }

            return newRemoveVariantName;
          });
      }
    }

    if (removeVariantCombinations && removeVariantCombinations.length > 0) {
      variantCombinationsArray = variantCombinationsArray.filter(
        (el) => !removeVariantCombinations.includes(el)
      );
    }

    if (secondaryData) {
      if (secondaryData.length > 0) {
        if (secondaryData.length <= variantCombinationsArray.length) {
          for (let i = 0; i < secondaryData.length; i++) {
            let tableProductObj = secondaryData[i];
            if (tableProductObj) {
              let tableVariantName = tableProductObj.VariantName;
              let VariantNameSplitArray = tableVariantName
                ? tableVariantName.split("/")
                : [];
              let VariantCombinationSplitArray = variantCombinationsArray[i]
                ? variantCombinationsArray[i].split("/")
                : [];
              let isValidVariant = false;
              if (VariantNameSplitArray && VariantCombinationSplitArray) {
                let nameSplitLength =
                  allAttributeActualLength > VariantNameSplitArray.length
                    ? allAttributeActualLength - 1
                    : allAttributeActualLength;
                for (let j = 0; j < nameSplitLength; j++) {
                  if (
                    VariantCombinationSplitArray[j] == VariantNameSplitArray[j]
                  ) {
                    isValidVariant = true;
                  } else {
                    isValidVariant = false;
                  }
                }
              }
              if (isValidVariant) {
                tableProductObj.VariantName = variantCombinationsArray[i];
                secondaryData[i] = tableProductObj;
              }
            }
          }
        }
      }
    }

    ////;
    // setTableProductVariantdataSecondary(TableProductVariantdata);

    let variantColumnData = [];
    if (secondaryData.length > 0) {
      for (let i = 0; i <= variantCombinationsArray.length - 1; i++) {
        let variantName = variantCombinationsArray[i];
        let secondaryDataObj =
          secondaryData &&
          secondaryData.filter(
            (x) =>
              removeSpacewithLowerCaseString(x.VariantName) ===
              removeSpacewithLowerCaseString(variantName)
          )[0];
        if (secondaryDataObj) {
          let variantColumnUpdatedData = {
            key: i,
            VariantName: variantName,
            VariantImageURL:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantImageURL
                : "",
            VariantProductID:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantProductID
                : "",
            VariantSKU:
              secondaryDataObj != undefined ? secondaryDataObj.VariantSKU : "",
            VariantSupplierCode:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantSupplierCode
                : "",
            VariantSupplyPrice:
              secondaryDataObj != undefined
                ? secondaryDataObj.IsSupplyPriceChange
                  ? secondaryDataObj.VariantSupplyPrice
                  : supplyPrice
                : supplyPrice,
            VariantRetailPrice:
              secondaryDataObj != undefined
                ? secondaryDataObj.IsRetailPriceChange
                  ? secondaryDataObj.VariantRetailPrice
                  : retailPrice
                : retailPrice,
            VariantEnabled:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantEnabled
                : true,
            VariantMarkup:
              secondaryDataObj != undefined
                ? secondaryDataObj.IsRetailPriceChange ||
                  secondaryDataObj.IsSupplyPriceChange
                  ? secondaryDataObj.VariantMarkup
                  : markUp
                : markUp,
            VariantIsCustomLoyalty:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantIsCustomLoyalty
                : false,
            VariantCustomLoyaltyPrice:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantCustomLoyaltyPrice
                : "",
            IsSupplyPriceChange:
              secondaryDataObj != undefined
                ? secondaryDataObj.IsSupplyPriceChange
                : false,
            IsRetailPriceChange:
              secondaryDataObj != undefined
                ? secondaryDataObj.IsRetailPriceChange
                : false,
            VariantTaxName:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantTaxName
                : "",
            VariantTaxPrice:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantTaxPrice
                : "",
            VariantLoyaltyPoints:
              secondaryDataObj != undefined
                ? secondaryDataObj.VariantLoyaltyPoints
                : "0",
          };
          variantColumnData.push(variantColumnUpdatedData);
        } else {
          let variantNewColumnData = {
            key: i,
            VariantProductID: "",
            VariantName: variantName,
            VariantImageURL: "",
            VariantSKU: "",
            VariantSupplierCode: "",
            VariantSupplyPrice: supplyPrice,
            VariantRetailPrice: retailPrice,
            VariantEnabled: true,
            VariantMarkup: markUp,
            VariantIsCustomLoyalty: false,
            VariantCustomLoyaltyPrice: "0",
            IsSupplyPriceChange: false,
            IsRetailPriceChange: false,
            VariantTaxPrice: taxPrice,
            VariantTaxName: taxName,
            VariantLoyaltyPoints: loyaltyPoints,
          };
          variantColumnData.push(variantNewColumnData);
        }
      }
    } else {
      variantColumnData = variantCombinations.map((obj, index) => {
        return {
          key: index,
          VariantProductID: "",
          VariantName: obj,
          VariantImageURL: "",
          VariantSKU: "",
          VariantSupplierCode: "",
          VariantSupplyPrice: supplyPrice,
          VariantRetailPrice: retailPrice,
          VariantEnabled: true,
          VariantMarkup: markUp,
          VariantIsCustomLoyalty: false,
          VariantCustomLoyaltyPrice: "0",
          IsSupplyPriceChange: false,
          IsRetailPriceChange: false,
          VariantTaxPrice: taxPrice,
          VariantTaxName: taxName,
          VariantLoyaltyPoints: loyaltyPoints,
        };
      });
    }

    let tempDataStore = [];

    for (let k = 0; k < variantColumnData.length; k++) {
      ////;
      let mapped = [];
      let variantOutletsData = tableDataVariantStoreOutlets;

      if (variantOutletsData[k] != undefined) {
        mapped = variantOutletsData[k].map((storeOutlet) => {
          return {
            key: getRandomInt(100000000),
            OutletID: storeOutlet.OutletID,
            OutletName: storeOutlet.OutletName,
            CurrentInventory: storeOutlet.CurrentInventory,
            ReOrderPoint: storeOutlet.ReOrderPoint,
            ReOrderQuantity: storeOutlet.ReOrderQuantity,
            Tax: storeOutlet.Tax,
          };
        });
      } else {
        mapped =
          variantOutletsData[0] &&
          variantOutletsData[0].map((storeOutlet) => {
            return {
              key: getRandomInt(100000000),
              OutletID: storeOutlet.OutletID,
              OutletName: storeOutlet.OutletName,
              CurrentInventory: "0",
              ReOrderPoint: "0",
              ReOrderQuantity: "0",
              Tax: "0",
            };
          });
      }

      tempDataStore.push(mapped);
    }
    setTableDataVariantStoreOutlets(tempDataStore);

    let tempSKUData = [];
    let tempBatchData = [];
    for (let k = 0; k < variantColumnData.length; k++) {
      ////;
      let mapped = [];
      let batchMapped = [];
      let variantSKUData = getVariantSKURows;
      let variantBatchData = getVariantBatchesRows;

      if (variantSKUData[k] != undefined) {
        mapped = variantSKUData[k];
      } else {
        let bodySKu = {
          ProductName: [""],
        };
        let generateSKU = await getReturnAutoGeneratedSKU(bodySKu);
        mapped = [
          {
            Key: 0,
            SKUID: generateSKU[0] != undefined ? generateSKU[0].skuid : "",
            SKUTypeID: 1,
            SKUValue:
              generateSKU[0] != undefined ? generateSKU[0].skuValue : "",
            IsUnique: true,
            RecordID: "0",
            IsRemove: false,
          },
        ];
      }

      if (variantBatchData[k] != undefined) {
        batchMapped = variantBatchData[k];
      } else {
        batchMapped = [
          // {
          //   Key: 0,
          //   BatchID: 0,
          //   BatchCode: "",
          //   BatchQuantity: 0,
          //   BatchExpiryDate: moment(),
          //   RecordID: "0",
          //   IsRemove: false,
          //   IsUnique: true,
          //   OutletID: "",
          //   BatchManufacturingDate: moment(),
          // },
        ];
      }

      tempSKUData.push(mapped);
      tempBatchData.push(batchMapped);
    }
    setVariantSKURows(tempSKUData);
    setVariantBatchesRows(tempBatchData);

    setRemoveVariantCombinations(removeVariantCombinations);
    if (RemoveVariantCombinations.length > 0) {
      setTableProductVariantdata(
        variantColumnData.filter(
          (obj) => !RemoveVariantCombinations.includes(obj.VariantName)
        )
      );
    } else {
      setTableProductVariantdata(variantColumnData);
    }
  }

  function getRemoveVariantCombinationsName(
    existingCombinations,
    attributesValues
  ) {
    let removeVariantCombinations = [];
    if (attributesValues.length > 0 && existingCombinations.length > 0) {
      let variantCombinationsArray = getvariantCombinatiosn(
        attributesValues.filter((e) => e.length)
      );
      removeVariantCombinations = variantCombinationsArray.filter(
        (el) => !existingCombinations.includes(el)
      );
    }
    return removeVariantCombinations;
  }
  const AddDeleteVariantAttributeOption = (event, isRemove, id) => {
    // if(attributeOptionCount <=3){
    //     setAttributeOptionCount(attributeOptionCount+1);
    // }

    let temp = "";

    if (isRemove) {
      temp = attributeOptionsRows;
      // ;
      if (temp != undefined) {
        setAttributeOptionsRows(temp.filter((a) => a.Key !== id));
        form.setFieldsValue({ ["AttributeValues" + id]: [] });
      }
      AddDeleteProductVariant();
    } else {
      let temp1 = attributeOptionsRows;
      if (temp1 != undefined) {
        setAttributeOptionsRows(
          temp1.concat({
            Key: temp1.slice(-1)[0].Key + 1,
            value: temp1.slice(-1)[0].Key + 1,
          })
        );
      }
    }
  };
  const AddDeleteSKUCodeTypeOption = (event, isRemove, id, recordID) => {
    let temp = "";
    if (isRemove) {
      temp = getSKUTypeOptionsRows;
      // ;
      if (temp != undefined) {
        if (recordID != "0") {
          let temp2 = temp.filter((obj) => obj.Key == id)[0];
          temp2.IsRemove = true;
          setSKUTypeOptionsRows(temp);
        } else {
          setSKUTypeOptionsRows(temp.filter((a) => a.Key !== id));
        }
        //form.setFieldsValue({ ["AttributeValues" + id]: [] });
      }
    } else {
      let temp1 = getSKUTypeOptionsRows;
      if (temp1 != undefined) {
        setSKUTypeOptionsRows(
          temp1.concat({
            Key: temp1.slice(-1)[0].Key + 1,
            SKUTypeID: temp1.slice(-1)[0].SKUTypeID + 1,
            SKUValue: "",
            IsUnique: true,
            RecordID: "0",
            IsRemove: false,
          })
        );
      }
    }
  };
  const AddDeleteProductBatchesOption = (event, isRemove, id, batchID) => {
    let temp = "";
    if (isRemove) {
      temp = getProductBatchesOptionsRows;
      // ;
      if (temp != undefined) {
        if (batchID != 0) {
          onClickBatchDelete(batchID);
          let productBatchesData = getProductBatchesOptionsRows.filter(
            (x) => x.BatchID != batchID
          );
          setProductBatchesOptionsRows(productBatchesData);
        } else {
          setProductBatchesOptionsRows(temp.filter((a) => a.Key !== id));
        }
      }
    } else {
      let temp1 = getProductBatchesOptionsRows;
      if (temp1 != undefined && temp1.length > 0) {
        setProductBatchesOptionsRows(
          temp1.concat({
            Key: temp1.slice(-1)[0].Key + 1,
            BatchID: "",
            BatchCode: "",
            BatchQuantity: "",
            BatchExpiryDate: moment().format(dateFormat),
            RecordID: "0",
            IsRemove: false,
            IsUnique: true,
            OutletID: "",
            BatchManufacturingDate: moment().format(dateFormat),
          })
        );
      } else {
        setProductBatchesOptionsRows(
          temp1.concat({
            Key: 0,
            BatchID: "",
            BatchCode: "",
            BatchQuantity: "",
            BatchExpiryDate: moment().format(dateFormat),
            RecordID: "0",
            IsRemove: false,
            IsUnique: true,
            OutletID: "",
            BatchManufacturingDate: moment().format(dateFormat),
          })
        );
      }
    }
  };
  const AddDeleteVariantProductBatchesOption = (
    event,
    isRemove,
    id,
    batchID,
    index
  ) => {
    let variantBatchesData = [...getVariantBatchesRows];
    let VariantBatchesCurrentIndexData = getVariantBatchesRows[index];

    if (VariantBatchesCurrentIndexData != undefined) {
      if (isRemove) {
        if (batchID != 0) {
          onClickBatchDelete(batchID);
          variantBatchesData[index] = VariantBatchesCurrentIndexData.filter(
            (obj) => obj.BatchID != batchID
          );
          setVariantBatchesRows(variantBatchesData);
        } else {
          variantBatchesData[index] = VariantBatchesCurrentIndexData.filter(
            (obj) => obj.Key != id
          );
          setVariantBatchesRows(variantBatchesData);
        }
      } else {
        variantBatchesData[index] = VariantBatchesCurrentIndexData.concat({
          Key:
            VariantBatchesCurrentIndexData &&
            VariantBatchesCurrentIndexData.length > 0
              ? VariantBatchesCurrentIndexData.slice(-1)[0].Key + 1
              : 0,
          BatchID: "",
          BatchCode: "",
          BatchQuantity: "",
          BatchExpiryDate: moment().format(dateFormat),
          RecordID: "0",
          IsRemove: false,
          IsUnique: true,
          OutletID: "",
          BatchManufacturingDate: moment(),
        });

        setVariantBatchesRows(variantBatchesData);
      }
    }
  };

  const AddDeleteVariantSKUCodeTypeOption = (
    event,
    isRemove,
    id,
    recordID,
    index
  ) => {
  
    let variantSKUData = [...getVariantSKURows];
    let VariantSKUCurrentIndexData = getVariantSKURows[index];

    if (VariantSKUCurrentIndexData != undefined) {
      if (isRemove) {
        if (recordID != "0") {
          let updatedCurrentSKUData = VariantSKUCurrentIndexData.filter(
            (obj) => obj.Key == id
          )[0];
          updatedCurrentSKUData.IsRemove = true;

          variantSKUData[index] = updatedCurrentSKUData;
          setVariantSKURows(variantSKUData);
        } else {
          variantSKUData[index] = VariantSKUCurrentIndexData.filter(
            (a) => a.Key !== id
          );
          setVariantSKURows(variantSKUData);
        }
      } else {
        variantSKUData[index] = VariantSKUCurrentIndexData.concat({
          Key: VariantSKUCurrentIndexData.slice(-1)[0].Key + 1,
          SKUTypeID: VariantSKUCurrentIndexData.slice(-1)[0].SKUTypeID + 1,
          SKUValue: "",
          IsUnique: true,
          RecordID: "0",
          IsRemove: false,
        });
        setVariantSKURows(variantSKUData);
      }
    }
  };
  const RestoreVariantProduct = () => {
    let temp = RemoveVariantCombinations;
    temp.length = 0;
    setRemoveVariantCombinations(temp);
    AddDeleteProductVariant();
  };
  //FormSaveUpdateDeleteFuntions
  const onFinishFailed = (errorInfo) => {
    //let productNameValidation = <IntlMessages id="products.main.add.namemessage" />;

    // message.error("Please select product name");
    const errors = errorInfo.errorFields.map((err) => err.errors[0]);
    setErrorMessages(errors);
  };

  async function createUpdateProduct(values) {
    //Outlet Inventory Array form start

    if (productInventoryType == 1) {
      if (TableProductVariantdata.length == 0) {
        //let oneVariantMessage = <IntlMessages id="products.main.add.selectatleastonevariant" />;
        message.error("Select atleast one variant");
        return false;
      }
    }
    if (productInventoryType == 2) {
      if (getTableCompositeProductData.length == 0) {
        //let oneVariantMessage = <IntlMessages id="products.main.add.selectatleastonevariant" />;
        message.error("Select atleast one Product in Composite");
        return false;
      }
    }

    SetisLoading(true);
    let pKeys = tableDataStoreOutlets.map((obj) => {
      return { keys: obj.key, OutletID: obj.OutletID };
    });
    let OutletInventoryData = [];
    let OutletTaxData = [];
    let variantAttribute = [];
    let productVariant = [];
    let productSKUs = [];
    let productBatches = [];
    let CompositeProductData = [];

    for (let i = 0; i < pKeys.length; i++) {
      let key = pKeys[i].keys;
      let valueArray = [];
      let prodObj = {};
      let prodObjTax = {};

      valueArray = Object.entries(values);
      valueArray.forEach(outletInventory);

      function outletInventory(value) {
        if (value[0].includes(key)) {
          let vKey = value[0];
          let vValue = value[1];
          let OutletId = tableDataStoreOutlets.filter((a) => a.key === key);

          prodObj.OutletID = OutletId[0].OutletID;
          prodObjTax.OutletID = OutletId[0].OutletID;

          if (vKey.includes(`CurrentInventory${key}`)) {
            prodObj.CurrentInventory = vValue;
          } else if (vKey.includes(`ReOrderPoint${key}`)) {
            prodObj.ReOrderPoint = vValue;
          } else if (vKey.includes(`ReOrderQuantity${key}`)) {
            prodObj.ReOrderQuantity = vValue;
          } else if (vKey.includes(`Tax${key}`)) {
            prodObjTax.Tax = vValue;
          }
        }
      }

      OutletInventoryData.push(prodObj);
      OutletTaxData.push(prodObjTax);
    }
    if (!getIsTaxExclusive) {
      OutletTaxData.forEach((x) => (x.Tax = getTaxID));
    }
    //General Data  Prepare
    let productTags =
      values.ProductTags &&
      values.ProductTags.map((obj) => {
        return {
          key: obj.toString(),
        };
      });

    const formData = new FormData();
    //Loop through each of the selected files.
    var newFiles = fileList && fileList.filter((x) => !x.url);
    for (let i = 0; i < newFiles.length; i++) {
      var file = newFiles[i].originFileObj;
      // Add the file to the request.
      formData.append("file", file);
    }

    //Standard Product
    if (productInventoryType == 0) {
      productSKUs = getSKUTypeOptionsRows;
      productBatches =
        getProductBatchesOptionsRows &&
        getProductBatchesOptionsRows.filter((x) => x.BatchID == 0);
    }
    //This is for Variant Product Data
    if (productInventoryType == 1) {
      for (let i = 0; i < attributeOptionsRows.length; i++) {
        if (attributeOptionsRows.length != 0) {
          let attrObj = {};
          let valueArray = [];

          valueArray = Object.entries(values);
          valueArray.forEach(attributeOptionandValues);
          function attributeOptionandValues(value) {
            let vKey = value[0];
            let vValue = value[1];
            if (vKey == "Attributes" + i) {
              if (vValue.includes("&&")) {
                ////;
                var splitAttribute = vValue.split("&&");
                var newValueAttribute = splitAttribute[1];
                attrObj.VariantAttribute_Key = newValueAttribute;
                attrObj.IsNew = true;
              } else {
                attrObj.VariantAttribute_Key = vValue;
                attrObj.IsNew = false;
              }
            }
            if (vKey == "AttributeValues" + i) {
              attrObj.VariantAttribute_Value = vValue.join(",");
            }
          }

          variantAttribute.push(attrObj);
        }
      }

      for (let j = 0; j < TableProductVariantdata.length; j++) {
        //
        let productVariantObj = {};
        productVariantObj.VariantKey = TableProductVariantdata[j].key;
        productVariantObj.ProductID =
          TableProductVariantdata[j].VariantProductID;
        productVariantObj.VariantName = TableProductVariantdata[j].VariantName;
        productVariantObj.IsActiveProduct =
          TableProductVariantdata[j].VariantEnabled;
        productVariantObj.IsCustomSKU = InvSKURadioButton == 1 ? false : true;
        productVariantObj.CustomSKUCode = TableProductVariantdata[j].VariantSKU;
        productVariantObj.SupplyPrice =
          TableProductVariantdata[j].VariantSupplyPrice;
        productVariantObj.SupplierID = values.SupplierID;
        productVariantObj.SupplierCode =
          TableProductVariantdata[j].VariantSupplierCode;
        productVariantObj.RetailPrice = getIsTaxExclusive
          ? TableProductVariantdata[j].VariantRetailPrice
          : parseFloat(TableProductVariantdata[j].VariantRetailPrice) -
            parseFloat(TableProductVariantdata[j].VariantTaxPrice);
        productVariantObj.MarkupInPercentage =
          TableProductVariantdata[j].VariantMarkup.toString();
        productVariantObj.IsCustomLoyalty =
          TableProductVariantdata[j].VariantIsCustomLoyalty;
        productVariantObj.LoyaltyPrice =
          TableProductVariantdata[j].VariantCustomLoyaltyPrice;

        let productVariantInventories = tableDataVariantStoreOutlets[j].map(
          (obj) => {
            return {
              OutletID: obj.OutletID,
              CurrentInventory: obj.CurrentInventory,
              ReOrderPoint: obj.ReOrderPoint,
              ReOrderQuantity: obj.ReOrderQuantity,
            };
          }
        );
        let productVariantTax = tableDataVariantStoreOutlets[j].map((obj) => {
          return {
            OutletID: obj.OutletID,
            Tax: obj.Tax,
          };
        });

        productVariantObj.OutletInventories = productVariantInventories;
        productVariantObj.OutletTaxes = productVariantTax;
        productVariantObj.ProductSKUs = getVariantSKURows[j];

        productVariantObj.ProductBatchesData = getVariantBatchesRows[j].filter(
          (x) => x.BatchID == 0
        );
        productVariant.push(productVariantObj);
      }
      var variantFiles =
        getVariantImages && getVariantImages.filter((x) => !x.url);
      for (let j = 0; j < variantFiles.length; j++) {
        var file = variantFiles[j].originFileObj;
        formData.append("variantFile" + variantFiles[j].key, file);
      }
    }

    //Composite Product
    if (productInventoryType == 2) {
      CompositeProductData = getTableCompositeProductData.map((obj) => {
        return {
          ProductID: obj.ProductID,
          Quantity: obj.CompositeProductQuantity.toString(),
        };
      });
      productSKUs = getSKUTypeOptionsRows;
    }
    //
    let ProductImagesEdit =
      getDeletedImages &&
      getDeletedImages
        .filter((x) => x.uid && !x.uid.toString().includes("__AUTO__"))
        .map((obj) => {
          //__AUTO__ because sometime delete contains empty objects
          return {
            ID: obj.uid,
            ImageURL: obj.url,
          };
        });
    ////;

    formData.append(
      "MainProduct",
      JSON.stringify({
        ProductID: isDuplicate ? "0&&_bd98-6131-47dd-8ac8-4bd1856d2a60" : productID,
        ProductName: values.Name,
        BrandID: values.BrandID != "" ? values.BrandID : 0,
        Description: descriptionContent,
        ProductTags: productTags,
        ProductType: values.ProductType,
        IsActiveProduct: isSellOnPOS,
        ProductImagesEdit: ProductImagesEdit,
        ProductInventoryType: productInventoryType.toString(),
        IsCustomSKU: InvSKURadioButton == 1 ? false : true,
        CustomSKUCode: values.CustomSKU,
        SupplierID: values.SupplierID,
        SupplierCode: values.SupplierCode,
        SupplyPrice: values.SupplyPrice,
        IsProductInventory: getIsProductInventory,
        OutletInventories: OutletInventoryData,
        OutletTaxes: OutletTaxData,
        CompositeProductsData: CompositeProductData,
        MarkupInPercentage:
          values.Markup != undefined ? values.Markup.toString() : "0", //values.Markup != undefined ? values.Markup.split("%")[0] : "0",
        RetailPrice: getIsTaxExclusive
          ? values.RetailPrice
          : parseFloat(values.RetailPrice) -
            parseFloat(getDisplayPriceWithName.taxPrice), //because we base supply and retail price with markup percentage
        IsCustomLoyalty: PLoyaltyRadioButton == 1 ? false : true,
        LoyaltyPrice: values.CustomLoyalty,
        ProductSKUs: productSKUs,
        ProductVariants: productVariant,
        VariantAttributes: variantAttribute,
        NoOfVariants:
          TableProductVariantdata != undefined
            ? TableProductVariantdata.length.toString()
            : "0",
        ProductBatchesData: productBatches,
        // ExpireDate:
        //   values.ExpireDate !== undefined
        //     ? values.ExpireDate.format(dateFormat)
        //     : undefined,
      })
    );

    SetisRegistering({ isRegistering: true });
    let addUpdateDeleteProduct = {
      data: {
        msgCode: "",
        msgDescription: "",
      },
    };
    const methType =
      formData.MainProduct && formData.MainProduct.IsRemove
        ? BEHAVIOUR_TYPE.DELETE
        : methodType;
    await ds
      .addUpdateDeleteProduct(formData, methType) // NOTE: delete option recheck cause not availble this time
      .then((response) => {
        addUpdateDeleteProduct.data = response.data;
      })
      .catch((e) => notAllowMsgCheck(e));

    if (addUpdateDeleteProduct.data.msgCode == "GENERAL_SUCCESS") {
      message.success(addUpdateDeleteProduct.data.msgDescription + " Product");
      let newproduct = [];
      if (!isEmptyObject(addUpdateDeleteProduct.data.data)) {
        newproduct.push(addUpdateDeleteProduct.data.data);

        if (
          addUpdateDeleteProduct.data.data.variantProductReturnList &&
          addUpdateDeleteProduct.data.data.variantProductReturnList.length > 0
        ) {
          newproduct.push(
            addUpdateDeleteProduct.data.data.variantProductReturnList
          );
        }
      }
      if (newproduct && newproduct.length > 0) {
        saveProductsToIndexedDB(newproduct.flat());
      }

      SetisRegistering({ isRegistering: false });
      setTimeout(() => {
        history.push("/Dashboard/products/main");
      }, 2000);
    }

    if (addUpdateDeleteProduct.data.msgCode == "GENERAL_ERROR") {
      message.error(addUpdateDeleteProduct.data.msgDescription);
      history.push("/Dashboard/products/main");
    }
  }
  const onFinish = async (values) => {
    createUpdateProduct(values);
  };
  //Funtions End
  const handleChangeSKUType = (event, Key) => {
    let skuTypeID = event;
    if (skuTypeID == 1) {
      //send api  for generate sku
      let bodySKu = {
        ProductName: [""],
      };
      getAutoGeneratedSKU(bodySKu);
    }
    let optionRows = getSKUTypeOptionsRows;
    if (optionRows.filter((e) => e.Key == Key)[0] != undefined) {
      optionRows.filter((e) => e.Key == Key)[0].SKUTypeID = skuTypeID;
      setSKUTypeOptionsRows(optionRows);
    }
  };
  const handleChangeSKUCodeValue = async (event, Key, skuTypeID) => {
    //;
 
    let skuValue = event.target.value;
    let GeneralSKUData = [...getSKUTypeOptionsRows];
    let skuType = skuTypeID == 1 ? 2 : skuTypeID; //1 for AutoGenerated , 2 For custom. If someone change value auto generated converted to Custom SKU

    if (skuValue != "" && skuValue != undefined && skuValue != null) {
      if (
        GeneralSKUData.filter((e) => e.SKUValue == skuValue).length != 0 &&
        GeneralSKUData.filter((e) => e.SKUValue == skuValue)[0] != undefined
      ) {
        let relatedSKURow = GeneralSKUData.filter((e) => e.SKUValue == skuValue)[0]; // wo row hy jisme ye value find hwi hy
        if(relatedSKURow.Key != Key){
          // relatedSKURow.IsUnique = false;
          let currentSKURow = GeneralSKUData.filter((e) => e.Key == Key)[0]; //Jis row pr change hwi hy sku ki value
          currentSKURow.SKUValue = skuValue;
          currentSKURow.IsUnique = false;
          currentSKURow.SKUTypeID = skuType;
          currentSKURow.SKUID = ""; //It's for Edit Case Removce SKUID if someone change code
          setSKUTypeOptionsRows(GeneralSKUData);
        }

      } else {
        let bodyCheckSKU = {
          SKUCode: skuValue,
          ProductID : !isAddMode ? productID : ""
        };
        const isAvailableObj = await getCheckSKUAvailibility(bodyCheckSKU);

        let currentSKURow = GeneralSKUData.filter((e) => e.Key == Key)[0];

        currentSKURow.SKUValue = isAvailableObj.skuValue;
        currentSKURow.IsUnique = isAvailableObj.isAvailable;
        currentSKURow.SKUTypeID = skuType;
        currentSKURow.SKUID = isAvailableObj.skuid; //It's for Edit Case Removce SKUID if someone change code
        setSKUTypeOptionsRows(GeneralSKUData);
      }
    }
  };

  const handleChangeBatchesInput = async (
    event,
    Key,
    batchID,
    batchInputType
  ) => {
    let inputValue = event;
    let productBatchesData = [...getProductBatchesOptionsRows];

    if (
      productBatchesData &&
      productBatchesData.length > 0 &&
      inputValue != "" &&
      inputValue != undefined &&
      inputValue != null &&
      batchInputType &&
      batchInputType != ""
    ) {
      let currentBatchRow = productBatchesData.filter((e) => e.Key == Key)[0];
      if (!isEmptyObject(currentBatchRow)) {
        if (batchInputType == "BatchCode") {
          currentBatchRow.BatchCode = inputValue.target.value;
        }
        if (batchInputType == "BatchQuantity") {
          currentBatchRow.BatchQuantity = inputValue.target.value;
        }
        if (batchInputType == "BatchExpiryDate") {
          currentBatchRow.BatchExpiryDate = moment(inputValue);
        }
        if (batchInputType == "BatchManufacturingDate") {
          currentBatchRow.BatchManufacturingDate = moment(inputValue);
        }
        if (batchInputType == "OutletID") {
          currentBatchRow.OutletID = inputValue;
        }

        setProductBatchesOptionsRows(productBatchesData);
      }
    }
  };

  const handleChangeVariantSKUType = async (event, Key, index) => {
    let skuTypeID = event;
    let variantSKUData = [...getVariantSKURows];
    let variantSKUCurrentIndexData = getVariantSKURows[index];

    if (skuTypeID == 1) {
      //send api  for generate sku
      let bodySKu = {
        ProductName: [""],
      };
      let generateSKU = await getReturnAutoGeneratedSKU(bodySKu);
      let filterVariantSKU = variantSKUCurrentIndexData.filter(
        (e) => e.Key == Key
      )[0];
      filterVariantSKU.SKUTypeID = 1;
      filterVariantSKU.SKUValue =
        generateSKU[0] != undefined ? generateSKU[0].skuValue : "";
      filterVariantSKU.SKUID =
        generateSKU[0] != undefined ? generateSKU[0].skuid : "";
      filterVariantSKU.IsUnique = generateSKU[0] != undefined ? true : false;
      variantSKUData[index] = variantSKUCurrentIndexData;
      setVariantSKURows(variantSKUData);
    }

    if (
      variantSKUCurrentIndexData.filter((e) => e.Key == Key)[0] != undefined
    ) {
      variantSKUCurrentIndexData.filter((e) => e.Key == Key)[0].SKUTypeID =
        skuTypeID;
      variantSKUData[index] = variantSKUCurrentIndexData;
      setVariantSKURows(variantSKUData);
    }
  };
  const handleChangeVariantSKUCodeValue = async (
    event,
    Key,
    skuTypeID,
    index,
    vProductID
  ) => {
 
    let skuValue = event.target.value;
    let variantSKUData = [...getVariantSKURows];
    let variantSKUCurrentIndexData = getVariantSKURows[index];

    let skuType = skuTypeID == 1 ? 2 : skuTypeID; //1 for AutoGenerated , 2 For custom. If someone change value auto generated converted to Custom SKU

    if (skuValue != "" && skuValue != undefined && skuValue != null) {
 
      const foundIndex = variantSKUData.findIndex(innerArray => 
        innerArray.some(item => item.SKUValue === skuValue)
      );
    
      if (
        foundIndex !== -1 
      ) {
        let relatedSKURow = variantSKUCurrentIndexData.filter(
          (e) => e.SKUValue == skuValue
        )[0]; // wo row hy jisme ye value find hwi hy
     
        let logicBypass = foundIndex != index ? true : false; // Agr currentIndex (Variant ki row wala) wo nhi hy jisme value mili hy tw hamen relatedSKURow ki condition dekhny ki zarorat nhi bypass krd

        if(relatedSKURow && relatedSKURow.Key != Key || logicBypass){
          // relatedSKURow.IsUnique = false;
          let currentSKURow = variantSKUCurrentIndexData.filter(
            (e) => e.Key == Key
          )[0]; //Jis row pr change hwi hy sku ki value
          currentSKURow.SKUValue = skuValue;
          currentSKURow.IsUnique = false;
          currentSKURow.SKUTypeID = skuType;
          currentSKURow.SKUID = ""; //It's for Edit Case Removce SKUID if someone change code
          variantSKUData[index] = variantSKUCurrentIndexData;
          setVariantSKURows(variantSKUData);
        }

      } else {
        let currentSKURow = variantSKUCurrentIndexData.filter(
          (e) => e.Key == Key
        )[0];

        let bodyCheckSKU = {
          SKUCode: skuValue,
          ProductID: !isAddMode && vProductID || ""
        };
        const isAvailableObj = await getCheckSKUAvailibility(bodyCheckSKU);
    
        currentSKURow.SKUValue = isAvailableObj.skuValue;
        currentSKURow.IsUnique = isAvailableObj.isAvailable;
        currentSKURow.SKUTypeID = skuType;
        currentSKURow.SKUID = isAvailableObj.skuid; //It's for Edit Case Removce SKUID if someone change code
        variantSKUData[index] = variantSKUCurrentIndexData;
        setVariantSKURows(variantSKUData);
      }
    }
  };

  const handleChangeVariantBatchesInput = async (
    event,
    Key,
    batchID,
    batchInputType,
    index
  ) => {
    let inputValue = event;
    let productVariantBatchesData = [...getVariantBatchesRows];
    let variantBatchesCurrentIndexData = getVariantBatchesRows[index];

    if (
      variantBatchesCurrentIndexData &&
      variantBatchesCurrentIndexData.length > 0 &&
      inputValue != "" &&
      inputValue != undefined &&
      inputValue != null &&
      batchInputType &&
      batchInputType != ""
    ) {
      let currentVariantBatchRow = variantBatchesCurrentIndexData.filter(
        (e) => e.Key == Key
      )[0];
      if (!isEmptyObject(currentVariantBatchRow)) {
        if (batchInputType == "BatchCode") {
          currentVariantBatchRow.BatchCode = inputValue.target.value;
        }
        if (batchInputType == "BatchQuantity") {
          currentVariantBatchRow.BatchQuantity = inputValue.target.value;
        }
        if (batchInputType == "BatchExpiryDate") {
          currentVariantBatchRow.BatchExpiryDate =
            moment(inputValue).format(dateFormat);
        }
        if (batchInputType == "BatchManufacturingDate") {
          currentVariantBatchRow.BatchManufacturingDate =
            moment(inputValue).format(dateFormat);
        }
        if (batchInputType == "OutletID") {
          currentVariantBatchRow.OutletID = inputValue;
        }
        productVariantBatchesData[index] = variantBatchesCurrentIndexData;
        setVariantBatchesRows(productVariantBatchesData);
      }
    }
  };
  const SKUCodeTypeandValues = () => {
    return (
      <Row className="inventory-data-change sku-codes-div">
        <Col xl={12} lg={24} md={24} sm={24} xs={24} className="p-0">
          <Row className="md-display-none">
            <Col className="pl-0-device" lg={8} md={8} sm={24} xs={24}>
              <label>
                <IntlMessages id="products.main.add.skucodetype" />
              </label>
            </Col>

            <Col lg={16} md={16} sm={24} xs={24} className="md-pl-0">
              <label>
                <IntlMessages id="products.main.add.skucode" />
              </label>
            </Col>
          </Row>
          {getSKUTypeOptionsRows
            .filter((e) => e.IsRemove != true)
            .map((obj) => {
              return (
                <Row>
                  <Col className="pl-0-device" lg={8} md={8} sm={24} xs={24}>
                    <Form
                      initialValues={{
                        ["SKUCodeTypes" + obj.Key]: obj.SKUTypeID,
                      }}
                    >
                      <Form.Item
                        className="ant-form-item-label-custom"
                        name={"SKUCodeTypes" + obj.Key}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id="producs.main.add.selectskutype" />
                            ),
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Type"
                          onChange={(event) => {
                            handleChangeSKUType(event, obj.Key);
                          }}
                        >
                          {obj.Key == 0
                            ? getSKUCodeTypeOptions &&
                              getSKUCodeTypeOptions
                                .filter((j) => j.id == 1)
                                .map((e, key) => {
                                  return (
                                    <option key={key} value={e.id}>
                                      {e.label}
                                    </option>
                                  );
                                })
                            : ""}
                          {getSKUCodeTypeOptions &&
                            getSKUCodeTypeOptions
                              .filter((j) => j.id != 1)
                              .map((e, key) => {
                                return (
                                  <option key={key} value={e.id}>
                                    {e.label}
                                  </option>
                                );
                              })}
                        </Select>
                      </Form.Item>
                    </Form>
                  </Col>

                  <Col md={obj.Key == 0 ? 16 : 13} sm={20} xs={16} lg={13} className="md-pad-0">
                    {obj.Key == 0 && getIsAutoSKUCodeLoader ? (
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ fontSize: 24 }} spin />
                        }
                      >
                        <div>
                          <IntlMessages id="producs.main.add.skucodegenerating" />
                        </div>
                      </Spin>
                    ) : (
                      <Form
                        initialValues={{
                          ["SKUCodeTypeValue" + obj.Key]: obj.SKUValue,
                        }}
                        // validateTrigger="onBlur"
                      >
                        <Form.Item
                          className="ant-form-item-label-custom"
                          name={"SKUCodeTypeValue" + obj.Key}
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="producs.main.add.pleaseenterskucode1" />
                              ),
                            },
                          ]}
                          onFocus={handleFocus}
                          onBlur={(event) =>
                            handleChangeSKUCodeValue(
                              event,
                              obj.Key,
                              obj.SKUTypeID
                            )
                          }
                          help={
                            obj.IsUnique
                              ? ""
                              : "This SKU code already exists. Please enter a different one."
                          }
                          validateStatus={obj.IsUnique ? "" : "error"}
                        >
                          <Input placeholder="Enter a SKU Code" />
                        </Form.Item>
                      </Form>
                    )}
                  </Col>
                  {obj.Key != 0 ? (
                    <Col lg={3} md={3} sm={4} xs={8} className="md-pr-0">
                      <Button
                        className="Delete-btn-2"
                        onClick={(event) =>
                          AddDeleteSKUCodeTypeOption(
                            event,
                            true,
                            obj.Key,
                            obj.RecordID
                          )
                        }
                        icon={<DeleteOutlined />}
                        size={"middle"}
                        danger={true}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              );
            })}

          {getSKUTypeOptionsRows.length < 6 ? (
            <Button
              className="mb-4 dk-btn-add"
              type="primary"
              icon={<i className="icon icon-add-circle dk-pd-10" />}
              onClick={(event) => AddDeleteSKUCodeTypeOption(event, false, 0)}
              size="large"
            >
              <IntlMessages id="products.main.add.addanothercode" />
            </Button>
          ) : (
            ""
          )}
        </Col>

        <Col xl={12} lg={24} md={24} sm={24} xs={24} className="md-pad-0">
          <div>
            <h3>
              <IntlMessages id="products.promoadd.preview" />
            </h3>

            <Card>
              <div className="gx-media gx-align-items-center gx-mb-4">
                <div className="gx-mr-3">
                  {fileList != undefined && fileList != "" ? (
                    <Avatar
                      shape="square"
                      size={64}
                      className="dk-avatar-retrive-sale"
                      src={
                        fileList[0] != undefined
                          ? fileList[0].uid.toString().includes("rc-upload")
                            ? URL.createObjectURL(fileList[0].originFileObj)
                            : fileList[0].url
                          : ""
                      }
                    />
                  ) : (
                    <Avatar
                      shape="square"
                      size={64}
                      className="dk-avatar-retrive-sale"
                      src={Placeholder}
                    />
                  )}
                </div>
                <div className="gx-media-body">
                  <h3 className="gx-mb-1">
                    {form.getFieldValue("Name") != undefined
                      ? form.getFieldValue("Name")
                      : "Product Name"}
                  </h3>
                  <p className="gx-text-grey gx-mb-0">
                    {form.getFieldValue("SKUCodeTypeValue0") != undefined ? (
                      form.getFieldValue("SKUCodeTypeValue0")
                    ) : (
                      <IntlMessages id="producs.main.add.pleaseenterskucode" />
                    )}
                  </p>
                </div>
              </div>
              <Divider style={{ borderColor: "#bfbebe" }} />
              <p className="gx-mb-4">
                <IntlMessages id={"products.main.add.skucodepreviewdesc"} />
              </p>
            </Card>
          </div>
        </Col>
      </Row>
    );
  };
  const AttributeOptionandValues = (id) => {
    return (
      <div class="child-variant-div">
        <Row>
          <Col lg={8} md={8} sm={24} xs={24} className="pl-0-device">
            <Form.Item
              className="ant-form-item-label-custom"
              name={"Attributes" + id.id}
            >
              <Select
                placeholder="Select attribute"
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <Divider style={{ margin: "4px 0" }} />
                    <div
                      style={{
                        padding: 8,
                      }}
                    >
                      <Form.Item
                        className="custom-mg-left-0"
                        name="NewAttributeName"
                      >
                        <Input
                          /* placeholder="Enter product name"*/ style={{
                            width: "90%",
                          }}
                        />
                      </Form.Item>
                      <div className="add-attribute">
                        <a onClick={addAttributeItem}>
                          <PlusCircleFilled className="dk-vertically-align-middle" />{" "}
                          <IntlMessages id="products.main.add.addattribute" />
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              >
                {variantAttributeOptions &&
                  variantAttributeOptions.map((e, key) => {
                    return (
                      <option key={key} value={e.id}>
                        {e.label}
                      </option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>

          <Col md={id.id == 0 ? 13 : 13} sm={20} xs={16} lg={13} className="md-pad-0">
            <Form.Item
              className="ant-form-item-label-custom"
              name={"AttributeValues" + id.id}
            >
              <Select
                mode="tags"
                tokenSeparators={[","]}
                onChange={(event) => handleAttributeValueChange(event, id)}
              ></Select>
            </Form.Item>
          </Col>
          {id.id != 0 ? (
            <Col lg={3} md={3} sm={4} xs={8}>
<Button
                            className="Delete-btn-2"
                            onClick={(event) =>
                              AddDeleteVariantAttributeOption(event, true, id.id)
                            }
                            icon={<DeleteOutlined />}
                            size={"middle"}
                            danger={true}
                          />

             
            </Col>
          ) : (
            ""
          )}
        </Row>
      </div>
    );
  };
  const ExpandedRowRenderInventory = (props) => {
    const columnsInventoryRender = [
      {
        title: "Outlet",
        dataIndex: "OutletName",
        key: "OutletName",
      },
      {
        title: "Current Inventory",
        dataIndex: "CurrentInventory",
        key: "CurrentInventory",
        render: (text, record) => {
          function putCurrentInventory() {
            let CurrentInventory = `CurrentInventoryVariant${
              record.key + props.record.VariantName
            }`;
            if (record.CurrentInventory != undefined)
              form.setFieldsValue({
                [CurrentInventory]: record.CurrentInventory,
              });
          }
          putCurrentInventory();
          function onChangeCurrentInventory(value) {
            let rowKey = record.key;
            let supposedArr = tableDataVariantStoreOutlets[props.obj];
            supposedArr.filter((a) => a.key === rowKey)[0].CurrentInventory =
              value.target.value;
            // tableDataVariantStoreOutlets[props.obj] = supposedArr; alternative
            let temp = tableDataVariantStoreOutlets;
            temp[props.obj] = supposedArr;
            setTableDataVariantStoreOutlets(temp);
          }
          return (
            <Form
              form={form}
              name="ProductForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >
              <Form.Item
                name={`CurrentInventoryVariant${
                  record.key + props.record.VariantName
                }`}
                className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto "
              >
                <Input
                  onChange={onChangeCurrentInventory}
                  onFocus={handleFocus}
                  type="number"
                />
              </Form.Item>
            </Form>
          );
        },
      },
      {
        title: "Re-order Point",
        dataIndex: "ReOrderPoint",
        key: "ReOrderPoint",
        render: (text, record) => {
          function putReOrderPoint() {
            let ReOrderPointVariant = `ReOrderPointVariant${
              record.key + props.record.VariantName
            }`;
            if (record.ReOrderPoint != undefined)
              form.setFieldsValue({
                [ReOrderPointVariant]: record.ReOrderPoint,
              });
          }
          putReOrderPoint();
          function onChangeReorderPoint(value) {
            let rowKey = record.key;
            let supposedArr = tableDataVariantStoreOutlets[props.obj];
            supposedArr.filter((a) => a.key === rowKey)[0].ReOrderPoint =
              value.target.value;
            // tableDataVariantStoreOutlets[props.obj] = supposedArr; alternative
            let temp = tableDataVariantStoreOutlets;
            temp[props.obj] = supposedArr;
            setTableDataVariantStoreOutlets(temp);
          }
          return (
            <Form
              form={form}
              name="ProductForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >
              <Form.Item
                name={`ReOrderPointVariant${
                  record.key + props.record.VariantName
                }`}
                className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
              >
                <Input onChange={onChangeReorderPoint} type="number" />
              </Form.Item>
            </Form>
          );
        },
      },
      {
        title: "Re-order Quantity",
        dataIndex: "ReOrderQuantity",
        key: "ReOrderQuantity",
        render: (text, record) => {
          function putReOrderQuantity() {
            let ReOrderPointVariant = `ReOrderQuantityVariant${
              record.key + props.record.VariantName
            }`;
            if (record.ReOrderQuantity != undefined)
              form.setFieldsValue({
                [ReOrderPointVariant]: record.ReOrderQuantity,
              });
          }
          putReOrderQuantity();
          function onChangeReOrderQuantity(value) {
            let rowKey = record.key;
            let supposedArr = tableDataVariantStoreOutlets[props.obj];
            supposedArr.filter((a) => a.key === rowKey)[0].ReOrderQuantity =
              value.target.value;
            // tableDataVariantStoreOutlets[props.obj] = supposedArr; alternative
            let temp = tableDataVariantStoreOutlets;
            temp[props.obj] = supposedArr;
            setTableDataVariantStoreOutlets(temp);
          }
          return (
            <Form
              form={form}
              name="ProductForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >
              <Form.Item
                name={`ReOrderQuantityVariant${
                  record.key + props.record.VariantName
                }`}
                className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
              >
                <Input onChange={onChangeReOrderQuantity} type="number" />
              </Form.Item>
            </Form>
          );
        },
      },
    ];
    //console.log(tableDataVariantStoreOutlets[props.obj]);
    return (
      <Table
        className={`gx-table-responsive ${
          !props.isTrackInventory ? "custom-div-hide" : ""
        }`}
        columns={columnsInventoryRender}
        dataSource={tableDataVariantStoreOutlets[props.obj]}
        pagination={false}
      />
    );
  };
  const ExpandedRowRenderSKU = (props) => {
    return (
      <div class="child-variant-div">
        <Row>
          <Col md={12}>
            <Row>
              <Col md={8} sm={12}>
                <label>
                  <IntlMessages id="products.main.add.skucodetype" />
                </label>
              </Col>

              <Col md={16} sm={12}>
                <label>
                  <IntlMessages id="products.main.add.skucode" />
                </label>
              </Col>
            </Row>
            {getVariantSKURows && getVariantSKURows[props.index] &&
              getVariantSKURows[props.index]
                .filter((e) => e.IsRemove != true)
                .map((obj) => {
                  return (
                    <Row Key={obj.Key} className="dk-mg-lft-0">
                      <Col md={8} sm={12}>
                        <Form
                          initialValues={{
                            ["SKUCodeTypesVariant" +
                            obj.Key +
                            props.record.VariantName]: obj.SKUTypeID,
                          }}
                        >
                          <Form.Item
                            className="ant-form-item-label-custom"
                            name={
                              "SKUCodeTypesVariant" +
                              obj.Key +
                              props.record.VariantName
                            }
                            rules={[
                              {
                                required: true,
                                message: (
                                  <IntlMessages id="producs.main.add.selectskutype" />
                                ),
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Type"
                              onChange={(event) => {
                                handleChangeVariantSKUType(
                                  event,
                                  obj.Key,
                                  props.index
                                );
                              }}
                            >
                              {obj.Key == 0
                                ? getSKUCodeTypeOptions &&
                                  getSKUCodeTypeOptions
                                    .filter((j) => j.id == 1)
                                    .map((e, key) => {
                                      return (
                                        <option key={key} value={e.id}>
                                          {e.label}
                                        </option>
                                      );
                                    })
                                : ""}
                              {getSKUCodeTypeOptions &&
                                getSKUCodeTypeOptions
                                  .filter((j) => j.id != 1)
                                  .map((e, key) => {
                                    return (
                                      <option key={key} value={e.id}>
                                        {e.label}
                                      </option>
                                    );
                                  })}
                            </Select>
                          </Form.Item>
                        </Form>
                      </Col>

                      <Col md={obj.Key == 0 ? 16 : 12} sm={12}>
                        {obj.Key == 0 && getIsAutoSKUCodeLoader ? (
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ fontSize: 24 }} spin />
                            }
                          >
                            <div>
                              <IntlMessages id="producs.main.add.skucodegenerating" />
                            </div>
                          </Spin>
                        ) : (
                          <Form
                            initialValues={{
                              ["SKUCodeTypeValueVariant" +
                              obj.Key +
                              props.record.VariantName]: obj.SKUValue,
                            }}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom"
                              name={
                                "SKUCodeTypeValueVariant" +
                                obj.Key +
                                props.record.VariantName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="producs.main.add.pleaseenterskucode1" />
                                  ),
                                },
                              ]}
                              onFocus={handleFocus}
                              onBlur={(event) => {
                                handleChangeVariantSKUCodeValue(
                                  event,
                                  obj.Key,
                                  obj.SKUTypeID,
                                  props.index,
                                  props.record.VariantProductID
                                );
                              }}
                              help={
                                obj.IsUnique
                                  ? ""
                                  : "This SKU code already exists. Please enter a different one."
                              }
                              validateStatus={obj.IsUnique ? "" : "error"}
                            >
                              <Input placeholder="Enter a SKU Code" />
                            </Form.Item>
                          </Form>
                        )}
                      </Col>
                      {obj.Key != 0 ? (
                        <Col md={4}>
                          <Button
                            className="Delete-btn-2"
                            onClick={(event) =>
                              AddDeleteVariantSKUCodeTypeOption(
                                event,
                                true,
                                obj.Key,
                                obj.RecordID,
                                props.index
                              )
                            }
                            icon={<DeleteOutlined />}
                            size={"middle"}
                            danger={true}
                          />
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  );
                })}

            {getVariantSKURows && getVariantSKURows[props.index] &&
            getVariantSKURows[props.index].length < 7 ? (
              <Button
                className="custom-searchbtn"
                type="primary"
                icon={<i className="icon icon-add-circle dk-pd-10" />}
                onClick={(event) =>
                  AddDeleteVariantSKUCodeTypeOption(
                    event,
                    false,
                    0,
                    0,
                    props.index
                  )
                }
                size="large"
              >
                <IntlMessages id="products.main.add.addanothercode" />
              </Button>
            ) : (
              ""
            )}
          </Col>

          <Col md={12}>
            <div>
              <h2>
                <IntlMessages id="products.promoadd.preview" />
              </h2>

              <Card>
                <div className="gx-media gx-align-items-center gx-mb-4">
                  <div className="gx-mr-3">
                    {fileList != undefined && fileList != "" ? (
                      <Avatar
                        shape="square"
                        size={64}
                        className="dk-avatar-retrive-sale"
                        src={
                          fileList[0] != undefined
                            ? fileList[0].uid.toString().includes("rc-upload")
                              ? URL.createObjectURL(fileList[0].originFileObj)
                              : fileList[0].url
                            : ""
                        }
                      />
                    ) : (
                      <Avatar
                        shape="square"
                        size={64}
                        className="dk-avatar-retrive-sale"
                        src={Placeholder}
                      />
                    )}
                  </div>
                  <div className="gx-media-body">
                    <h2 className="gx-mb-1">
                      {props.record.VariantName != undefined
                        ? props.record.VariantName
                        : "Product Name"}
                    </h2>
                    <p className="gx-text-grey gx-mb-0">
                      {getVariantSKURows[props.index] != undefined ? (
                        getVariantSKURows[props.index][0] != undefined ? (
                          getVariantSKURows[props.index][0].SKUValue
                        ) : (
                          <IntlMessages id="producs.main.add.pleaseenterskucode" />
                        )
                      ) : (
                        <IntlMessages id="producs.main.add.pleaseenterskucode" />
                      )}
                    </p>
                  </div>
                </div>
                <Divider style={{ borderColor: "#bfbebe" }} />
                <p className="gx-mb-4">
                  <IntlMessages id={"products.main.add.skucodepreviewdesc"} />
                </p>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    );
  };
  const validateNumber = (_, value, type) => {
    if (value == undefined || !/^\d+$/.test(value) || value <= 0) {
      return Promise.reject(
        "Please enter a valid Batch Quantity,always greater than zero."
      );
    }
    return Promise.resolve();
  };
  const ExpandedRowRenderBatches = (props) => {
    return (
      <div class="child-variant-div">
        <div>
          <h2 className="custom-font-weight-500 custom-font-color-black">
            <IntlMessages id="products.main.add.batchdetails" />
          </h2>
          <Row>
            <Col md={24}>
              <Row>
                <Col md={4} sm={8}>
                  <label>
                    <IntlMessages id="products.main.add.batchcode" />
                  </label>
                </Col>

                <Col md={4} sm={8}>
                  <label>
                    <IntlMessages id="products.main.add.batchquantity" />
                  </label>
                </Col>
                <Col md={4} sm={8}>
                  <label>
                    <IntlMessages id="products.main.add.outlet1" />
                  </label>
                </Col>
                <Col md={4} sm={8}>
                  <label>
                    <IntlMessages id="products.main.add.batchmanufacturingdate" />
                  </label>
                </Col>
                <Col md={4} sm={8}>
                  <label>
                    <IntlMessages id="products.main.add.batchexpirydate" />
                  </label>
                </Col>
              </Row>
              {getVariantBatchesRows[props.index] &&
                getVariantBatchesRows[props.index]
                  .filter((e) => e.IsRemove != true)
                  .map((obj) => {
                    return (
                      <Row Key={obj.Key} className="dk-mg-lft-0">
                        
                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchCodeVariant" +
                              obj.Key +
                              props.record.VariantName]: obj.BatchCode,
                            }}
                            form={form}
                            onFinish={onFinish}
                            scrollToFirstError
                            id="ProductForm"
                            name="ProductForm"
                          >
                            <Form.Item
                              className="ant-form-item-label-custom"
                              name={
                                "BatchCodeVariant" +
                                obj.Key +
                                props.record.VariantName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="products.main.add.pleaseenterbatchcode" />
                                  ),
                                },
                              ]}
                              onFocus={handleFocus}
                              onBlur={(event) =>
                                handleChangeVariantBatchesInput(
                                  event,
                                  obj.Key,
                                  obj.BatchID,
                                  "BatchCode",
                                  props.index
                                )
                              }
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <Input placeholder="Enter a Batch Code" />
                              ) : (
                                obj.BatchCode
                              )}
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchQuantityVariant" +
                              obj.Key +
                              props.record.VariantName]: obj.BatchQuantity,
                            }}
                            form={form}
                            onFinish={onFinish}
                            scrollToFirstError
                            id="ProductForm"
                            name="ProductForm"
                          >
                            <Form.Item
                              className="ant-form-item-label-custom"
                              name={
                                "BatchQuantityVariant" +
                                obj.Key +
                                props.record.VariantName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="products.main.add.pleaseenterbatchquantity" />
                                  ),
                                },
                                { validator: validateNumber },
                              ]}
                              // onBlur={(event) => {
                              //   handleChangeVariantSKUCodeValue(
                              //     event,
                              //     obj.Key,
                              //     obj.SKUTypeID,
                              //     props.index
                              //   );
                              // }}
                              onFocus={handleFocus}
                              onBlur={(event) =>
                                handleChangeVariantBatchesInput(
                                  event,
                                  obj.Key,
                                  obj.BatchID,
                                  "BatchQuantity",
                                  props.index
                                )
                              }
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <Input placeholder="Enter a Batch Quantity" />
                              ) : (
                                obj.BatchQuantity
                              )}
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4} sm={24}>
                          <Form
                            form={form}
                            onFinish={onFinish}
                            scrollToFirstError
                            id="ProductForm"
                            name="ProductForm"
                            initialValues={{
                              ["OutletIDVariant" +
                              obj.Key +
                              props.record.VariantName]: !StringIsNullOrEmpty(
                                obj.OutletID
                              )
                                ? obj.OutletID
                                : obj.OutletID, ///here we add moment object
                            }}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom ant-form-margin-right"
                              name={
                                "OutletIDVariant" +
                                obj.Key +
                                props.record.VariantName
                              }
                              label=""
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="products.main.add.pleaseselectoutlet" />
                                  ),
                                },
                              ]}
                            >
                              <Select
                                placeholder={
                                  <IntlMessages id="products.main.add.selectoutlet" />
                                }
                                showSearch
                                optionFilterProp="children"
                                onChange={(event) =>
                                  handleChangeVariantBatchesInput(
                                    event,
                                    obj.Key,
                                    obj.BatchID,
                                    "OutletID",
                                    props.index
                                  )
                                }
                                disabled={
                                  isAddMode || obj.BatchID == 0 ? false : true
                                }
                              >
                                {getReduxStoreOutlets &&
                                  getReduxStoreOutlets.map((e, index) => {
                                    return (
                                      <Select.Option
                                        key={obj.Key}
                                        value={getDecryptID(e.id).toString()}
                                      >
                                        {e.outlet}
                                      </Select.Option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4} sm={24}>
                          <Form
                            form={form}
                            onFinish={onFinish}
                            scrollToFirstError
                            id="ProductForm"
                            name="ProductForm"
                            initialValues={{
                              ["BatchManufacturingDateVariant" +
                              obj.Key +
                              props.record.VariantName]: !StringIsNullOrEmpty(
                                obj.BatchManufacturingDate
                              )
                                ? moment(obj.BatchManufacturingDate)
                                : moment(), ///here we add moment object
                            }}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom ant-form-margin-right "
                              name={
                                "BatchManufacturingDateVariant" +
                                obj.Key +
                                props.record.VariantName
                              }
                              label=""
                              style={{ width: "100%" }}
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <DatePicker
                                  onChange={(event) =>
                                    handleChangeVariantBatchesInput(
                                      event,
                                      obj.Key,
                                      obj.BatchID,
                                      "BatchManufacturingDate",
                                      props.index
                                    )
                                  }
                                  format={dateFormat}
                                />
                              ) : !StringIsNullOrEmpty(
                                  obj.BatchManufacturingDate
                                ) ? (
                                moment(obj.BatchManufacturingDate).format(
                                  dateFormat
                                )
                              ) : (
                                moment()
                              )}
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchExpiryDateVariant" +
                              obj.Key +
                              props.record.VariantName]: !StringIsNullOrEmpty(
                                obj.BatchExpiryDate
                              )
                                ? moment(obj.BatchExpiryDate)
                                : moment(), ///here we add moment object
                            }}
                            form={form}
                            id="ProductForm"
                            name="ProductForm"
                            // validateTrigger="onBlur"
                          >
                            <Form.Item
                              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
                              name={
                                "BatchExpiryDateVariant" +
                                obj.Key +
                                props.record.VariantName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please select the expiry date",
                                },
                                {
                                  validator: (_, value) =>
                                    validateExpiryDate(
                                      _,
                                      value,
                                      obj,
                                      props.record.VariantName
                                    ),
                                },
                              ]}
                              label=""
                              style={{ width: "100%" }}
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <DatePicker
                                  onChange={(event) =>
                                    handleChangeVariantBatchesInput(
                                      event,
                                      obj.Key,
                                      obj.BatchID,
                                      "BatchExpiryDate",
                                      props.index
                                    )
                                  }
                                  format={dateFormat}
                                />
                              ) : !StringIsNullOrEmpty(obj.BatchExpiryDate) ? (
                                moment(obj.BatchExpiryDate).format(dateFormat)
                              ) : (
                                moment()
                              )}
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4}>
                          <Button
                            className="Delete-btn-2"
                            onClick={(event) =>
                              confirm({
                                title: "Permanent Delete ?",
                                content: `"Are you sure you want to delete"`,
                                okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
                                onOk() {
                                  AddDeleteVariantProductBatchesOption(
                                    event,
                                    true,
                                    obj.Key,
                                    obj.BatchID,
                                    props.index
                                  );
                                },
                                onCancel() {
                                  //console.log('Cancel');
                                },
                              })
                            }
                            icon={<DeleteOutlined />}
                            size={"middle"}
                            danger={true}
                          />
                        </Col>

                      </Row>
                    );
                  })}

              {getVariantBatchesRows[props.index] &&
              getVariantBatchesRows[props.index].length < 31 ? (
                <Button
                  className="custom-searchbtn"
                  type="primary"
                  icon={<i className="icon icon-add-circle dk-pd-10" />}
                  onClick={(event) =>
                    AddDeleteVariantProductBatchesOption(
                      event,
                      false,
                      0,
                      0,
                      props.index
                    )
                  }
                  size="large"
                >
                  <IntlMessages id="products.main.add.addanotherbatchcode" />
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  };
  const ExpandedRowRenderTax = (props) => {
    const columnsTaxRender = [
      {
        title: "Outlet",
        dataIndex: "OutletName",
        key: "OutletName",
      },
      {
        title: "Tax",
        dataIndex: "Tax",
        key: "Tax",
        render: (text, record) => {
          function putTax() {
            let TaxVariant = `TaxVariant${
              record.key + props.record.VariantName
            }`;
            if (record.Tax != undefined)
              form.setFieldsValue({
                [TaxVariant]: record.Tax,
              });
          }
          putTax();
          function onChangeTax(value) {
            let rowKey = record.key;
            let supposedArr = tableDataVariantStoreOutlets[props.obj];
            supposedArr.filter((a) => a.key === rowKey)[0].Tax =
              value.target.value;
            // tableDataVariantStoreOutlets[props.obj] = supposedArr; alternative
            let temp = tableDataVariantStoreOutlets;
            temp[props.obj] = supposedArr;
            setTableDataVariantStoreOutlets(temp);
          }
          return (
            <Form
              form={form}
              name="ProductForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >
              <Form.Item
                className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
                name={`TaxVariant${record.key + props.record.VariantName}`}
                onChange={onChangeTax}
              >
                <Select>
                  {saleTaxOptions &&
                    saleTaxOptions.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.label}
                        </option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Form>
          );
        },
      },
    ];
    let taxID = tableDataVariantStoreOutlets[props.obj][0].Tax;
    function onChangeVariantMainTax(value) {
      let supposedArr = tableDataVariantStoreOutlets[props.obj];
      for (var i = 0; i < supposedArr.length; i++) {
        let tempObj = supposedArr[i];
        tempObj.Tax = value;
        supposedArr[i] = tempObj;
      }

      let temp = tableDataVariantStoreOutlets;
      temp[props.obj] = supposedArr;
      setTableDataVariantStoreOutlets(temp);

      VariantProductTaxCalculator(value, props.record.key, "");
    }
    console.log(tableDataVariantStoreOutlets[props.obj]);
    return getIsTaxExclusive ? (
      <Table
        className="gx-table-responsive"
        columns={columnsTaxRender}
        dataSource={tableDataVariantStoreOutlets[props.obj]}
        pagination={false}
      />
    ) : (
      <Form
        form={form}
        name="ProductForm"
        initialValues={{
          ["TaxVariant" + props.record.key + props.record.VariantName]: taxID,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
      >
        <Form.Item
          className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment ant-custom-mb-auto"
          name={`TaxVariant${props.record.key + props.record.VariantName}`}
        >
          <Select onChange={onChangeVariantMainTax}>
            {saleTaxOptions &&
              saleTaxOptions.map((e, key) => {
                return (
                  <option key={key} value={e.id}>
                    {e.label}
                  </option>
                );
              })}
          </Select>
        </Form.Item>
      </Form>
    );
  };
  const ExpandedRowRenderPrices = (props) => {
    return (
      <>
        <Row>
          <Col md={12}>
            <p>
              <strong>
                <IntlMessages id="products.main.add.supplyprice" /> (
                {getCurrData.currencyCode != null
                  ? getCurrData.currencyCode
                  : getCurrData.currencyName != null
                  ? getCurrData.currencyName
                  : getCurrData.currencySymbol}
                )
              </strong>
            </p>
            <p>
              <strong>
                <IntlMessages id="products.main.add.markup" /> (%)
              </strong>
            </p>
          </Col>

          <Col md={12}>
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right dk-txt-align-end"
              name={`VariantSupplyPrice${props.record.VariantName}`}
              label=""
            >
              {/* <Input
                // onChange={(e) => {
                //   handleVariantPricesCalculator(e, "SupplyPrice", props.record.key);
                // }}
                placeholder=""
                defaultValue={"0"}
                disabled={true}
                style={{
                  textAlign: "right",
                  border: "0px solid #d9d9d9",
                  color: "#000000",
                }}
              /> */}
              <InputNumber
              type="number"
                onBlur={(event) => {
                  handleVariantPricesCalculator(
                    event,
                    props.record.key,
                    "SupplyPrice"
                  );
                }}
                onFocus={handleFocus}
                placeholder={
                  getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol
                }
                disabled={true}
                precision={2}
                style={{
                  textAlign: "right",
                  border: "0px solid #d9d9d9",
                  color: "#000000",
                  width: "100%",
                }}
                min={0}
              />
            </Form.Item>

            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right dk-txt-align-end"
              name={`VariantMarkup${props.record.VariantName}`}
              label=""
            >
              {/* <Input
                // onChange={(e) => {
                //   handleVariantPricesCalculator(e, "MarkUp", props.record.key);
                // }}
                placeholder={"%"}
                defaultValue={0}
                width="80%"
                style={{ textAlign: "right" }}
              /> */}
              <InputNumber
              type="number"
                onFocus={handleFocus}
                onBlur={(event) => {
                  handleVariantPricesCalculator(
                    event,
                    props.record.key,
                    "MarkUp"
                  );
                }}
                placeholder={"%"}
                precision={2}
                style={{
                  textAlign: "right",
                  width: "100%",
                }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Divider style={{ marginBottom: "50px" }} />
        <Row>
          <Col md={12}>
            <div style={{ lineHeight: "4px" }}>
              <p>
                <strong>
                  <IntlMessages id="products.main.add.retailprice" />
                </strong>
              </p>
              {getIsTaxExclusive ? (
                <p style={{ fontSize: "small" }}>
                  <IntlMessages id="products.main.add.excludingtax" />
                </p>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col md={12}>
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right dk-txt-align-end"
              name={`VariantRetailPrice${props.record.VariantName}`}
              label=""
            >
              {/* <Input
                placeholder="PKRs"
                // onChange={(e) => {
                //   handleVariantPricesCalculator(
                //     e,
                //     "RetailPrice",
                //     props.record.key
                //   );
                // }}
                type="retailpriceProduct"
                style={{ textAlign: "right" }}

              /> */}
              <InputNumber
                onFocus={handleFocus}
                onBlur={(event) => {
                  handleVariantPricesCalculator(
                    event,
                    props.record.key,
                    "RetailPrice"
                  );
                }}
                placeholder={
                  getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol
                }
                precision={2}
                type="retailpriceProduct"
                style={{
                  textAlign: "right",
                  width: "100%",
                }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        {!getIsTaxExclusive ? (
          <Row>
            <Col md={20} style={{ display: "flex" }}>
              <p>
                <strong>
                  <IntlMessages id="products.main.add.tax" />
                </strong>
              </p>
              &nbsp;
              <p>({props.record.VariantTaxName})</p>
            </Col>
            <Col md={4}>
              {parseFloat(props.record.VariantTaxPrice).toFixed(
                getDefaultDecimalPlaces
              )}
            </Col>
          </Row>
        ) : (
          ""
        )}

        {getIsLoyaltyEnabled ? (
          <Row>
            <div style={{ marginLeft: "15px", marginRight: "18px" }}>
              <Radio.Group
                style={{ display: "inline-grid" }}
                size="large"
                value={PLoyaltyRadioButton}
                onChange={OnChangeLoyaltyRadioButton}
              >
                <Radio value={1}>
                  <IntlMessages id="products.main.add.earndefaultloyalty" />
                  <div
                    style={{
                      marginLeft: "24px",
                      fontSize: "12px",
                      marginBottom: "auto",
                      wordBreak: "break-all",
                    }}
                  >
                    <p>
                      {`This customer will earn ${parseFloat(
                        props.record.VariantLoyaltyPoints
                      ).toFixed(
                        getDefaultDecimalPlaces
                      )} loyalty points on the default retail price. These loyalty points are based on the default loyalty ratio of
                                  ${
                                    getCurrData.currencyCode != null
                                      ? getCurrData.currencyCode
                                      : getCurrData.currencyName != null
                                      ? getCurrData.currencyName
                                      : getCurrData.currencySymbol
                                  }   ${
                        getLoyaltyAmountValue != undefined
                          ? 1 /
                            parseFloat(getLoyaltyAmountValue).toFixed(
                              getDefaultDecimalPlaces
                            )
                          : "0"
                      } for each point.`}
                    </p>
                  </div>
                </Radio>

                <Tooltip
                  placement="leftTop"
                  title={<IntlMessages id="common.resource.comingsoon" />}
                >
                  <Radio value={2} disabled={true}>
                    <IntlMessages id="products.main.add.earncustomloyalty" />
                  </Radio>
                </Tooltip>

                <p>
                  <IntlMessages id="products.main.add.earncustomloyaltydescription" />
                </p>
                <Form.Item
                  className={`ant-form-item-label-custom ant-form-margin-right custom-sku-input-margin ${
                    PLoyaltyRadioButton == 2
                      ? "custom-div-show"
                      : "custom-div-hide"
                  }`}
                  name={`VariantCustomLoyalty${props.record.VariantName}`}
                >
                  {/* <Input
                  // onChange={(e) => {
                  //   handleVariantPricesCalculator(
                  //     e,
                  //     "CustomLoyalty",
                  //     props.record.key
                  //   );
                  // }}
                  placeholder=""
                /> */}
                  <InputNumber
                  type="number"
                    onFocus={handleFocus}
                    onBlur={(event) => {
                      handleVariantPricesCalculator(
                        event,
                        props.record.key,
                        "CustomLoyalty"
                      );
                    }}
                    placeholder={
                      getCurrData.currencyCode != null
                        ? getCurrData.currencyCode
                        : getCurrData.currencyName != null
                        ? getCurrData.currencyName
                        : getCurrData.currencySymbol
                    }
                    precision={2}
                    min={0}
                    style={{ width: "80%" }}
                  />
                </Form.Item>
              </Radio.Group>
            </div>
          </Row>
        ) : (
          ""
        )}
      </>
    );
  };
  const ExpandedRowRenderImages = (props) => {
    //
    let supposedArr =
      getVariantImages &&
      getVariantImages != undefined &&
      getVariantImages.length != 0
        ? getVariantImages
        : [];
    let rowImageKey =
      props.record.VariantProductID != ""
        ? props.record.VariantProductID
        : props.record.key != undefined
        ? props.record.key
        : 0;

    let rowFileList =
      props.record.VariantProductID != ""
        ? supposedArr.filter(
            (a) =>
              getDecryptID(a.variantProductID) === getDecryptID(rowImageKey)
          )
        : supposedArr.filter((a) => a.key === rowImageKey);

    const [getRowImage, setRowImage] = React.useState(rowFileList);

    const handleRowUpload = (rowImageObj) => {
      ////;
      if (
        rowImageObj.file.status == undefined &&
        rowImageObj.file.uid.toString().includes("rc-upload")
      ) {
        //its the first time whe user upload image

        if (getRowImage.length == 0) {
          let imageObj =
            rowImageObj && rowImageObj != undefined
              ? rowImageObj.fileList[0]
              : null;
          if (imageObj != null && imageObj != undefined) {
            imageObj.key = props.record.key;
            imageObj.originFileObj.key = props.record.key;
          }
          if (props.record.VariantProductID != "") {
            imageObj.variantProductID = props.record.VariantProductID;
          }

          let variantImages = getVariantImages;
          if (imageObj != null) {
            variantImages.push(imageObj);
            setVariantImages(variantImages);

            // let variantRowImage = [];
            let variantRowImage =
              props.record.VariantProductID != ""
                ? variantImages.filter(
                    (a) =>
                      getDecryptID(a.variantProductID) ==
                      getDecryptID(rowImageKey)
                  )
                : variantImages.filter((a) => a.key == rowImageKey);

            let rowKey = props.record.key;
            let supposedVariantArr = TableProductVariantdata;
            let imgURL = variantRowImage[0].uid.toString().includes("rc-upload")
              ? URL.createObjectURL(rowImageObj.file)
              : "";
            supposedVariantArr.filter(
              (a) => a.key === rowKey
            )[0].VariantImageURL = imgURL;
            setTableProductVariantdata(supposedVariantArr);

            setRowImage(variantRowImage);
          }
        } else {
          message.error("Only One Image allowed for variant product");
        }
      }
      if (rowImageObj.file.status == "removed") {
        if (!rowImageObj.file.uid.toString().includes("rc-upload")) {
          let getImages = getDeletedImages;
          getImages.push(rowImageObj.file);
          setDeletedImages(getImages);
        }
        let variantImages = getVariantImages;
        let filterImages =
          props.record.VariantProductID != ""
            ? variantImages.filter(
                (a) =>
                  getDecryptID(a.variantProductID) != getDecryptID(rowImageKey)
              )
            : variantImages.filter((a) => a.key != rowImageKey);
        setVariantImages(filterImages);
        setRowImage([]);
      }
    };

    const rowProps = {
      name: "file" + props.obj,
      multiple: true,
      fileList: getRowImage,
      listType: "picture-card",
      onPreview: handlePreview,
      onChange(info) {
        handleRowUpload(info);
      },
    };
    //  const beforeUpload =(e)=>{
    //    let a  =e ;
    //    return false;
    //  }
    return (
      <div>
        <Dragger
          {...rowProps}
          beforeUpload={() => {
            return false;
          }}
          maxCount={1}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            <IntlMessages id="products.main.add.uploadimagemessage1" />
          </p>
          <p className="ant-upload-hint">
            <IntlMessages id="products.main.add.uploadimagemessage2" />
          </p>
        </Dragger>
      </div>
    );
  };
  function onProductNameChange(event) {
    if (event.target.value === getProductName) {
      return;
    }

    let bodySKu = {
      ProductName: [event.target.value],
      IsGenerateByName: true,
    };
    getAutoGeneratedSKU(bodySKu);
    setProductName(event.target.value);
  }
  const ProductBatchDetails = () => {
    return (
      <Row className="BatchDetails">
        <Col md={24} className="p-0">
          <Row className="md-display-none">
            <Col md={4} sm={8} className="pl-0-device">
              <label>
                <IntlMessages id="products.main.add.batchcode" />
              </label>
            </Col>

            <Col md={4} sm={8}>
            <label>
                <IntlMessages id="products.main.add.batchquantity" />
                </label>
            </Col>
            <Col md={4} sm={8}>
            <label>
                <IntlMessages id="products.main.add.outlet1" />
                </label>
            </Col>
            <Col md={4} sm={8}>
            <label>
                <IntlMessages id="products.main.add.batchmanufacturingdate" />
                </label>
            </Col>
            <Col md={4} sm={8}>
            <label>
                <IntlMessages id="products.main.add.batchexpirydate" />
                </label>
            </Col>
          </Row>
          {getProductBatchesOptionsRows
            .filter((e) => e.IsRemove != true)
            .map((obj) => {
              return (
                <Row className="swicth-form">
                  <Col lg={4} md={12} sm={24} xs={24} className="">
                    <Form
                      initialValues={{
                        ["BatchCode" + obj.Key]: obj.BatchCode,
                      }}
                      form={form}
                      scrollToFirstError
                      id="ProductForm"
                      name="ProductForm"
                    >
                      <Form.Item
                        className="ant-form-item-label-custom"
                        name={"BatchCode" + obj.Key}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id="products.main.add.pleaseenterbatchcode" />
                            ),
                          },
                        ]}
                        onFocus={handleFocus}
                        onBlur={(event) =>
                          handleChangeBatchesInput(
                            event,
                            obj.Key,
                            obj.BatchID,
                            "BatchCode"
                          )
                        }
                      >
                        {isAddMode || obj.BatchID == 0 ? (
                          <Input placeholder="Enter a Batch Code" />
                        ) : (
                          obj.BatchCode
                        )}
                      </Form.Item>
                    </Form>
                  </Col>

                  <Col lg={4} md={12} sm={24} xs={24} className="">
                    <Form
                      initialValues={{
                        ["BatchQuantity" + obj.Key]: !StringIsNullOrEmpty(
                          obj.BatchQuantity
                        )
                          ? obj.BatchQuantity
                          : 0,
                      }}
                      form={form}
                      scrollToFirstError
                      id="ProductForm"
                      name="ProductForm"
                    >
                      <Form.Item
                        className="ant-form-item-label-custom"
                        name={"BatchQuantity" + obj.Key}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id="products.main.add.pleaseenterbatchquantity" />
                            ),
                          },
                          { validator: validateNumber },
                        ]}
                        onFocus={handleFocus}
                        onBlur={(event) =>
                          handleChangeBatchesInput(
                            event,
                            obj.Key,
                            obj.BatchID,
                            "BatchQuantity"
                          )
                        }
                      >
                        {isAddMode || obj.BatchID == 0 ? (
                          <Input placeholder="Enter a Batch Quantity" />
                        ) : (
                          obj.BatchQuantity
                        )}
                      </Form.Item>
                    </Form>
                  </Col>

                  <Col lg={4} md={12} sm={24} xs={24} className="">
                    <Form
                      form={form}
                      scrollToFirstError
                      id="ProductForm"
                      name="ProductForm"
                    >
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right"
                        name={"OutletID" + obj.Key}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id="products.main.add.pleaseselectoutlet" />
                            ),
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select a outlet"
                          showSearch
                          optionFilterProp="children"
                          onChange={(event) =>
                            handleChangeBatchesInput(
                              event,
                              obj.Key,
                              obj.BatchID,
                              "OutletID"
                            )
                          }
                          disabled={
                            isAddMode || obj.BatchID == 0 ? false : true
                          }
                        >
                          {getReduxStoreOutlets &&
                            getReduxStoreOutlets.map((e, index) => {
                              return (
                                <Select.Option
                                  key={obj.Key}
                                  value={getDecryptID(e.id).toString()}
                                >
                                  {e.outlet}
                                </Select.Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </Form>
                  </Col>

                  <Col lg={4} md={12} sm={24} xs={24} className="">
                    <Form
                      initialValues={{
                        ["BatchManufacturingDate" + obj.Key]:
                          !StringIsNullOrEmpty(obj.BatchManufacturingDate)
                            ? moment(obj.BatchManufacturingDate)
                            : moment(), ///here we add moment object
                      }}
                      className=""
                    >
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right"
                        name={"BatchManufacturingDate" + obj.Key}
                        label=""
                      >
                        {isAddMode || obj.BatchID == 0 ? (
                          <DatePicker className="w-100 ManufacterDate"
                            onChange={(event) =>
                              handleChangeBatchesInput(
                                event,
                                obj.Key,
                                obj.BatchID,
                                "BatchManufacturingDate"
                              )
                            }
                            format={dateFormat}
                          />
                        ) : !StringIsNullOrEmpty(obj.BatchManufacturingDate) ? (
                          moment(obj.BatchManufacturingDate).format(dateFormat)
                        ) : (
                          moment()
                        )}
                      </Form.Item>
                    </Form>
                  </Col>

                  <Col lg={4} md={12} sm={24} xs={24} className="">
                    <Form
                      initialValues={{
                        ["BatchExpiryDate" + obj.Key]: !StringIsNullOrEmpty(
                          obj.BatchExpiryDate
                        )
                          ? moment(obj.BatchExpiryDate)
                          : moment(), ///here we add moment object
                      }}
                      form={form}
                      scrollToFirstError
                      id="ProductForm"
                      name="ProductForm"
                      // validateTrigger="onBlur"
                    >
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right "
                        name={"BatchExpiryDate" + obj.Key}
                        label=""
                        rules={[
                          {
                            required: true,
                            message: "Please select the expiry date",
                          },
                          {
                            validator: (_, value) =>
                              validateExpiryDate(_, value, obj),
                          },
                        ]}
                      >
                        {isAddMode || obj.BatchID == 0 ? (
                          <DatePicker  className="w-100 ExpiryDate"
                            onChange={(event) =>
                              handleChangeBatchesInput(
                                event,
                                obj.Key,
                                obj.BatchID,
                                "BatchExpiryDate"
                              )
                            }
                            format={dateFormat}
                          />
                        ) : !StringIsNullOrEmpty(obj.BatchExpiryDate) ? (
                          moment(obj.BatchExpiryDate).format(dateFormat)
                        ) : (
                          moment()
                        )}
                      </Form.Item>
                    </Form>
                  </Col>

                  <Col lg={4} md={12} sm={24} xs={24} className="">
                    <Button
                      className="Delete-btn-2 mb-3"
                      onClick={(event) =>
                        confirm({
                          title: "Delete ?",
                          content: `"Are you sure you want to delete"`,
                          okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
                          onOk() {
                            AddDeleteProductBatchesOption(
                              event,
                              true,
                              obj.Key,
                              obj.BatchID
                            );
                          },
                          onCancel() {
                            //console.log('Cancel');
                          },
                        })
                      }
                      icon={<DeleteOutlined />}
                      size={"middle"}
                      danger={true}
                    />
                  </Col>
                </Row>
              );
            })}

          {getProductBatchesOptionsRows.length < 31 ? (
            <Button
              className="custom-searchbtn mt-2 mb-2"
              type="primary"
              icon={<i className="icon icon-add-circle dk-pd-10" />}
              onClick={(event) =>
                AddDeleteProductBatchesOption(event, false, 0)
              }
              size="large"
            >
              <IntlMessages id="products.main.add.addanotherbatchcode" />
            </Button>
          ) : (
            ""
          )}
        </Col>
      </Row>
    );
  };

  const validateExpiryDate = (_, value, row, variantName) => {
    const manufacturingDate = moment(row.BatchManufacturingDate).startOf("day");
    const expiryDate = moment(value).startOf("day");
    if (!value || expiryDate.isSameOrAfter(manufacturingDate)) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(
        ` ${
          !StringIsNullOrEmpty(variantName)
            ? `Variant Name : ${variantName},`
            : ""
        } Batch Code : ${
          row.BatchCode
        } -- Expiry date must be the same day or after the manufacturing date`
      )
    );
  };
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.Products,
      SearchValue: value,
      ID : productID
    };
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST);
    getIsExist
      .then((response) => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback("This Product name exists. Add a different one.");
        } else {
          callback();
        }
      })
      .catch((e) => {});
  };
  // const onExpiryDateChange = (date, dateString) => {
  //   console.log(date, dateString);
  // };
  return getIsAllowRead ? (
    <div className="Content-wrapper NewProduct-pg">
      <>
        <Spin tip="Loading..." spinning={isLoading} size="large">
          <Modal
            title="Error"
            visible={errorMessages.length > 0}
            onCancel={() => setErrorMessages([])}
            footer={[
              <Button key="ok" onClick={() => setErrorMessages([])}>
                OK
              </Button>,
            ]}
          >
            {errorMessages.map((message, index) => (
              <p key={index}>{message}</p>
            ))}
          </Modal>

          <div className="back-arrow-h1">
              <h1 className="d-flex align-items-center">
                <ArrowLeftOutlined
                  className="dk-vertical-align"
                  onClick={redirectToListing}
                />
                <span className="mx-2">
                {" "}
                {true ? (
                  <IntlMessages id="products.main.add.newproduct" />
                ) : (
                  <IntlMessages id="products.main.add.editproduct" /> +
                  form.getFieldValue("supplierName")
                )}{" "}
                </span>
              </h1>
            </div>


          <Card className="gx-card" title="">
            <Collapse>
              <Panel
                showArrow={true}
                header={
                  <IntlMessages id="products.main.add.needhelpheadingproduct" />
                }
              >
                <Row>
                  <div className="billing-main">
                    <Col md={12}>
                      <p>
                        <IntlMessages id="products.main.add.needhelpheadingproductpdescription1" />
                      </p>
                      <p>
                        <IntlMessages id="products.main.add.needhelpheadingproductpdescription2" />
                      </p>
                      <p>
                        <IntlMessages id="products.main.add.needhelpheadingproductpdescription3"
                          values={{
                            strong: chunks => <strong>{chunks}</strong>,
                            bus_name_first: REACT_APP_BUS_FIRST_NAME
                          }}
                        />
                      </p>
                    </Col>

                    <Col md={12}>
                      <img src={ProductImg} alt="" />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <Row className="ant-row dk-row-bg-color m-0 Sec-heading-bg">
          <Col lg={18} md={12} sm={14} xs={24}>
             <p className="title vd-hero-intro custom-font-color-black m-0">
                {true ? (
                  <IntlMessages id="products.main.add.createnewproduct" />
                ) : (
                  "Edit supplier's details."
                )}
              </p>
            </Col>
            <Col lg={6} md={12} sm={10} xs={24}>
             <div className="pg-header-btn">
                <Button
                  className="dk-btn-cancel dk-wd-auto"
                  type="primary"
                  onClick={redirectToListing}
                  size="large"
                >
                  <IntlMessages id="products.main.add.cancel" />
                </Button>
                <Button
                  className="dk-btn-add dk-wd-auto"
                  disabled={isAddMode ? getIsDisableCreate : getIsDisableUpdate}
                  // disabled={isRegistering.isRegistering}
                  form="ProductForm"
                  htmlType="submit"
                  type="primary"
                  size="large"
                >
                  {true ? (
                    <IntlMessages id="products.main.add.save" />
                  ) : (
                    "Edit Product"
                  )}
                </Button>
              </div>
            </Col>
          </Row>

          <div className="custom-mg-top-25">
            <Row className="General-div">
              <Col xl={6} lg={24} md={24} sm={24} xs={24}>
              <h2 class="custom-font-weight-500 custom-font-color-black">
                  <IntlMessages id="products.main.add.general" />
                </h2>
                <p className="dk-font-size-15">
                  <IntlMessages id="products.main.add.generaldescription" />
                </p>
              </Col>
              <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: "86",
                  }}
                  className="custom-mg-top-26"
                  scrollToFirstError
                  id="ProductForm"
                  name="ProductForm"
                >
                  <InputGroup size="large" className="ant-row-FlexFix">
                    <Form.Item
                      className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0"
                      name="Name"
                      label={<IntlMessages id="products.main.add.name" />}
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id="products.main.add.namemessage" />
                          ),
                        },
                        {
                          validator: valideDuplicateName,
                        },
                      ]}
                    >
                      <Input maxLength={30} onBlur={onProductNameChange} />
                    </Form.Item>

                    <Form.Item
                      className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0"
                      name="BrandID"
                      label={<IntlMessages id="products.main.add.brand" />}
                    >
                      <Select
                        placeholder={
                          <IntlMessages id="products.main.add.choosebrand" />
                        }
                        showSearch
                        optionFilterProp="children"
                      >
                        {brandOptions &&
                          brandOptions.map((e, key) => {
                            return <option value={e.id}>{e.label}</option>;
                          })}
                      </Select>
                    </Form.Item>
                  </InputGroup>

                  <div className="GeneralForm gx-mb-3">
                    <CKEditor
                      activeClass="p10"
                      content={descriptionContent}
                      label={
                        <IntlMessages id="products.main.add.description" />
                      }
                      events={{
                        change: OnChangeDescription,
                      }}
                    />

                    <div className="mt-4">
                      <p>
                        <strong>
                          <IntlMessages id="products.main.add.tags" />
                        </strong>{" "}
                        <IntlMessages id="products.main.add.tagsdescription" />
                      </p>
                      <Form.Item name="ProductTags" className="form-inner-pad-0">
                        <Select
                          mode="multiple"
                          showSearch
                          optionFilterProp="children"
                        >
                          {productTagOptions &&
                            productTagOptions.map((e, key) => {
                              return (
                                <option key={key} value={e.id}>
                                  {e.label}
                                </option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>

                  <div className="gx-mb-3">
                    <div className="GeneralForm">
                      <p>
                        <strong>
                          <IntlMessages id="products.main.add.producttype" />
                        </strong>{" "}
                        <IntlMessages id="products.main.add.producttypedescription" />
                      </p>
                    </div>
                    <Form.Item
                      className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0"
                      name="ProductType"
                      label="">
                      <Select
                        placeholder={
                          <IntlMessages id="products.main.add.chooseproducttype" />
                        }
                        showSearch
                        optionFilterProp="children"
                      >
                        {productTypeOptions &&
                          productTypeOptions.map((e, key) => {
                            return (
                              <option key={key} value={e.id}>
                                {e.label}
                              </option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </div>

                  <div className="gx-mb-3 Point-of-Sale-toggle">
                    <Switch
                      checked={isSellOnPOS}
                      style={{ marginBottom: "20px" }}
                      onChange={(e) => {
                        setIsSellOnPOS(e);
                      }}
                    />
                    <label className="w-100 mb-0">
                     
                        <IntlMessages id="products.main.add.sellonpos" />
                     
                    </label>
                    <p>
                      <IntlMessages id="products.main.add.sellonposdescription" />
                    </p>

                    <label className="w-100 mb-0">
                     
                        <IntlMessages id="products.main.add.uploadimages" />
                      
                    </label>
                    <p>
                      <IntlMessages id="products.main.add.uploadimagesdescription" />
                    </p>
                    <Dragger {...props} beforeUpload={() => false} className="border-10-imp mb-3">
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        <IntlMessages id="products.main.add.uploadimagemessage1" />
                      </p>
                      <p className="ant-upload-hint">
                        <IntlMessages id="products.main.add.uploadimagemessage2" />
                      </p>
                    </Dragger>

                    <Modal
                      visible={PreviewVisible}
                      title={PreviewTitle}
                      footer={null}
                      onCancel={handleCancel}
                    >
                      <img
                        alt="example"
                        style={{ width: "100%" }}
                        src={PreviewImage}
                      />
                    </Modal>
                  </div>


                </Form>
              </Col>
            </Row>

            <Divider className="mt-3 mb-4" />

            <Row className="inventory-div">
            <Col xl={6} lg={24} md={24} sm={24} xs={24}>
            <h2 class="custom-font-weight-500 custom-font-color-black">
                  <IntlMessages id="products.main.add.inventory" />
                </h2>
                <p className="dk-font-size-15">
                  {" "}
                  <IntlMessages id="products.main.add.inventorydescription" />
                </p>
              </Col>
              <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: "86",
                  }}
                  className="custom-mg-top-36"
                  scrollToFirstError
                  id="ProductForm"
                  name="ProductForm"
                >
                  <div className="gx-mb-3 Inventory">
                    {isAddMode ? (
                      <Row justify="center" type="flex" className="dk-flex-promo">
                        <Col lg={8} md={8} sm={24} xs={24} className="dk-flex-promo-1 pl-0-device">
                          <div className="dk-custom-promoadd-card1 dk-flex-promo-1">
                          <Card
                            title={
                              <h3 className="mb-0"><IntlMessages id="products.main.add.standardproduct" /></h3>
                            }
                            className={`${
                              productInventoryType == 0
                                ? "ant-card-bordered-active div-cursor-pointer"
                                : "div-cursor-pointer"
                            }`}
                            onClick={() => ProductInventoryTypeSelection(0)}
                          >
                            <p className="mb-0">
                              <IntlMessages id="products.main.add.standardproductdescription" />
                            </p>
                          </Card>
                          </div>
                        </Col>

                        <Col lg={8} md={8} sm={24} xs={24} className="dk-flex-promo-1 md-pad-0">
                        <div className="dk-custom-promoadd-card1 dk-flex-promo-1">
                          <Card
                            title={
                              <h3 className="mb-0"> <IntlMessages id="products.main.add.productwithvariants" /> </h3>
                            }
                            className={`${
                              productInventoryType == 1
                                ? "ant-card-bordered-active div-cursor-pointer"
                                : "div-cursor-pointer"
                            }`}
                            onClick={() => ProductInventoryTypeSelection(1)}
                          >
                            <p className="mb-0">
                              <IntlMessages id="products.main.add.productwithvariantsdescription" />
                            </p>
                          </Card>
                          </div>
                        </Col>

                        <Col lg={8} md={8} sm={24} xs={24} className="dk-flex-promo-1 pr-0-device">
                        <div className="dk-custom-promoadd-card1 dk-flex-promo-1">
                          <Card
                            title={
                              <h3 className="mb-0"> <IntlMessages id="products.main.add.compositeproduct" /></h3>
                            }
                            className={`${
                              productInventoryType == 2
                                ? "ant-card-bordered-active div-cursor-pointer"
                                : "div-cursor-pointer"
                            }`}
                            onClick={() => ProductInventoryTypeSelection(2)}
                          >
                             <p className="mb-0">
                              <IntlMessages id="products.main.add.compositeproductdescription" />
                            </p>
                          </Card>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {productInventoryTypeInEdit == "Standard Product" ? (
                      <div className="div-flow add-pro-variants mb-4">
                        <Row>
                          <h3>
                            <IntlMessages id="products.main.add.thisproducthasnovariants" />
                          </h3>
                        </Row>
                        <Row>
                          <p className="font-size-smaller">
                            <IntlMessages id="products.main.add.ifyouwanttosellmorevariantdescp" />
                          </p>
                        </Row>
                        <Row>
                          <Button
                            className="dk-btn-add"
                            type="primary"
                            onClick={() => ProductInventoryTypeSelection(1)}
                          >
                            <IntlMessages id="products.main.add.addvariant" />
                          </Button>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    {isAddMode && productInventoryType == 2 ? (
                      <>
                        <Radio.Group
                          style={{ display: "inline-grid" }}
                          size="large"
                          /*value={value}*/ value={InvSKURadioButton}
                          onChange={OnChangeSKURadioButton}
                        >
                          <Radio value={1}>
                            <IntlMessages id="products.main.add.autogeneratesku" />
                            <div>
                              <p className="font-size-smaller">
                                <IntlMessages id="products.main.add.autogenerateskudescription" />
                              </p>
                            </div>
                          </Radio>

                          <Radio value={2}>
                            <IntlMessages id="products.main.add.entercustomsku" />
                          </Radio>
                        </Radio.Group>
                        {InvSKURadioButton == 2 ? (
                          <Form
                            initialValues={{
                              ["CustomSKU"]: getSKUTypeOptionsRows[0].SKUValue,
                            }}
                            name="ProductForm"
                          >
                            <Form.Item
                              className={`ant-form-item-label-custom ant-form-margin-right custom-sku-input-margin`}
                              name="CustomSKU"
                              label=""
                              rules={[
                                {
                                  required:
                                    InvSKURadioButton == 2 ? true : false,
                                  message: (
                                    <IntlMessages id="products.main.add.entercustomskumessage" />
                                  ),
                                },
                              ]}
                              onFocus={handleFocus}
                              onBlur={(event) =>
                                handleChangeSKUCodeValue(event, 0, 2)
                              }
                              help={
                                getSKUTypeOptionsRows[0].IsUnique
                                  ? ""
                                  : "This SKU code already exists. Please enter a different one."
                              }
                              validateStatus={
                                getSKUTypeOptionsRows[0].IsUnique ? "" : "error"
                              }
                            >
                              <Input
                                placeholder="Enter SKU" className="w-100"/>
                            </Form.Item>
                          </Form>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {!isAddMode && productInventoryType == 2 ? (
                      <>
                        <Form
                          initialValues={{
                            ["CustomSKU"]: getSKUTypeOptionsRows[0].SKUValue,
                          }}
                          name="ProductForm"
                        >
                          <Form.Item
                            className={`ant-form-item-label-custom ant-form-margin-right custom-sku-input-margin`}
                            name="CustomSKU"
                            label=""
                            rules={[
                              {
                                required: InvSKURadioButton == 2 ? true : false,
                                message: (
                                  <IntlMessages id="products.main.add.entercustomskumessage" />
                                ),
                              },
                            ]}
                            onFocus={handleFocus}
                            onBlur={(event) =>
                              handleChangeSKUCodeValue(event, 0, 2)
                            }
                            help={
                              getSKUTypeOptionsRows[0].IsUnique
                                ? ""
                                : "This SKU code already exists. Please enter a different one."
                            }
                            validateStatus={
                              getSKUTypeOptionsRows[0].IsUnique ? "" : "error"
                            }
                          >
                            <Input
                              placeholder="Enter SKU"
                              style={{ width: "43%" }}
                            />
                          </Form.Item>
                        </Form>
                      </>
                    ) : (
                      ""
                    )}
                    {productInventoryType == 0 ? (
                      <>
                        <Divider className="mt-3 mb-4" />
                        <div>
                        <h2 class="custom-font-weight-500 custom-font-color-black mb-4">
                            <IntlMessages id="products.main.add.skucodes" />
                          </h2>
                          <SKUCodeTypeandValues />
                          {/* <div class="parent-variant-div">

                          </div> */}
                        </div>

                        <Divider className="mt-3 mb-4" />
                        <div>
                        <h2 class="custom-font-weight-500 custom-font-color-black mb-4">
                            <IntlMessages id="products.main.add.batchdetails" />
                          </h2>
                          <ProductBatchDetails />
                          {/* <div class="parent-variant-div">

                          </div> */}
                        </div>

                        <Divider className="mt-3 mb-4" />
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="Product-with-Variants">
                    <div
                      className={
                        productInventoryType != 2
                          ? "custom-div-show "
                          : "custom-div-hide"
                      }
                    >
                      <InputGroup
                        size="large"
                        className="gx-mb-3 Supplier-div">
                        <Col lg={8} md={8} sm={24} xs={24} className="pl-0-device">
                          <Form.Item
                            className="ant-form-item-label-custom ant-form-margin-right form-inner-pad-0"
                            name="SupplierID"
                            label={
                              <IntlMessages id="products.main.add.supplier" />
                            }
                          >
                            <Select
                              placeholder={
                                <IntlMessages id="products.main.add.choosesupplier" />
                              }
                              showSearch
                              optionFilterProp="children"
                            >
                              {supplierOptions &&
                                supplierOptions.map((e, key) => {
                                  return (
                                    <option key={key} value={e.id}>
                                      {e.label}
                                    </option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col lg={8} md={8} sm={24} xs={24} className="md-pad-0">
                          <Form.Item
                            className="ant-form-item-label-custom ant-form-margin-right form-inner-pad-0"
                            name="SupplierCode"
                            label={
                              <IntlMessages id="products.main.add.suppliercode" />
                            }
                            rules={[
                              {
                                message: (
                                  <IntlMessages id="products.main.add.entersuppliercode" />
                                ),
                              },
                            ]}
                          >
                            <Input placeholder="Enter supplier code " />
                          </Form.Item>
                        </Col>
                        <Col lg={8} md={8} sm={24} xs={24} className="pr-0-device">
                          <Form.Item
                            className="ant-form-item-label-custom ant-form-margin-right form-inner-pad-0"
                            name="SupplyPrice"
                            label={
                              <IntlMessages id="products.main.add.supplyprice" />
                            }
                          >
                            <InputNumber className="w-100"
                            type="number"
                              onFocus={handleFocus}
                              onBlur={(event) => {
                                handlePricesCalculator(event, "SupplyPrice");
                              }}
                              placeholder={
                                getCurrData.currencyCode != null
                                  ? getCurrData.currencyCode
                                  : getCurrData.currencyName != null
                                  ? getCurrData.currencyName
                                  : getCurrData.currencySymbol
                              }
                              value={0.0}
                              precision={2}
                              min={0}
                            />
                          </Form.Item>
                        </Col>
                      </InputGroup>

                      <div className="TrackInventory">
                        <Form.Item noStyle>
                          <Form.Item
                            name="IsProductInventory"
                            valuePropName="checked"
                            className="form-inner-pad-0"
                          >
                            <Checkbox
                              style={{ fontSize: "15px" }}
                              checked={getIsProductInventory}
                              onChange={(e) => {
                                onChangeProductInventor(e);
                              }}
                            >
                              <IntlMessages id="products.main.add.trackinventoryproduct" />
                            </Checkbox>
                            <p className="font-size-smaller">
                              <IntlMessages id="products.main.add.trackinventoryproductdescription" />
                            </p>
                          </Form.Item>
                        </Form.Item>
                      </div>
                    </div>

                    <div
                      className={
                        getIsProductInventory && productInventoryType == 0
                          ? "custom-div-show "
                          : "custom-div-hide"
                      }
                    >
                      <Table
                        className="gx-table-responsive custom-product-table"
                        columns={columnsInventory}
                        dataSource={tableDataStoreOutlets}
                        pagination={false}
                      />
                    </div>
                  </div>
                  <Divider className="mt-3 mb-4" />
                </Form>
              </Col>
            </Row>

            <Divider className="mt-3 mb-4" />

            <Row>
              <Col lg={6} md={24} sm={24} xs={24}
                className={
                  productInventoryType == 2
                    ? "custom-div-show "
                    : "custom-div-hide"
                }
              >
               <h2 class="custom-font-weight-500 custom-font-color-black">
                  <IntlMessages id="products.main.add.products" />
                </h2>
                <p className="dk-font-size-15">
                  <IntlMessages id="products.main.add.productsdescription" />
                </p>
              </Col>
              <Col lg={18} md={24} sm={24} xs={24}
                className={
                  productInventoryType == 2
                    ? "custom-div-show "
                    : "custom-div-hide"
                }
              >
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: "86",
                  }}
                  className="custom-mg-top-26"
                  scrollToFirstError
                  id="ProductForm"
                  name="ProductForm"
                >
                  <div className="new-pro-ProductSearch">
                   
                    <ProductSearch isLabel={true} />
                    {getTableCompositeProductData.length > 0 || true ? (
                      <>
                        <Table
                          className="gx-table-responsive custom-product-table"
                          pagination={false}
                          columns={columnsCompositeProduct}
                          dataSource={getTableCompositeProductData}
                        />
                        <Row
                          justify="end"
                          className="custom-mg-top-10 custom-text-center"
                        >
                          <Col md={6}>
                            {" "}
                            <h2>
                              <IntlMessages id="products.main.add.total" />
                            </h2>
                          </Col>
                          <Col md={6}>
                            <h3>{getCPTotalQuantity}</h3>
                          </Col>
                          <Col md={8}>
                            <h3>{getCPTotalSupplyPrice}</h3>
                          </Col>
                          <Col md={4}></Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Form>
              </Col>
            </Row>

            <Divider
              className={
                productInventoryType == 2
                  ? "custom-div-show "
                  : "custom-div-hide"
              }
            />

            <Row className="tax-div">
              <Col xl={6} lg={24} md={24} sm={24} xs={24}>
              <h2 class="custom-font-weight-500 custom-font-color-black">
                  <IntlMessages id="products.main.add.tax" />
                </h2>
              </Col>
              <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                {getIsTaxExclusive ? (
                  <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                      prefix: "86",
                    }}
                    scrollToFirstError
                    id="ProductForm"
                    name="ProductForm"
                  >
                    <div className="Price-Loyalty">
                      <Table
                        className="gx-table-responsive custom-product-table"
                        columns={columnsTax}
                        dataSource={tableDataStoreOutlets}
                        pagination={false}
                      />
                    </div>
                  </Form>
                ) : (
                  <Form
                    form={form}
                    onFinish={onFinish}
                    id="ProductForm"
                    name="ProductForm"
                  >
                    <Form.Item
                      className="ant-form-item-label-custom ant-form-margin-right"
                      name={`TaxID`}
                    >
                      <Select
                        onChange={(event) => {
                          onChangeMainTax(event);
                        }}
                      >
                        {saleTaxOptions &&
                          saleTaxOptions.map((e, key) => {
                            return <option value={e.id}>{e.label}</option>;
                          })}
                      </Select>
                    </Form.Item>
                  </Form>
                )}
              </Col>
            </Row>

            <Divider className="mt-3 mb-4" />

            <Row className="Price&Loyalty-div">
            <Col xl={6} lg={24} md={24} sm={24} xs={24}>
              <h2 class="custom-font-weight-500 custom-font-color-black">
                  <IntlMessages id="products.main.add.priceandloyalty" />
                </h2>
              </Col>
              <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: "86",
                  }}
                  className="custom-mg-top-36"
                  scrollToFirstError
                  id="ProductForm"
                  name="ProductForm"
                >
                  <div className="Price-Loyalty">
                    <Row>
                      <Col lg={24} md={24} sm={24} xs={24} className="mb-3 p-0">
                        <label>
                          
                            <IntlMessages id="products.main.add.supplyprice" />{" "}
                            (
                            {getCurrData.currencyCode != null
                              ? getCurrData.currencyCode
                              : getCurrData.currencyName != null
                              ? getCurrData.currencyName
                              : getCurrData.currencySymbol}
                            )
                         
                        </label>

                        <Form.Item
                          className="ant-form-item-label-custom ant-form-margin-right dk-mg-bt-6 w-100 form-inner-pad-0 inner-input-100"
                          name="SupplyPriceTotal"
                          label=""
                        >
                          <InputNumber
                          type="number"
                            placeholder=""
                            value={0.0}
                            disabled={true}
                            precision={2}
                            min={0}
                          />
                        </Form.Item>

                        
                      </Col>

                      <Col lg={24} md={24} sm={24} xs={24} className="mb-3 p-0">
                        
                      <label>
                            <IntlMessages id="products.main.add.markup" />
                            </label>
                        <Form.Item
                          className="ant-form-item-label-custom ant-form-margin-right w-100 form-inner-pad-0 inner-input-100"
                          name="Markup"
                          label=""
                        >
                          <InputNumber
                          type="number"
                            onFocus={handleFocus}
                            onBlur={(event) => {
                              handlePricesCalculator(event, "MarkUp");
                            }}
                            placeholder={"%"}
                            value={0.0}
                            precision={2}
                            min={0}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    {!getIsTaxExclusive ? (
                      <Row>
                        <Col lg={24} md={24} sm={24} xs={24} className="p-0">
                        <label>
                              <IntlMessages id="products.main.add.tax" /> ({getDisplayPriceWithName.taxName})
                              </label>
                          
                         
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24} className="p-0">
                          {parseFloat(getDisplayPriceWithName.taxPrice).toFixed(
                            getDefaultDecimalPlaces
                          )}
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    <Divider className="mt-3 mb-4" />

                    <Row>
                    <Col lg={24} md={24} sm={24} xs={24} className="p-0">
                          <label className="mb-0">
                           
                              <IntlMessages id="products.main.add.retailprice" />
                           
                          </label>
                          <span> </span>
                          <p className="font-size-smaller">
                            {getIsTaxExclusive ? (
                              <IntlMessages id="products.main.add.excludingtax" />
                            ) : (
                              <IntlMessages id="products.main.add.includingtax" />
                            )}
                          </p>

                          <Form.Item
                          className="ant-form-item-label-custom ant-form-margin-right w-100 form-inner-pad-0 inner-input-100"
                          name="RetailPrice"
                          label=""
                        >
                          <InputNumber
                          type="number"
                            onFocus={handleFocus}
                            onBlur={(event) => {
                              handlePricesCalculator(event, "RetailPrice");
                            }}
                            placeholder={
                              getCurrData.currencyCode != null
                                ? getCurrData.currencyCode
                                : getCurrData.currencyName != null
                                ? getCurrData.currencyName
                                : getCurrData.currencySymbol
                            }
                            value={0.0}
                            precision={2}
                            min={0}
                          />
                        </Form.Item>
                      </Col>

                    
                    </Row>
                    {getIsLoyaltyEnabled ? (
                      <Row>
                        <div
                          style={{
                            marginLeft: "15px",
                            marginRight: "18px",
                            marginBottom: "15px",
                          }}
                        >
                          <Radio.Group
                            style={{ display: "inline-grid" }}
                            size="large"
                            name="radiogroupLoyalty"
                            onChange={OnChangeLoyaltyRadioButton}
                            value={PLoyaltyRadioButton}
                          >
                            <Radio value={1}>
                              <IntlMessages id="products.main.add.earndefaultloyalty" />
                              <div
                                style={{
                                  marginLeft: "24px",
                                  fontSize: "12px",
                                  marginBottom: "auto",
                                  wordBreak: "break-all",
                                }}
                              >
                               

                                <p>
                                  {`This customer will earn ${getLoyaltyPoints.toFixed(
                                    getDefaultDecimalPlaces
                                  )} loyalty points on the default retail price. These loyalty points are based on the default loyalty ratio of
                                  ${
                                    getCurrData.currencyCode != null
                                      ? getCurrData.currencyCode
                                      : getCurrData.currencyName != null
                                      ? getCurrData.currencyName
                                      : getCurrData.currencySymbol
                                  }   ${
                                    getLoyaltyAmountValue != undefined
                                      ? 1 /
                                        parseFloat(
                                          getLoyaltyAmountValue
                                        ).toFixed(getDefaultDecimalPlaces)
                                      : "0"
                                  } for each point.`}
                                </p>
                              </div>
                            </Radio>

                            <Tooltip
                              placement="leftTop"
                              title={
                                <IntlMessages id="common.resource.comingsoon" />
                              }
                            >
                              <Radio value={2} disabled={true}>
                                <IntlMessages id="products.main.add.earncustomloyalty" />
                              </Radio>
                            </Tooltip>

                            <Form.Item
                              className={`ant-form-item-label-custom ant-form-margin-right custom-sku-input-margin ${
                                PLoyaltyRadioButton == 2
                                  ? "custom-div-show"
                                  : "custom-div-hide"
                              }`}
                              name="CustomLoyalty"
                            >
                              <InputNumber
                              type="number"
                                onFocus={handleFocus}
                                placeholder={
                                  getCurrData.currencyCode != null
                                    ? getCurrData.currencyCode
                                    : getCurrData.currencyName != null
                                    ? getCurrData.currencyName
                                    : getCurrData.currencySymbol
                                }
                                value={0.0}
                                precision={2}
                                style={{ width: "80%" }}
                                min={0}
                              />
                            </Form.Item>
                          </Radio.Group>
                        </div>
                      </Row>
                    ) : (
                      ""
                    )}
                  </div>
                </Form>
              </Col>
            </Row>

            <Divider className="mt-3 mb-4" />

            <Row>
            <Col xl={6} lg={24} md={24} sm={24} xs={24} className={
                  productInventoryType == 1
                    ? "custom-div-show "
                    : "custom-div-hide"
                }
              >
                <h2 className="custom-font-weight-500 custom-font-color-black">
                  <IntlMessages id="products.main.add.variants" />
                </h2>
                <p className="dk-font-size-15">
                  <IntlMessages id="products.main.add.variantsdescription" />
                </p>
              </Col>
              <Col xl={18} lg={24} md={24} sm={24} xs={24} className={
                  productInventoryType == 1
                    ? "custom-div-show "
                    : "custom-div-hide"
                }
              >
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: "86",
                  }}
                  className="custom-mg-top-26"
                  scrollToFirstError
                  id="ProductForm"
                  name="ProductForm"
                >
                  
                    <Row
                      className={
                        productInventoryType == 1
                          ? "custom-div-show "
                          : "custom-div-hide"
                      }
                    >
                     
                        
                          <Row className="md-display-none">
                          <Col lg={8} md={8} sm={24} xs={24}>
                              <label>
                                <IntlMessages id="products.main.add.attributeoptionlabel" />
                                </label>
                            </Col>

                            <Col lg={13} md={18} sm={20} xs={16}>
                              <label>
                                <IntlMessages id="products.main.add.attributevaluelabel" />
                                </label>
                            </Col>
                          </Row>

                          <div class="parent-variant-div">
                            {attributeOptionsRows.map((obj) => {
                              return <AttributeOptionandValues id={obj.Key} />;
                            })}
                          </div>

                          <Row>
                            <Col lg={8} md={8} sm={24} xs={24} className="md-pad-0">
                              {attributeOptionsRows.length <= 2 ? (
                                <Title
                                  level={5}
                                  className="custom-font-color-primary custom-hand-active"
                                  onClick={(event) =>
                                    AddDeleteVariantAttributeOption(
                                      event,
                                      false,
                                      0
                                    )
                                  }
                                >
                                  <i className="icon icon-add-circle" />{" "}
                                  <IntlMessages id="products.main.add.addanotherattribute" />
                                </Title>
                              ) : (
                                ""
                              )}
                            </Col>

                            <Col lg={13} md={18} sm={20} xs={24} className="md-pad-0">
                              {
                                // <Title
                                //   level={5}
                                //   className="custom-font-color-secondary"
                                // >
                                //   <i className="icon icon-edit" />{" "}
                                //   <IntlMessages id="products.main.add.editvaluename" />
                                // </Title>
                              }
                            </Col>
                          </Row>
                        
                          <div className="mt-3">
                        <p>
                          <IntlMessages id="products.main.add.thisproducthas" />{" "}
                          {TableProductVariantdata.length}{" "}
                          <IntlMessages id="products.main.add.variants" />
                        </p>
                        {RemoveVariantCombinations.length > 0 ? (
                          <p
                            className="custom-hand-active"
                            onClick={RestoreVariantProduct}
                          >
                            {RemoveVariantCombinations.length}{" "}
                            <IntlMessages id="products.main.add.othershavebeenremoved" />{" "}
                          </p>
                        ) : (
                          ""
                        )}
                        
                          <Table
                            columns={columnsProductVariant}
                            expandable={{
                              expandedRowRender: (
                                record,
                                index,
                                indent,
                                expaned
                              ) => (
                                <Tabs defaultActiveKey="1">
                                  <TabPane
                                    tab={
                                      <IntlMessages id="products.main.add.inventory" />
                                    }
                                    key="1"
                                  >
                                    <ExpandedRowRenderSKU
                                      record={record}
                                      index={index}
                                    />
                                    <Divider />

                                    <ExpandedRowRenderBatches
                                      record={record}
                                      index={index}
                                    />

                                    <Divider />
                                    <ExpandedRowRenderInventory
                                      record={record}
                                      obj={index}
                                      isTrackInventory={getIsProductInventory}
                                    />
                                  </TabPane>
                                  <TabPane
                                    tab={
                                      <IntlMessages id="products.main.add.tax" />
                                    }
                                    key="2"
                                  >
                                    <ExpandedRowRenderTax
                                      record={record}
                                      obj={index}
                                    />
                                  </TabPane>
                                  <TabPane
                                    tab={
                                      <IntlMessages id="products.main.add.priceandloyalty" />
                                    }
                                    key="3"
                                  >
                                    <ExpandedRowRenderPrices record={record} />
                                  </TabPane>
                                  <TabPane
                                    tab={
                                      <IntlMessages id="products.main.add.Image" />
                                    }
                                    key="4"
                                  >
                                    <ExpandedRowRenderImages
                                      record={record}
                                      obj={index}
                                    />
                                  </TabPane>
                                </Tabs>
                              ),
                              rowExpandable: (record) =>
                                record.VariantName !== "Not Expandable",
                              //  expandRowByClick: true,
                            }}
                            dataSource={TableProductVariantdata}
                            pagination={false}
                            className="gx-table-responsive custom-variant-product-table MinWidth-auto"
                          />
                        </div>
                     
                      <Divider
                        style={{ marginTop: "50px", marginBottom: "50px" }}
                      />
                    </Row>
                  
                </Form>
              </Col>
            </Row>
          </div>
        </Spin>
      </>
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default Products;
